import { get, cloneDeep } from 'lodash';
import { Component, Renderer2, Input, ViewChild, Injectable, ɵɵdefineInjectable, ɵɵinject, EventEmitter, Output, Pipe, NgModule, ViewEncapsulation, ElementRef, Directive, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalController, NavController, LoadingController, AlertController, ToastController, PopoverController, Platform, IonicModule } from '@ionic/angular';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import jazzicon from 'jazzicon';
import { BehaviorSubject, Subject, EMPTY, of, from, ReplaySubject, Subscription } from 'rxjs';
import { tap, mergeMap, take } from 'rxjs/operators';
import { __awaiter } from 'tslib';
import { MomentModule } from 'ngx-moment';
import { FormsModule, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import '@arianee/arianeejs/dist/src/models';
import { DomSanitizer } from '@angular/platform-browser';
import '@arianee/arianeejs/dist/src/core/wallet';
import '@arianee/arianeejs';
import { PhotoViewer } from '@ionic-native/photo-viewer/ngx';
import Hammer from 'hammerjs';
import { pickLanguageAccordingToUserLanguagesWithMacrosFallback } from '@arianee/iso-language-picker';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T
 */
class Mapper {
    /**
     * @param {...?} args
     * @return {?}
     */
    map(...args) {
        /** @type {?} */
        const res = this.mapperImplementation(...args);
        Object.keys(res).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            /** @type {?} */
            const value = res[key];
            if (value === undefined || value.length === 0) {
                res[key] = this.placeholder[key];
            }
        }));
        return res;
    }
}
if (false) {
    /** @type {?} */
    Mapper.prototype.mapperImplementation;
    /** @type {?} */
    Mapper.prototype.placeholder;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const isCertificateValid = (/**
 * @param {?} arianeeCertificate
 * @return {?}
 */
(arianeeCertificate) => arianeeCertificate.content.isAuthentic &&
    arianeeCertificate.issuer.isIdentityVerified &&
    arianeeCertificate.issuer.isIdentityAuthentic);
/** @type {?} */
const brandImageLogo = (/**
 * @param {?} identity
 * @param {?} picturesOrder
 * @return {?}
 */
(identity, picturesOrder) => {
    if (get(identity, 'data') === undefined || get(identity, 'data') === null) {
        return '';
    }
    const { pictures } = identity.data;
    /** @type {?} */
    const isPicture = (/**
     * @param {?} pictureName
     * @return {?}
     */
    (pictureName) => {
        /** @type {?} */
        const picture = pictures
            .find((/**
         * @param {?} pic
         * @return {?}
         */
        pic => pic.type === pictureName));
        return picture !== undefined;
    });
    /** @type {?} */
    const pictureUrl = (/**
     * @param {?} pictureName
     * @return {?}
     */
    (pictureName) => {
        return pictures
            .find((/**
         * @param {?} pic
         * @return {?}
         */
        pic => pic.type === pictureName)).url;
    });
    /** @type {?} */
    const findPicture = (/**
     * @param {?} picturesNames
     * @return {?}
     */
    (picturesNames) => {
        for (const pictureName of picturesNames) {
            if (isPicture(pictureName)) {
                return pictureUrl(pictureName);
            }
        }
        return '';
    });
    if (pictures) {
        return findPicture(picturesOrder);
    }
    return '';
});
/** @type {?} */
const brandIdentity = (/**
 * @param {?} identity
 * @return {?}
 */
(identity) => {
    return get(identity, 'address');
});
/** @type {?} */
const brandName = (/**
 * @param {?} identity
 * @return {?}
 */
(identity) => {
    return get(identity, 'data.name');
});
/** @type {?} */
const brandDescription = (/**
 * @param {?} identity
 * @return {?}
 */
(identity) => {
    return get(identity, 'data.description');
});
/** @type {?} */
const brandCompanyName = (/**
 * @param {?} identity
 * @return {?}
 */
(identity) => {
    return get(identity, 'data.companyName');
});
/** @type {?} */
const brandSocialmedia = (/**
 * @param {?} identity
 * @return {?}
 */
(identity) => {
    return get(identity, 'data.socialmedia');
});
/** @type {?} */
const brandExternalContent = (/**
 * @param {?} identity
 * @return {?}
 */
(identity) => {
    return get(identity, 'data.externalContents');
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BrandDisplay() { }
if (false) {
    /** @type {?} */
    BrandDisplay.prototype.imgurl;
    /** @type {?} */
    BrandDisplay.prototype.count;
    /** @type {?} */
    BrandDisplay.prototype.brandname;
    /** @type {?} */
    BrandDisplay.prototype.brandId;
    /** @type {?} */
    BrandDisplay.prototype.brandlogo;
    /** @type {?} */
    BrandDisplay.prototype.brandDescription;
    /** @type {?|undefined} */
    BrandDisplay.prototype.brandCompanyName;
    /** @type {?} */
    BrandDisplay.prototype.brandLogoHeaderReversed;
    /** @type {?} */
    BrandDisplay.prototype.brandBackgroundPicture;
    /** @type {?|undefined} */
    BrandDisplay.prototype.brandSocialmedia;
    /** @type {?|undefined} */
    BrandDisplay.prototype.brandExternalContent;
    /** @type {?} */
    BrandDisplay.prototype.squareLogo;
}
class ArianeeBrandDisplayMapper extends Mapper {
    constructor() {
        super(...arguments);
        this.placeholder = {
            imgurl: 'assets/imgs/default-images/Brand_Collection_Picture_V1.png',
            count: 0,
            brandname: 'brand_list.brand_missing_name',
            brandId: '0',
            brandDescription: 'brand_list.brand_mission_description',
            brandlogo: 'assets/imgs/default-images/Brand_Logo_Header_Black_V1.png',
            brandLogoHeaderReversed: 'assets/imgs/default-images/Brand_Logo_Header_White_V1.png',
            brandBackgroundPicture: 'assets/imgs/default-images/Brand_Background_Picture.jpg',
            brandSocialmedia: [],
            brandExternalContent: [],
            brandCompanyName: 'brand company name',
            squareLogo: 'assets/imgs/default-images/Brand_Logo_Square_V1.png'
        };
        this.mapperImplementation = (/**
         * @param {?} arianeeIdentity
         * @param {?=} count
         * @return {?}
         */
        (arianeeIdentity, count = 0) => {
            return {
                imgurl: brandImageLogo(arianeeIdentity, ['brandHomePicture']),
                count,
                brandlogo: brandImageLogo(arianeeIdentity, ['brandLogoHeader']),
                brandLogoHeaderReversed: brandImageLogo(arianeeIdentity, ['brandLogoHeaderReversed']),
                brandBackgroundPicture: brandImageLogo(arianeeIdentity, ['brandBackgroundPicture']),
                brandname: brandName(arianeeIdentity),
                brandId: brandIdentity(arianeeIdentity),
                brandDescription: brandDescription(arianeeIdentity),
                brandCompanyName: brandCompanyName(arianeeIdentity),
                brandSocialmedia: brandSocialmedia(arianeeIdentity),
                brandExternalContent: brandExternalContent(arianeeIdentity),
                squareLogo: brandImageLogo(arianeeIdentity, ['brandLogoSquare'])
            };
        });
    }
}
if (false) {
    /** @type {?} */
    ArianeeBrandDisplayMapper.prototype.placeholder;
    /** @type {?} */
    ArianeeBrandDisplayMapper.prototype.mapperImplementation;
}
/** @type {?} */
const brandDisplayMapper = (/**
 * @param {?} arianeeIdentity
 * @param {?=} count
 * @return {?}
 */
(arianeeIdentity, count = 0) => {
    return new ArianeeBrandDisplayMapper().map(arianeeIdentity, count);
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const certificateImageLogo = (/**
 * @param {?} certificate
 * @param {?} picturesOrder
 * @return {?}
 */
(certificate, picturesOrder) => {
    if (certificate && !certificate.content.data) {
        return '';
    }
    const { medias } = certificate.content.data;
    /** @type {?} */
    const isPicture = (/**
     * @param {?} pictureName
     * @return {?}
     */
    (pictureName) => {
        /** @type {?} */
        const picture = medias
            .find((/**
         * @param {?} pic
         * @return {?}
         */
        pic => pic.type === pictureName));
        return picture !== undefined;
    });
    /** @type {?} */
    const pictureUrl = (/**
     * @param {?} pictureName
     * @return {?}
     */
    (pictureName) => {
        return medias
            .find((/**
         * @param {?} pic
         * @return {?}
         */
        pic => pic.type === pictureName)).url;
    });
    /** @type {?} */
    const findPicture = (/**
     * @param {?} picturesNames
     * @return {?}
     */
    (picturesNames) => {
        for (const pictureName of picturesNames) {
            if (isPicture(pictureName)) {
                return pictureUrl(pictureName);
            }
        }
        return '';
    });
    if (medias) {
        return findPicture(picturesOrder);
    }
    return '';
});
/** @type {?} */
const serialNumber = (/**
 * @param {?} certificate
 * @param {?} serialnumberType
 * @return {?}
 */
(certificate, serialnumberType) => {
    if (certificate && !certificate.content.data) {
        return '';
    }
    const { serialnumber } = certificate.content.data;
    /** @type {?} */
    const isSN = (/**
     * @param {?} serialnumberType
     * @return {?}
     */
    (serialnumberType) => {
        /** @type {?} */
        const sn = serialnumber
            .find((/**
         * @param {?} sn
         * @return {?}
         */
        sn => sn.type === serialnumberType));
        return sn !== undefined;
    });
    /** @type {?} */
    const snValue = (/**
     * @param {?} serialnumberType
     * @return {?}
     */
    (serialnumberType) => {
        return serialnumber
            .find((/**
         * @param {?} sn
         * @return {?}
         */
        sn => sn.type === serialnumberType)).value;
    });
    /** @type {?} */
    const findSN = (/**
     * @param {?} serialnumberType
     * @return {?}
     */
    (serialnumberType) => {
        for (const snType of serialnumberType) {
            if (isSN(snType)) {
                return snValue(snType);
            }
        }
        return '';
    });
    if (serialnumber) {
        return findSN(serialnumberType);
    }
    return '';
});
/** @type {?} */
const getAssetType = (/**
 * @param {?} category
 * @return {?}
 */
(category) => {
    if (category && category.toLowerCase() === 'Digital Asset'.toLowerCase()) {
        return "digitalAsset" /* digitalAsset */;
    }
    else {
        return "digitalTwin" /* digitalTwin */;
    }
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function CertificateDisplay() { }
if (false) {
    /** @type {?} */
    CertificateDisplay.prototype.brandLogoHeaderReversed;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.transparency;
    /** @type {?} */
    CertificateDisplay.prototype.pictures;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.medias;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.otherMedias;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.threeDimensionalMedias;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.arMedias;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.videoMedias;
    /** @type {?} */
    CertificateDisplay.prototype.name;
    /** @type {?} */
    CertificateDisplay.prototype.model;
    /** @type {?} */
    CertificateDisplay.prototype.brandName;
    /** @type {?} */
    CertificateDisplay.prototype.description;
    /** @type {?} */
    CertificateDisplay.prototype.serialNumber;
    /** @type {?} */
    CertificateDisplay.prototype.itemBackgroundPicture;
    /** @type {?} */
    CertificateDisplay.prototype.links;
    /** @type {?} */
    CertificateDisplay.prototype.isCertificateValid;
    /** @type {?} */
    CertificateDisplay.prototype.isRequestable;
    /** @type {?} */
    CertificateDisplay.prototype.brandLogoHeader;
    /** @type {?} */
    CertificateDisplay.prototype.certificateBackgroundPicture;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.scanned;
    /** @type {?} */
    CertificateDisplay.prototype.inError;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.isOwner;
    /** @type {?} */
    CertificateDisplay.prototype.customAttributes;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.pgeneve;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.swissmade;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.transparencyItems;
    /** @type {?|undefined} */
    CertificateDisplay.prototype.fallbackClaim;
    /** @type {?} */
    CertificateDisplay.prototype.assetType;
}
/** @type {?} */
const brandLogoHeaderReversedOrder = ['brandLogoHeaderReversed', 'brandLogoHeader'];
/** @type {?} */
const brandLogoHeaderOrder = ['brandLogoHeader'];
/** @type {?} */
const certificateBackgroundPictureOrder = ['certificateBackgroundPicture'];
/** @type {?} */
const commonPlaceHolder = {
    pictures: [],
    medias: [],
    transparency: false,
    name: 'missing_name',
    links: [],
    description: '',
    model: '',
    brandName: '',
    serialNumber: [{ type: 'regular', value: undefined }],
    brandLogoHeaderReversed: '/assets/imgs/default-images/Brand_Logo_Header_White_V1.png',
    isCertificateValid: false,
    isRequestable: false,
    itemBackgroundPicture: 'assets/imgs/default-images/Item_Background_Picture_V1.png',
    brandLogoHeader: '',
    certificateBackgroundPicture: 'assets/imgs/default-images/Certificate_Background_Picture.jpg',
    inError: true,
    isOwner: false,
    customAttributes: [],
    pgeneve: '',
    swissmade: '',
    assetType: "digitalTwin" /* digitalTwin */
};
class ArianeeAssetCertificateDisplayMapper extends Mapper {
    constructor() {
        super(...arguments);
        this.placeholder = commonPlaceHolder;
        this.mapperImplementation = (/**
         * @param {?} arianeeCertificate
         * @return {?}
         */
        (arianeeCertificate) => {
            /** @type {?} */
            const data = (/** @type {?} */ (arianeeCertificate.content.data));
            /** @type {?} */
            const certificateData = (/** @type {?} */ (data));
            /** @type {?} */
            const picturesList = certificateData.pictures ? certificateData.pictures.map((/**
             * @param {?} pic
             * @return {?}
             */
            pic => pic.src)) : [];
            /** @type {?} */
            const pictures = [certificateData.picture, ...picturesList].filter((/**
             * @param {?} i
             * @return {?}
             */
            i => i !== undefined));
            /** @type {?} */
            const name = certificateData.name;
            /** @type {?} */
            const itemBackgroundPicture = brandImageLogo(arianeeCertificate.issuer.identity, ['itemBackgroundPicture']);
            /** @type {?} */
            const links = certificateData.externalContents;
            /** @type {?} */
            const assetType = getAssetType(get(arianeeCertificate, 'content.data.category'));
            return {
                pictures,
                name,
                links,
                itemBackgroundPicture,
                isOwner: get(arianeeCertificate, 'owner.isOwner'),
                description: get(certificateData, 'description'),
                serialNumber: get(certificateData, 'serialnumber'),
                model: get(arianeeCertificate, 'content.data.model'),
                brandName: get(arianeeCertificate, 'issuer.identity.data.name'),
                brandLogoHeaderReversed: brandImageLogo(arianeeCertificate.issuer.identity, brandLogoHeaderReversedOrder),
                isCertificateValid: isCertificateValid(arianeeCertificate),
                isRequestable: get(arianeeCertificate, 'isRequestable') && !get(arianeeCertificate, 'owner.isOwner', true),
                brandLogoHeader: brandImageLogo(arianeeCertificate.issuer.identity, brandLogoHeaderOrder),
                certificateBackgroundPicture: brandImageLogo(arianeeCertificate.issuer.identity, certificateBackgroundPictureOrder),
                inError: false,
                transparency: false,
                customAttributes: [],
                assetType
            };
        });
    }
}
if (false) {
    /** @type {?} */
    ArianeeAssetCertificateDisplayMapper.prototype.placeholder;
    /** @type {?} */
    ArianeeAssetCertificateDisplayMapper.prototype.mapperImplementation;
}
class ArianeI18nCertificateDisplayMapper extends Mapper {
    constructor() {
        super(...arguments);
        this.placeholder = commonPlaceHolder;
        this.mapperImplementation = (/**
         * @param {?} arianeeCertificate
         * @return {?}
         */
        (arianeeCertificate) => {
            /** @type {?} */
            const data = (/** @type {?} */ (arianeeCertificate.content.data));
            for (const key of Object.keys(data)) {
                if (!data[key])
                    delete data[key];
            }
            /** @type {?} */
            const certificateData = (/** @type {?} */ (data));
            /** @type {?} */
            const mediasCertificate = certificateData.medias || [];
            mediasCertificate.forEach((/**
             * @param {?} media
             * @param {?} index
             * @return {?}
             */
            (media, index) => {
                if (!media.type.toLowerCase().includes('asset') &&
                    media.type !== 'brandItemBackgroundPicture' &&
                    media.type !== 'certificateBackgroundPicture') {
                    media.order = index + 1;
                }
            }));
            /** @type {?} */
            const pictures = mediasCertificate
                .filter((/**
             * @param {?} media
             * @param {?} index
             * @return {?}
             */
            (media, index) => {
                if (media.mediaType === 'picture' && media.type === 'product') {
                    return {
                        url: media.url,
                        order: index + 1
                    };
                }
            }))
                .filter((/**
             * @param {?} i
             * @return {?}
             */
            i => i !== undefined));
            /** @type {?} */
            const medias = mediasCertificate
                .filter((/**
             * @param {?} media
             * @return {?}
             */
            media => !['picture', '3dModel', 'video'].includes(media.mediaType)))
                .map((/**
             * @param {?} media
             * @return {?}
             */
            media => media))
                .filter((/**
             * @param {?} i
             * @return {?}
             */
            i => i !== undefined));
            /** @type {?} */
            const otherMedias = mediasCertificate
                .filter((/**
             * @param {?} media
             * @return {?}
             */
            media => media.type !== 'product' && !['3dModel', 'video'].includes(media.mediaType)))
                .map((/**
             * @param {?} media
             * @return {?}
             */
            media => media))
                .filter((/**
             * @param {?} i
             * @return {?}
             */
            i => i !== undefined));
            /** @type {?} */
            const threeDimensionalMedias = mediasCertificate
                .filter((/**
             * @param {?} media
             * @return {?}
             */
            media => media.mediaType === '3dModel'))
                .map((/**
             * @param {?} _
             * @param {?} index
             * @param {?} array
             * @return {?}
             */
            (_, index, array) => index % 2 === 0 ? {
                preview: array[index],
                asset: array[index + 1]
            } : undefined))
                .filter((/**
             * @param {?} i
             * @return {?}
             */
            i => i !== undefined));
            /** @type {?} */
            const videoMedias = mediasCertificate
                .filter((/**
             * @param {?} media
             * @return {?}
             */
            media => media.mediaType === 'video'))
                .map((/**
             * @param {?} _
             * @param {?} index
             * @param {?} array
             * @return {?}
             */
            (_, index, array) => index % 2 === 0 ? {
                preview: array[index],
                video: array[index + 1]
            } : undefined))
                .filter((/**
             * @param {?} i
             * @return {?}
             */
            i => i !== undefined));
            /** @type {?} */
            const arMedias = mediasCertificate
                .filter((/**
             * @param {?} media
             * @return {?}
             */
            media => media.mediaType === 'AR'))
                .map((/**
             * @param {?} media
             * @param {?} index
             * @param {?} array
             * @return {?}
             */
            (media, index, array) => index % 2 === 0 ? {
                preview: media.type === 'ARPreview' ? array[index] : undefined,
                asset: array[index + 1]
            } : undefined))
                .filter((/**
             * @param {?} i
             * @return {?}
             */
            i => i !== undefined));
            /** @type {?} */
            const itemBackgroundPicture = certificateImageLogo(arianeeCertificate, ['itemBackgroundPicture']) || brandImageLogo(arianeeCertificate.issuer.identity, ['itemBackgroundPicture']);
            /** @type {?} */
            const pgeneve = serialNumber(arianeeCertificate, ['pgeneve']);
            /** @type {?} */
            const swissmade = serialNumber(arianeeCertificate, ['swissmade']);
            /** @type {?} */
            let links = [];
            /** @type {?} */
            let transparency = [];
            /** @type {?} */
            let fallbackClaim;
            if (certificateData.externalContents) {
                links = certificateData.externalContents
                    .filter((/**
                 * @param {?} externalContent
                 * @return {?}
                 */
                externalContent => !['transparency', 'fallbackClaim', 'authRedirectTo'].includes(externalContent.type)));
                transparency = certificateData.externalContents
                    .filter((/**
                 * @param {?} externalContent
                 * @return {?}
                 */
                externalContent => externalContent.type === 'transparency'))[0];
                fallbackClaim = certificateData.externalContents
                    .find((/**
                 * @param {?} externalContent
                 * @return {?}
                 */
                externalContent => externalContent.type === 'fallbackClaim'));
            }
            /** @type {?} */
            let transparencyItems = [];
            transparencyItems = certificateData.transparencyItems;
            return {
                pictures,
                links,
                transparency,
                transparencyItems,
                arMedias,
                itemBackgroundPicture,
                fallbackClaim,
                isOwner: get(arianeeCertificate, 'owner.isOwner'),
                medias,
                otherMedias,
                threeDimensionalMedias,
                videoMedias,
                name: get(arianeeCertificate, 'content.data.name'),
                model: get(arianeeCertificate, 'content.data.model'),
                description: certificateData.description,
                serialNumber: get(certificateData, 'serialnumber'),
                brandName: get(arianeeCertificate, 'issuer.identity.data.name'),
                brandLogoHeaderReversed: brandImageLogo(arianeeCertificate.issuer.identity, brandLogoHeaderReversedOrder),
                isCertificateValid: isCertificateValid(arianeeCertificate),
                isRequestable: get(arianeeCertificate, 'isRequestable') && !get(arianeeCertificate, 'owner.isOwner', true),
                brandLogoHeader: brandImageLogo(arianeeCertificate.issuer.identity, brandLogoHeaderOrder),
                certificateBackgroundPicture: certificateImageLogo(arianeeCertificate, certificateBackgroundPictureOrder) || brandImageLogo(arianeeCertificate.issuer.identity, certificateBackgroundPictureOrder),
                inError: false,
                customAttributes: get(arianeeCertificate, 'content.data.customAttributes'),
                pgeneve: pgeneve,
                swissmade: swissmade,
                assetType: "digitalAsset" /* digitalAsset */
            };
        });
    }
}
if (false) {
    /** @type {?} */
    ArianeI18nCertificateDisplayMapper.prototype.placeholder;
    /** @type {?} */
    ArianeI18nCertificateDisplayMapper.prototype.mapperImplementation;
}
/** @type {?} */
const certificateDisplayMapper = (/**
 * @param {?=} arianeeCertificate
 * @return {?}
 */
(arianeeCertificate) => {
    if (!get(arianeeCertificate, 'content.data.$schema')) {
        return commonPlaceHolder;
    }
    /** @type {?} */
    const regexi18n = /https:\/\/cert\.arianee\.org\/version\d\/(ArianeeProductCertificate-i18n\.json)/;
    if (arianeeCertificate.content.data.$schema.match(regexi18n)) {
        return new ArianeI18nCertificateDisplayMapper().map(arianeeCertificate);
    }
    else if (arianeeCertificate.content.data.$schema === 'https://cert.arianee.org/version1/ArianeeAsset.json') {
        return new ArianeeAssetCertificateDisplayMapper().map(arianeeCertificate);
    }
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BackCertComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} navCtrl
     */
    constructor(modalCtrl, navCtrl) {
        this.modalCtrl = modalCtrl;
        this.navCtrl = navCtrl;
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    onClickBackMyCert() {
        this.modalCtrl.dismiss();
        this.navCtrl.navigateForward('tab/brand-list');
    }
}
BackCertComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-back-cert',
                template: "<div class=\"inner-content\" data-e2e=\"back-cert-component\">\n  <p class=\"cert-mdl-header\">\n    {{'Backup.correct' | translate}}\n  </p>\n\n  <p class=\"mdl-text\">\n    {{'Backup.correctList' | translate}}\n  </p>\n\n  <div class=\"mdl-image\">\n    <img src=\"{{'/assets/imgs/img_backup_cert.png' | imageSrc}}\" />\n  </div>\n\n  <div class=\"cert-mdl-btn\">\n    <ion-button color=\"pink\" expand=\"full\" (click)=\"onClickBackMyCert()\" data-e2e=\"back-to-brand-list\">\n      {{'Backup.backToMyCert' | translate}}\n    </ion-button>\n  </div>\n</div>\n",
                styles: [".cert-mdl-header{color:#2cb32a;font-family:Inter-Bold;text-align:center;font-size:1.4em}.cert-mdl-btn{width:100%;margin-top:3vh}"]
            }] }
];
/** @nocollapse */
BackCertComponent.ctorParameters = () => [
    { type: ModalController },
    { type: NavController }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    BackCertComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    BackCertComponent.prototype.navCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BackConfirmComponent {
    /**
     * @param {?} modalCtrl
     */
    constructor(modalCtrl) {
        this.modalCtrl = modalCtrl;
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    onClickConfirmImport() {
        this.modalCtrl.dismiss('confirm');
    }
}
BackConfirmComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-back-confirm',
                template: "<div class=\"inner-content\" data-e2e=\"backup_import_confirm\">\n  <p class=\"mdl-header\">\n    {{'Backup.confirmImportHeader' | translate}}\n  </p>\n\n  <p class=\"mdl-text\">\n    {{'Backup.confirmLost' | translate}}\n  </p>\n\n  <div class=\"confirm-input\">\n    <ion-button color=\"pink\" expand=\"full\" (click)=\"onClickConfirmImport()\" data-e2e=\"restore_wallet_confirm\">\n      {{'Backup.confirmImport' | translate}}\n    </ion-button>\n  </div>\n</div>\n",
                styles: [".confirm-input{width:100%;margin-top:3vh}app-back-confirm{border-radius:22px}"]
            }] }
];
/** @nocollapse */
BackConfirmComponent.ctorParameters = () => [
    { type: ModalController }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    BackConfirmComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// example <angular-jazzicon seed="'zefozenfioeznfze'" ></angular-jazzicon>
class JazziconComponent {
    /**
     * @param {?} renderer
     */
    constructor(renderer) {
        this.renderer = renderer;
        this.size = 100;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        /** @type {?} */
        let seedInteger = this.seed;
        if (typeof this.seed === 'string') {
            seedInteger = JazziconComponent.jsNumberForAddress(this.seed);
        }
        /** @type {?} */
        const value = jazzicon(this.size, seedInteger);
        this.renderer.appendChild(this.jazziconElement.nativeElement, value);
    }
    /**
     * @private
     * @param {?} address
     * @return {?}
     */
    static jsNumberForAddress(address) {
        /** @type {?} */
        const addr = address.slice(2, 10);
        return parseInt(addr, 16);
    }
}
JazziconComponent.decorators = [
    { type: Component, args: [{
                selector: 'angular-jazzicon',
                template: '<div #jazziconElement></div>'
            }] }
];
/** @nocollapse */
JazziconComponent.ctorParameters = () => [
    { type: Renderer2 }
];
JazziconComponent.propDecorators = {
    seed: [{ type: Input, args: ['seed',] }],
    size: [{ type: Input, args: ['size',] }],
    jazziconElement: [{ type: ViewChild, args: ['jazziconElement', { static: true },] }]
};
if (false) {
    /** @type {?} */
    JazziconComponent.prototype.seed;
    /** @type {?} */
    JazziconComponent.prototype.size;
    /** @type {?} */
    JazziconComponent.prototype.jazziconElement;
    /**
     * @type {?}
     * @private
     */
    JazziconComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CommonService {
    constructor() {
        this.logScreen = (/**
         * @return {?}
         */
        () => {
        });
        this.logEvent = (/**
         * @return {?}
         */
        () => {
        });
        this.openBrowser = (/**
         * @return {?}
         */
        () => { });
    }
}
CommonService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ CommonService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CommonService_Factory() { return new CommonService(); }, token: CommonService, providedIn: "root" });
if (false) {
    /** @type {?} */
    CommonService.prototype.logScreen;
    /** @type {?} */
    CommonService.prototype.logEvent;
    /** @type {?} */
    CommonService.prototype.openBrowser;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LoaderService {
    /**
     * @param {?} commonService
     */
    constructor(commonService) {
        this.commonService = commonService;
        this._loader$ = new BehaviorSubject(false);
        this.loader$ = this._loader$.asObservable();
        this._fromBlockchain$ = new BehaviorSubject(false);
        this.fromBlockchain$ = this._fromBlockchain$.asObservable();
    }
    /**
     * @private
     * @return {?}
     */
    get isShown() {
        return this._loader$.getValue();
    }
    /**
     * @return {?}
     */
    showLoaderWithBlockchain() {
        this.commonService.logEvent('blockchainLoader', {});
        this._fromBlockchain$.next(true);
        this.showLoader();
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    showLoader(params) {
        if (params) {
            if (params.label) {
                this.loaderLabel = params.label;
            }
            if (params.title) {
                this.loaderTitle = params.title;
            }
        }
        if (!this.isShown) {
            this._loader$.next(true);
        }
    }
    /**
     * @param {?=} label
     * @return {?}
     */
    dismiss(label) {
        if (label) {
            this.loaderLabel = undefined;
        }
        if (this.loaderLabel === undefined) {
            this._fromBlockchain$.next(false);
            this._loader$.next(false);
        }
    }
}
LoaderService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
LoaderService.ctorParameters = () => [
    { type: CommonService }
];
/** @nocollapse */ LoaderService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LoaderService_Factory() { return new LoaderService(ɵɵinject(CommonService)); }, token: LoaderService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    LoaderService.prototype._loader$;
    /** @type {?} */
    LoaderService.prototype.loader$;
    /**
     * @type {?}
     * @private
     */
    LoaderService.prototype._fromBlockchain$;
    /** @type {?} */
    LoaderService.prototype.fromBlockchain$;
    /** @type {?} */
    LoaderService.prototype.loaderLabel;
    /** @type {?} */
    LoaderService.prototype.loaderTitle;
    /**
     * @type {?}
     * @private
     */
    LoaderService.prototype.commonService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToasterService {
    /**
     * @param {?} translateService
     * @param {?} commonService
     */
    constructor(translateService, commonService) {
        this.translateService = translateService;
        this.commonService = commonService;
        this._toaster$ = new Subject();
        this.toaster$ = this._toaster$.asObservable();
        this._alert$ = new Subject();
        this.alert$ = this._alert$.asObservable();
    }
    /**
     * @param {?} alertOptions
     * @return {?}
     */
    alert(alertOptions) {
        this.commonService.logEvent('toasterAlert_' + alertOptions.message, {});
        alertOptions.message = this.translateService.instant((/** @type {?} */ (alertOptions.message)));
        if (alertOptions.header) {
            return this.translateService.instant(alertOptions.header);
        }
        this._alert$.next(alertOptions);
        return EMPTY;
    }
    /**
     * @param {?} toastOptions
     * @return {?}
     */
    show(toastOptions) {
        this.commonService.logEvent('toasterShow_' + toastOptions.message, {});
        this.translateService
            .get((/** @type {?} */ (toastOptions.message)))
            .pipe(tap((/**
         * @param {?} translatedMessage
         * @return {?}
         */
        (translatedMessage) => {
            toastOptions.message = translatedMessage;
            toastOptions.duration = toastOptions.duration === undefined ? 1000 : toastOptions.duration;
        })), mergeMap((/**
         * @return {?}
         */
        () => {
            if (toastOptions.header) {
                return this.translateService.get(toastOptions.header);
            }
            else {
                return of('');
            }
        })), tap((/**
         * @param {?} translatedHeader
         * @return {?}
         */
        (translatedHeader) => {
            if (toastOptions.header) {
                toastOptions.header = translatedHeader;
            }
            this._toaster$.next(toastOptions);
        })))
            .subscribe();
        return this.toaster$;
    }
    /**
     * @param {?} errorMessage
     * @return {?}
     */
    toastMessage(errorMessage) {
        this.show({
            message: errorMessage,
            color: 'danger',
            duration: 2500,
            position: 'top',
            animated: true
        });
    }
    /**
     * @param {?} toastParams
     * @return {?}
     */
    showRedesigned(toastParams) {
        return __awaiter(this, void 0, void 0, function* () {
            this.commonService.logEvent('toasterShow_' + toastParams.message, {});
            /** @type {?} */
            const options = {};
            /** @type {?} */
            const title = this.translateService.instant((/** @type {?} */ (toastParams.title)));
            options.message = `<div><b>${title}</b></div>`;
            if (toastParams.message) {
                /** @type {?} */
                const message = this.translateService.instant((/** @type {?} */ (toastParams.message)));
                options.message = `<div><b>${title}</b><div>${message}</div></div>`;
            }
            options.cssClass = [`toast-redesigned toast-${toastParams.color}`, toastParams.icon ? `toast-icon-base toast-icon-${toastParams.icon}` : null];
            if (toastParams.position) {
                options.position = toastParams.position;
            }
            if (toastParams.duration) {
                options.duration = toastParams.duration;
            }
            this._toaster$.next(options);
            return this.toaster$;
        });
    }
}
ToasterService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ToasterService.ctorParameters = () => [
    { type: TranslateService },
    { type: CommonService }
];
/** @nocollapse */ ToasterService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ToasterService_Factory() { return new ToasterService(ɵɵinject(TranslateService), ɵɵinject(CommonService)); }, token: ToasterService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ToasterService.prototype._toaster$;
    /** @type {?} */
    ToasterService.prototype.toaster$;
    /**
     * @type {?}
     * @private
     */
    ToasterService.prototype._alert$;
    /** @type {?} */
    ToasterService.prototype.alert$;
    /**
     * @type {?}
     * @private
     */
    ToasterService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    ToasterService.prototype.commonService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LoaderComponent {
    /**
     * @param {?} loaderService
     * @param {?} toasterService
     * @param {?} loadingCtrl
     * @param {?} alertCtrl
     * @param {?} toasterCtrl
     */
    constructor(loaderService, toasterService, loadingCtrl, alertCtrl, toasterCtrl) {
        this.loaderService = loaderService;
        this.toasterService = toasterService;
        this.loadingCtrl = loadingCtrl;
        this.alertCtrl = alertCtrl;
        this.toasterCtrl = toasterCtrl;
        this.showLoader = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.handleToaster();
        this.handleAlert();
        this.handleLoader();
    }
    /**
     * @return {?}
     */
    handleLoader() {
        this.loaderService.loader$
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            this.showLoader = data;
        }));
    }
    /**
     * @return {?}
     */
    handleAlert() {
        this.toasterService.alert$
            .pipe(mergeMap((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            return from(this.alertCtrl.create(Object.assign({}, data, { cssClass: 'e2e-alert' })));
        })))
            .subscribe((/**
         * @param {?} toaster
         * @return {?}
         */
        toaster => {
            toaster.present();
        }));
    }
    /**
     * @return {?}
     */
    handleToaster() {
        this.toasterService.toaster$
            .pipe(mergeMap((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            return from(this.toasterCtrl.create(Object.assign({}, data, { cssClass: [...(data.cssClass || []), 'e2e-toaster'] })));
        })))
            .subscribe((/**
         * @param {?} toaster
         * @return {?}
         */
        toaster => {
            toaster.shadowRoot
                .querySelector('.toast-content')
                .setAttribute('part', 'content');
            toaster.present();
        }));
    }
}
LoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-loader',
                template: "<lib-custom-theme-wrapper>\n  <div class=\"loader-container\" *ngIf=\"showLoader\" [attr.data-e2e]=\"showLoader?'loading':'not-loading'\">\n    <div class=\"content\">\n      <ion-spinner name=\"crescent\"></ion-spinner>\n      <p *ngIf=\"!!loaderService.loaderTitle\"> {{ loaderService.loaderTitle | translate }}</p>\n      <p *ngIf=\"loaderService.fromBlockchain$ | async\">{{ 'Loader.fromBlockchain' | translate }}</p>\n    </div>\n  </div>\n\n\n</lib-custom-theme-wrapper>\n",
                styles: ["div.loader-container{height:100%;width:100%;left:0;top:0;overflow:hidden;position:fixed;background:rgba(0,0,0,.5);display:flex;justify-content:center;align-items:center;flex-direction:column}div.loader-container div.content{background:rgba(14,15,17,.5);backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px);border-radius:8px;padding:16px;height:auto;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:8px}div.loader-container div.content ion-spinner{width:36px;min-width:36px;height:36px;min-height:36px;color:#fff}div.loader-container div.content p{font-weight:700;font-size:14px;margin:0;line-height:20px;color:#fff;text-align:center}"]
            }] }
];
/** @nocollapse */
LoaderComponent.ctorParameters = () => [
    { type: LoaderService },
    { type: ToasterService },
    { type: LoadingController },
    { type: AlertController },
    { type: ToastController }
];
if (false) {
    /** @type {?} */
    LoaderComponent.prototype.loader;
    /** @type {?} */
    LoaderComponent.prototype.showLoader;
    /** @type {?} */
    LoaderComponent.prototype.loaderService;
    /**
     * @type {?}
     * @private
     */
    LoaderComponent.prototype.toasterService;
    /**
     * @type {?}
     * @private
     */
    LoaderComponent.prototype.loadingCtrl;
    /**
     * @type {?}
     * @private
     */
    LoaderComponent.prototype.alertCtrl;
    /**
     * @type {?}
     * @private
     */
    LoaderComponent.prototype.toasterCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TitleIconComponent {
    /**
     * @param {?} translateService
     */
    constructor(translateService) {
        this.translateService = translateService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.text = yield this.translateService
                .get(this.text).toPromise();
        });
    }
}
TitleIconComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-title-icon',
                template: "<div class=\"titleIcon\">\n    <app-check-icon [isEnable]=isEnable></app-check-icon>\n    <p>{{text}}</p>\n</div>\n",
                styles: [".titleIcon{display:flex;flex-direction:row;align-items:center}.titleIcon app-check-icon{width:20px;height:20px;margin-right:10px}.titleIcon p{margin:0;font-weight:800}"]
            }] }
];
/** @nocollapse */
TitleIconComponent.ctorParameters = () => [
    { type: TranslateService }
];
TitleIconComponent.propDecorators = {
    text: [{ type: Input, args: ['text',] }],
    isEnable: [{ type: Input, args: ['isEnable',] }]
};
if (false) {
    /** @type {?} */
    TitleIconComponent.prototype.text;
    /** @type {?} */
    TitleIconComponent.prototype.isEnable;
    /**
     * @type {?}
     * @private
     */
    TitleIconComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BackupPopoverComponent {
    /**
     * @param {?} popoverController
     */
    constructor(popoverController) {
        this.popoverController = popoverController;
    }
    /**
     * @return {?}
     */
    dismissPopover() {
        this.popoverController.dismiss();
    }
}
BackupPopoverComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-backup-popover',
                template: "<div class=\"inner-content\" data-e2e=\"product_history\">\n    <h2>{{ backupType | translate}}</h2>\n    <app-check-icon [isEnable]=true></app-check-icon>\n    <p>{{\"Backup.backupSuccessfull\" | translate}}  </p>\n    <p>{{\"Backup.proceedManual\" | translate}}</p>\n    <ion-button color=\"primary\" (click)=\"dismissPopover()\">{{\"Backup.ok\" | translate}}</ion-button>\n</div>\n\n\n\n",
                styles: [".inner-content{border-radius:70px;text-align:center;padding:0 5% 5%}.inner-content h2{font-size:1.2em}.inner-content ion-button{width:80%;margin:auto}.inner-content app-check-icon{display:block;width:20vw;height:20vw;margin:20px auto}.inner-content p{margin:30px 0}"]
            }] }
];
/** @nocollapse */
BackupPopoverComponent.ctorParameters = () => [
    { type: PopoverController }
];
BackupPopoverComponent.propDecorators = {
    backupType: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    BackupPopoverComponent.prototype.backupType;
    /**
     * @type {?}
     * @private
     */
    BackupPopoverComponent.prototype.popoverController;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckIconComponent {
}
CheckIconComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-check-icon',
                template: "\n<div class=\"enable\" *ngIf=\"isEnable\"></div>\n<div class=\"notEnable\" *ngIf=\"!isEnable\">\n    <div></div>\n</div>\n\n\n\n",
                styles: [".enable,.notEnable{position:relative;min-width:20px;min-height:20px;width:100%;height:100%;margin-right:10px;border-radius:100px}.enable div::after,.enable div::before,.enable::before,.enable:after,.notEnable div::after,.notEnable div::before,.notEnable::before,.notEnable:after{position:absolute}.notEnable{background-color:red}.notEnable div{background-color:#fff;top:5%;left:5%;width:90%;height:90%;border-radius:100px;position:relative}.notEnable div::before{content:\"\";background-color:red;display:block;top:34%;left:22%;width:59%;height:10%;transform:rotate(90deg)}.notEnable div::after{content:\"\";background-color:red;display:block;top:76%;left:46%;width:10%;height:10%}.enable{background-color:#41cb70}.enable::before{content:\"\";width:37%;height:5%;top:54%;left:14%;background-color:#fff;transform:rotate(53deg)}.enable::after{content:\"\";width:53%;height:5%;top:50%;left:33%;background-color:#fff;transform:rotate(-45deg)}"]
            }] }
];
CheckIconComponent.propDecorators = {
    isEnable: [{ type: Input, args: ['isEnable',] }]
};
if (false) {
    /** @type {?} */
    CheckIconComponent.prototype.isEnable;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BackupItemComponent {
    constructor() {
        this.onBackUpSubmit = new EventEmitter();
    }
    /**
     * @return {?}
     */
    onSubmit() {
        this.onBackUpSubmit.emit();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
BackupItemComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-backup-item',
                template: "<ng-container *ngIf=\"lastCheck\">\n    <app-title-icon *ngIf=\"lastCheck\" [text]=\"titleLabel\"\n                    [isEnable]=lastCheck.isBackedUp></app-title-icon>\n    <p>{{warningLabel | translate}}</p>\n    <div *ngIf=\"lastCheck.date\" class=\"backupMessage\">\n        <div>\n            <app-check-icon [isEnable]=lastCheck.isBackedUp></app-check-icon>\n        </div>\n        <div>\n            <p>{{descriptionLabel | translate}} :</p>\n            <p *ngIf=\"lastCheck.email\">{{lastCheck.email}}</p>\n            <p>{{'Backup.lastCheck' | translate}}: {{lastCheck.date | date:'medium'}}</p>\n        </div>\n    </div>\n    <ion-button color=\"primary\"\n                data-e2e=\"backup_button\"\n                (click)=\"onSubmit()\">{{buttonLabel | translate}}</ion-button>\n</ng-container>\n",
                styles: [".backupChoice{margin:50px 0}ion-button{width:100%;margin-top:10px}.backupMessage{display:flex;flex-direction:row;font-size:.9em}.backupMessage>div:last-child{margin-left:20px}.backupMessage app-check-icon{display:block;margin-top:5px;width:70px;height:70px}.backupMessage p{margin:0}"]
            }] }
];
BackupItemComponent.propDecorators = {
    titleLabel: [{ type: Input, args: ['titleLabel',] }],
    buttonLabel: [{ type: Input, args: ['buttonLabel',] }],
    descriptionLabel: [{ type: Input, args: ['descriptionLabel',] }],
    warningLabel: [{ type: Input, args: ['warningLabel',] }],
    onBackUpSubmit: [{ type: Output, args: ['onBackUpSubmit',] }],
    lastCheck: [{ type: Input, args: ['lastCheck',] }]
};
if (false) {
    /** @type {?} */
    BackupItemComponent.prototype.titleLabel;
    /** @type {?} */
    BackupItemComponent.prototype.buttonLabel;
    /** @type {?} */
    BackupItemComponent.prototype.descriptionLabel;
    /** @type {?} */
    BackupItemComponent.prototype.warningLabel;
    /** @type {?} */
    BackupItemComponent.prototype.onBackUpSubmit;
    /** @type {?} */
    BackupItemComponent.prototype.lastCheck;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function EventDisplay() { }
if (false) {
    /** @type {?} */
    EventDisplay.prototype.title;
    /** @type {?} */
    EventDisplay.prototype.subtitle;
    /** @type {?} */
    EventDisplay.prototype.type;
    /** @type {?} */
    EventDisplay.prototype.date;
    /** @type {?|undefined} */
    EventDisplay.prototype.avatar;
    /** @type {?|undefined} */
    EventDisplay.prototype.pending;
    /** @type {?|undefined} */
    EventDisplay.prototype.detail;
    /** @type {?|undefined} */
    EventDisplay.prototype.description;
    /** @type {?} */
    EventDisplay.prototype.viewdetail;
    /** @type {?} */
    EventDisplay.prototype.id;
    /** @type {?|undefined} */
    EventDisplay.prototype.publicKey;
}
class EventDisplayMapper extends Mapper {
    constructor() {
        super(...arguments);
        this.mapperImplementation = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            /** @type {?} */
            const data = (/** @type {?} */ (get(event.content, 'data')));
            /** @type {?} */
            const eventData = (/** @type {?} */ (data));
            // todo: replace any by ArianeeEventContent
            /** @type {?} */
            const isBlockChainEvent = get(event, 'event') === 'Transfer';
            /** @type {?} */
            let identity;
            /** @type {?} */
            let id;
            if (isBlockChainEvent) {
                identity = (/** @type {?} */ (event.identity));
                id = event.id;
            }
            else {
                identity = (/** @type {?} */ (event.issuer.identity));
                id = event.arianeeEventId;
            }
            /** @type {?} */
            const title = isBlockChainEvent ? 'ownership_transfer' : get(eventData, 'title');
            /** @type {?} */
            const subtitle = get(eventData, 'description');
            return {
                id,
                title: title,
                subtitle: subtitle,
                type: get(eventData, 'eventType'),
                date: new Date(event.timestamp * 1000),
                avatar: brandImageLogo(identity, ['brandLogoSquare']),
                pending: event.pending,
                viewdetail: event.pending,
                publicKey: identity.address,
                detail: {
                    imgurl: get(eventData, 'medias[0].url'),
                    title: get(eventData, 'title'),
                    description: get(eventData, 'description')
                }
            };
        });
        this.placeholder = (/** @type {?} */ ({}));
    }
}
if (false) {
    /** @type {?} */
    EventDisplayMapper.prototype.mapperImplementation;
    /** @type {?} */
    EventDisplayMapper.prototype.placeholder;
}
/** @type {?} */
const eventDisplayMapper = (/**
 * @param {?} event
 * @return {?}
 */
(event) => {
    return new EventDisplayMapper().map(event);
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ProductListItem() { }
if (false) {
    /** @type {?} */
    ProductListItem.prototype.name;
    /** @type {?} */
    ProductListItem.prototype.description;
    /** @type {?} */
    ProductListItem.prototype.imgurl;
    /** @type {?} */
    ProductListItem.prototype.brandLogo;
    /** @type {?} */
    ProductListItem.prototype.scanned;
    /** @type {?} */
    ProductListItem.prototype.brandName;
    /** @type {?|undefined} */
    ProductListItem.prototype.cornerPicture;
    /** @type {?} */
    ProductListItem.prototype.certificateId;
}
/** @type {?} */
const placeholder = {
    name: 'item name is missing',
    description: 'description is missing',
    brandName: 'missing brand name',
    brandLogo: 'assets/imgs/default-images/Brand_Logo_Header_Black_V1.png',
    imgurl: 'assets/imgs/default-images/Brand_Item_Background_V1.png',
    certificateId: '0',
    scanned: false
};
class ArianeeAssetProductListDisplayMapper extends Mapper {
    constructor() {
        super(...arguments);
        this.mapperImplementation = (/**
         * @param {?} arianeeCertificate
         * @return {?}
         */
        (arianeeCertificate) => {
            return {
                name: get(arianeeCertificate, 'content.data.name'),
                brandName: brandName(arianeeCertificate.issuer.identity),
                description: get(arianeeCertificate, 'content.data.description'),
                imgurl: brandImageLogo(arianeeCertificate.issuer.identity, ['brandItemBackgroundPicture']),
                cornerPicture: arianeeCertificate.content.data.picture,
                brandLogo: brandImageLogo(arianeeCertificate.issuer.identity, ['brandLogoHeader']),
                certificateId: arianeeCertificate.certificateId,
                scanned: false
            };
        });
        this.placeholder = placeholder;
    }
}
if (false) {
    /** @type {?} */
    ArianeeAssetProductListDisplayMapper.prototype.mapperImplementation;
    /** @type {?} */
    ArianeeAssetProductListDisplayMapper.prototype.placeholder;
}
class ArianeeI18nProductListDisplayMapper extends Mapper {
    constructor() {
        super(...arguments);
        this.mapperImplementation = (/**
         * @param {?} arianeeCertificate
         * @return {?}
         */
        (arianeeCertificate) => {
            /** @type {?} */
            const medias = ((/** @type {?} */ (arianeeCertificate.content.data))).medias;
            /** @type {?} */
            let cornerPicture;
            /** @type {?} */
            let imgurl;
            if (medias) {
                /** @type {?} */
                const brandItemBackgroundPicture = medias
                    .find((/**
                 * @param {?} pic
                 * @return {?}
                 */
                pic => pic.type === 'brandItemBackgroundPicture'));
                if (!brandItemBackgroundPicture) {
                    /** @type {?} */
                    const threeDimensionalPreview = medias
                        .find((/**
                     * @param {?} pic
                     * @return {?}
                     */
                    pic => pic.type === '3dModelPreview'));
                    /** @type {?} */
                    const pic = medias
                        .find((/**
                     * @param {?} pic
                     * @return {?}
                     */
                    pic => pic.type === 'product' && pic.mediaType === 'picture'));
                    /** @type {?} */
                    const videoPreview = medias
                        .find((/**
                     * @param {?} pic
                     * @return {?}
                     */
                    pic => pic.type === 'videoPreview'));
                    cornerPicture = this.getFirstCornerPicture(medias, [threeDimensionalPreview, pic, videoPreview]);
                    imgurl = brandImageLogo(arianeeCertificate.issuer.identity, ['brandItemBackgroundPicture']);
                }
                else {
                    imgurl = brandItemBackgroundPicture.url;
                }
            }
            return {
                name: get(arianeeCertificate, 'content.data.name'),
                brandName: brandName(arianeeCertificate.issuer.identity),
                description: get(arianeeCertificate, 'content.data.description'),
                imgurl,
                cornerPicture,
                certificateId: arianeeCertificate.certificateId,
                brandLogo: brandImageLogo(arianeeCertificate.issuer.identity, ['brandLogoHeader']),
                scanned: false
            };
        });
        this.placeholder = placeholder;
    }
    /**
     * Returns the corner picture that is the closest to the 0 index
     * @private
     * @param {?} medias medias to compare index to
     * @param {?} cornerPictures array of medias
     * @return {?} the media whose index is closest to 0
     */
    getFirstCornerPicture(medias, cornerPictures) {
        // Priority is given to picture medias for corner picture
        /** @type {?} */
        const filteredMedias = medias.find((/**
         * @param {?} media
         * @return {?}
         */
        (media) => media.mediaType === 'picture'))
            ? medias.filter((/**
             * @param {?} media
             * @return {?}
             */
            (media) => media.mediaType === 'picture')) : medias;
        /** @type {?} */
        const finalCornerPicture = cornerPictures
            .reduce((/**
         * @param {?} previous
         * @param {?} cornerPicture
         * @return {?}
         */
        (previous, cornerPicture) => {
            /** @type {?} */
            const currentIndex = filteredMedias.indexOf(cornerPicture);
            return currentIndex <= previous.index && currentIndex >= 0 ? { index: currentIndex, cornerPicture } : previous;
        }), { index: Infinity, cornerPicture: null }).cornerPicture;
        return get(finalCornerPicture, 'url');
    }
}
if (false) {
    /** @type {?} */
    ArianeeI18nProductListDisplayMapper.prototype.mapperImplementation;
    /** @type {?} */
    ArianeeI18nProductListDisplayMapper.prototype.placeholder;
}
/** @type {?} */
const productListDisplayMapper = (/**
 * @param {?} arianeeCertificate
 * @return {?}
 */
(arianeeCertificate) => {
    if (!get(arianeeCertificate, 'content.data.$schema')) {
        return placeholder;
    }
    /** @type {?} */
    const regexi18n = /https:\/\/cert\.arianee\.org\/version\d\/(ArianeeProductCertificate-i18n\.json)/;
    if (arianeeCertificate.content.data.$schema.match(regexi18n)) {
        return new ArianeeI18nProductListDisplayMapper().map(arianeeCertificate);
    }
    else if (arianeeCertificate.content.data.$schema === 'https://cert.arianee.org/version1/ArianeeAsset.json') {
        return new ArianeeAssetProductListDisplayMapper().map(arianeeCertificate);
    }
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const getYoutubeMedia = (/**
 * @param {?} media
 * @return {?}
 */
(media) => {
    media.ytId = extractYoutubeId(media.url);
    media.thumbnail = getYoutubeThumbnail(media.ytId);
    media.embedURL = getYoutubeEmbedUrl(media.ytId);
    return media;
});
/** @type {?} */
const extractYoutubeId = (/**
 * @param {?} url
 * @return {?}
 */
(url) => {
    return url.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^/&?]{10,12})/)[1];
});
/** @type {?} */
const getYoutubeThumbnail = (/**
 * @param {?} ytId
 * @return {?}
 */
(ytId) => {
    return `https://img.youtube.com/vi/${ytId}/0.jpg`;
});
/** @type {?} */
const getYoutubeEmbedUrl = (/**
 * @param {?} ytId
 * @return {?}
 */
(ytId) => {
    return `https://www.youtube.com/embed/${ytId}`;
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} certificate
 * @return {?}
 */
function getMappedMediasFromCertificate(certificate) {
    /** @type {?} */
    let mediaList = [];
    if (certificate && certificate.content.data.medias) {
        /** @type {?} */
        let previewUrl = '';
        /** @type {?} */
        let ytMedia = null;
        mediaList = certificate.content.data.medias
            .filter((/**
         * @param {?} media
         * @return {?}
         */
        (media) => media.url))
            .filter((/**
         * @param {?} media
         * @return {?}
         */
        (media) => ![
            'itemBackgroundPicture',
            'certificateBackgroundPicture',
            'brandItemBackgroundPicture'
        ].includes(media.type)))
            .map((/**
         * @param {?} media
         * @param {?} index
         * @param {?} certificateMedias
         * @return {?}
         */
        (media, index, certificateMedias) => {
            switch (media.mediaType) {
                case 'youtube':
                    ytMedia = getYoutubeMedia(media);
                    return {
                        type: media.mediaType,
                        url: ytMedia.embedURL,
                        preview: ytMedia.thumbnail,
                        order: media.order
                    };
                case 'picture':
                    previewUrl = media.preview;
                    return media.type === 'product'
                        ? {
                            type: media.mediaType,
                            url: media.url,
                            preview: previewUrl,
                            order: media.order
                        }
                        : undefined;
                case 'video':
                    return media.type === 'videoPreview'
                        ? {
                            type: media.mediaType,
                            preview: certificateMedias[index].url,
                            url: certificateMedias[index + 1]
                                ? certificateMedias[index + 1].url
                                : undefined,
                            order: media.order
                        }
                        : undefined;
                case 'AR':
                    if (media.type === 'ARPrimaryAsset') {
                        return {
                            type: 'ARPrimaryAsset',
                            url: media.url,
                            order: media.order
                        };
                    }
                    return media.type === 'ARPreview'
                        ? {
                            type: media.mediaType,
                            preview: certificateMedias[index].url,
                            url: certificateMedias[index + 1]
                                ? certificateMedias[index + 1].url
                                : undefined,
                            order: media.order
                        }
                        : undefined;
                case '3dModel':
                    return media.type === '3dModelPreview'
                        ? {
                            type: media.mediaType,
                            preview: certificateMedias[index].url,
                            url: certificateMedias[index + 1]
                                ? certificateMedias[index + 1].url
                                : undefined,
                            order: media.order
                        }
                        : undefined;
                default:
                    console.warn('Invalid media type:', media.type);
                    return null;
            }
        }))
            .filter((/**
         * @param {?} media
         * @return {?}
         */
        (media) => media));
        mediaList = [...mediaList];
    }
    return mediaList;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const mapEnrichedNotification = (/**
 * @param {?} notification
 * @param {?} certificate
 * @return {?}
 */
(notification, certificate) => {
    if (get(certificate, 'content.data') && get(certificate, 'issuer.identity')) {
        /** @type {?} */
        const certificateMedias = getMappedMediasFromCertificate(certificate);
        /** @type {?} */
        let image = '';
        if (certificateMedias.length > 0) {
            image = certificateMedias[0].type === 'picture' ? certificateMedias[0].url : certificateMedias[0].preview;
        }
        return Object.assign({}, notification, { productName: certificate.content.data.name, image, smallBrandImage: brandImageLogo(certificate.issuer.identity, ['brandLogoSquare']), bigBrandImage: brandImageLogo(certificate.issuer.identity, ['brandLogoHeader']), brandName: brandName(certificate.issuer.identity) });
    }
    else {
        return null;
    }
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function CertificateDisplay$1() { }
if (false) {
    /** @type {?} */
    CertificateDisplay$1.prototype.brandLogoHeaderReversed;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.transparency;
    /** @type {?} */
    CertificateDisplay$1.prototype.pictures;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.medias;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.otherMedias;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.threeDimensionalMedias;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.videoMedias;
    /** @type {?} */
    CertificateDisplay$1.prototype.name;
    /** @type {?} */
    CertificateDisplay$1.prototype.model;
    /** @type {?} */
    CertificateDisplay$1.prototype.brandName;
    /** @type {?} */
    CertificateDisplay$1.prototype.description;
    /** @type {?} */
    CertificateDisplay$1.prototype.serialNumber;
    /** @type {?} */
    CertificateDisplay$1.prototype.itemBackgroundPicture;
    /** @type {?} */
    CertificateDisplay$1.prototype.links;
    /** @type {?} */
    CertificateDisplay$1.prototype.isCertificateValid;
    /** @type {?} */
    CertificateDisplay$1.prototype.isRequestable;
    /** @type {?} */
    CertificateDisplay$1.prototype.brandLogoHeader;
    /** @type {?} */
    CertificateDisplay$1.prototype.certificateBackgroundPicture;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.scanned;
    /** @type {?} */
    CertificateDisplay$1.prototype.inError;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.isOwner;
    /** @type {?} */
    CertificateDisplay$1.prototype.customAttributes;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.pgeneve;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.swissmade;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.transparencyItems;
    /** @type {?|undefined} */
    CertificateDisplay$1.prototype.fallbackClaim;
    /** @type {?} */
    CertificateDisplay$1.prototype.assetType;
}
/** @type {?} */
const brandLogoHeaderReversedOrder$1 = ['brandLogoHeaderReversed', 'brandLogoHeader'];
/** @type {?} */
const brandLogoHeaderOrder$1 = ['brandLogoHeader'];
/** @type {?} */
const certificateBackgroundPictureOrder$1 = ['certificateBackgroundPicture'];
/** @type {?} */
const commonPlaceHolder$1 = {
    pictures: [],
    medias: [],
    transparency: false,
    name: 'missing_name',
    links: [],
    description: '',
    model: '',
    brandName: '',
    serialNumber: [{ type: 'regular', value: undefined }],
    brandLogoHeaderReversed: '/assets/imgs/default-images/Brand_Logo_Header_White_V1.png',
    isCertificateValid: false,
    isRequestable: false,
    itemBackgroundPicture: 'assets/imgs/default-images/Item_Background_Picture_V1.png',
    brandLogoHeader: '',
    certificateBackgroundPicture: 'assets/imgs/default-images/Certificate_Background_Picture.jpg',
    inError: true,
    isOwner: false,
    customAttributes: [],
    pgeneve: '',
    swissmade: '',
    assetType: "digitalTwin" /* digitalTwin */
};
/** @type {?} */
const poapToCertificateDetails = (/**
 * @param {?} parameters
 * @return {?}
 */
(parameters) => {
    if (!get(parameters.poapNFT, 'event.fancy_id')) {
        return commonPlaceHolder$1;
    }
    const { poapNFT, identity } = parameters;
    /** @type {?} */
    const links = poapNFT.event.event_url ? [
        {
            type: 'website',
            title: 'Click to see attached link',
            url: poapNFT.event.event_url
        }
    ] : [];
    return Object.assign({}, commonPlaceHolder$1, { isOwner: false, pictures: [poapNFT.event.image_url], name: poapNFT.event.name, links, description: poapNFT.event.description, brandName: identity.data.name, brandLogoHeaderReversed: brandImageLogo(identity, brandLogoHeaderReversedOrder$1), isCertificateValid: true, isRequestable: identity.claimed, brandLogoHeader: brandImageLogo(identity, brandLogoHeaderOrder$1), certificateBackgroundPicture: brandImageLogo(identity, certificateBackgroundPictureOrder$1), inError: false, assetType: "digitalAsset" /* digitalAsset */ });
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ProductListItem$1() { }
if (false) {
    /** @type {?} */
    ProductListItem$1.prototype.name;
    /** @type {?} */
    ProductListItem$1.prototype.description;
    /** @type {?} */
    ProductListItem$1.prototype.imgurl;
    /** @type {?} */
    ProductListItem$1.prototype.brandLogo;
    /** @type {?} */
    ProductListItem$1.prototype.scanned;
    /** @type {?} */
    ProductListItem$1.prototype.brandName;
    /** @type {?|undefined} */
    ProductListItem$1.prototype.cornerPicture;
    /** @type {?} */
    ProductListItem$1.prototype.certificateId;
}
/** @type {?} */
const placeholder$1 = {
    name: 'item name is missing',
    description: 'description is missing',
    brandName: 'missing brand name',
    brandLogo: 'assets/imgs/default-images/Brand_Logo_Header_Black_V1.png',
    imgurl: 'assets/imgs/default-images/Brand_Item_Background_V1.png',
    certificateId: '0',
    scanned: false
};
/** @type {?} */
const poapToCertificateListItem = (/**
 * @param {?} parameters
 * @return {?}
 */
(parameters) => {
    if (!get(parameters.poapNFT, 'event.fancy_id')) {
        return placeholder$1;
    }
    const { poapNFT, identity } = parameters;
    return Object.assign({}, placeholder$1, { name: poapNFT.event.name, brandName: identity.data.name, description: poapNFT.event.description, imgurl: brandImageLogo(identity, ['brandItemBackgroundPicture']), cornerPicture: poapNFT.event.image_url, certificateId: poapNFT.tokenId.toString(), brandLogo: brandImageLogo(identity, ['brandLogoHeader']), scanned: false });
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const poapNFTToEventDisplay = (/**
 * @param {?} parameters
 * @return {?}
 */
(parameters) => {
    const { identity, poapNFT } = parameters;
    /** @type {?} */
    const justABitMore = (/**
     * @param {?} date
     * @return {?}
     */
    (date) => {
        /** @type {?} */
        const dateInstance = new Date(date);
        dateInstance.setMilliseconds(dateInstance.getMilliseconds() + 1);
        return dateInstance;
    });
    /** @type {?} */
    const commontEvent = {
        type: undefined,
        date: new Date(),
        avatar: brandImageLogo(identity, ['brandLogoSquare']),
        pending: undefined,
        viewdetail: undefined,
        publicKey: identity.address,
        detail: {
            imgurl: poapNFT.event.image_url,
            title: `Ending: ${poapNFT.event.name}`,
            description: poapNFT.event.description
        }
    };
    /** @type {?} */
    const eventStarting = (/** @type {?} */ (Object.assign({}, commontEvent, { id: 0, title: `${poapNFT.event.name} starts`, date: new Date(poapNFT.event.start_date) })));
    /** @type {?} */
    const eventEnding = (/** @type {?} */ (Object.assign({}, commontEvent, { id: 1, title: `${poapNFT.event.name} ends`, date: justABitMore(poapNFT.event.end_date) })));
    /** @type {?} */
    const transferEvent = {
        id: 2,
        title: undefined,
        subtitle: undefined,
        type: 'ownership_transfer',
        date: new Date(poapNFT.created_date),
        avatar: brandImageLogo(identity, ['brandLogoSquare']),
        pending: undefined,
        viewdetail: undefined,
        publicKey: poapNFT.owner,
        detail: {
            imgurl: poapNFT.event.image_url,
            title: `Starting: ${poapNFT.event.name}`,
            description: poapNFT.event.description
        }
    };
    /** @type {?} */
    const events = [eventStarting, eventEnding];
    // I cannot find the date when token was requested
    if (poapNFT.owner && poapNFT.created_date) {
        events.push(transferEvent);
    }
    return events.sort((/**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    function compare(a, b) {
        return b.date.getTime() - a.date.getTime();
    }));
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DisplayMapperService {
    constructor() {
        this.brandDisplayMapper = brandDisplayMapper;
        this.eventDisplayMapper = eventDisplayMapper;
        this.certificateDisplayMapper = certificateDisplayMapper;
        this.poapCertificateDisplayMapper = poapToCertificateDetails;
        this.poapListCertificateDisplayMapper = poapToCertificateListItem;
        this.poapToEventDisplayMapper = poapNFTToEventDisplay;
        this.productListDisplayMapper = productListDisplayMapper;
        this.mapEnrichedNotification = mapEnrichedNotification;
    }
}
DisplayMapperService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ DisplayMapperService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DisplayMapperService_Factory() { return new DisplayMapperService(); }, token: DisplayMapperService, providedIn: "root" });
if (false) {
    /** @type {?} */
    DisplayMapperService.prototype.brandDisplayMapper;
    /** @type {?} */
    DisplayMapperService.prototype.eventDisplayMapper;
    /** @type {?} */
    DisplayMapperService.prototype.certificateDisplayMapper;
    /** @type {?} */
    DisplayMapperService.prototype.poapCertificateDisplayMapper;
    /** @type {?} */
    DisplayMapperService.prototype.poapListCertificateDisplayMapper;
    /** @type {?} */
    DisplayMapperService.prototype.poapToEventDisplayMapper;
    /** @type {?} */
    DisplayMapperService.prototype.productListDisplayMapper;
    /** @type {?} */
    DisplayMapperService.prototype.mapEnrichedNotification;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BrandListItemComponent {
    /**
     * @param {?} displayMapperService
     */
    constructor(displayMapperService) {
        this.displayMapperService = displayMapperService;
        this.clickOnBrand = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.brand = this.displayMapperService.brandDisplayMapper(this.brandIdentity, this.count);
        this.countNFTs();
    }
    /**
     * @private
     * @return {?}
     */
    countNFTs() {
        this.oneOrMoreNFT = !!this.certificates.find((/**
         * @param {?} certificate
         * @return {?}
         */
        (certificate) => get(certificate, 'content.data.subCategory', '') === 'Digital Asset' || get(certificate, 'content.data.category', '') === 'Digital Asset'));
    }
}
BrandListItemComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-brand-list-item',
                template: "<div class=\"product-item\" *ngIf=\"brand\"\n     [attr.data-e2e]=\"'brand_list_item_' + brand.brandId\"\n     (click)=\"clickOnBrand.emit(brand.brandId)\">\n  <div class=\"product-image\">\n    <img [src]=\"brand.imgurl | imageProxy | async\"/>\n  </div>\n\n  <div class=\"product-count\" *ngIf=\"overrideCountWithMsg\">\n    <p>\n      {{overrideCountWithMsg}}\n    </p>\n  </div>\n  <div class=\"product-count\" data-e2e=\"product_count\" *ngIf=\"!overrideCountWithMsg && count > 0\">\n    <p>\n      {{(brand.count > 1) ? ((oneOrMoreNFT ? 'BrandList.itemsNfts' : 'BrandList.items') | translate:{itemCount: brand.count}) : ((oneOrMoreNFT ? 'BrandList.itemNft' : 'BrandList.item') | translate:{itemCount: brand.count}) }}\n    </p>\n  </div>\n</div>\n",
                styles: [".product-item{position:relative}.product-image{min-height:170px;position:relative;overflow:hidden;border-radius:10px;margin:2vh 0}.product-image>img{width:100%;display:block}.product-count{position:absolute;top:0;right:0}.product-count>p{margin:0;padding:8px 20px;color:#423b41;background-color:#d8d8d8;font-family:Inter-Regular;border-top-right-radius:10px;border-bottom-left-radius:25px}"]
            }] }
];
/** @nocollapse */
BrandListItemComponent.ctorParameters = () => [
    { type: DisplayMapperService }
];
BrandListItemComponent.propDecorators = {
    brandIdentity: [{ type: Input }],
    count: [{ type: Input }],
    overrideCountWithMsg: [{ type: Input }],
    certificates: [{ type: Input }],
    clickOnBrand: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    BrandListItemComponent.prototype.brandIdentity;
    /** @type {?} */
    BrandListItemComponent.prototype.count;
    /** @type {?} */
    BrandListItemComponent.prototype.overrideCountWithMsg;
    /** @type {?} */
    BrandListItemComponent.prototype.certificates;
    /** @type {?} */
    BrandListItemComponent.prototype.clickOnBrand;
    /** @type {?} */
    BrandListItemComponent.prototype.brand;
    /** @type {?} */
    BrandListItemComponent.prototype.oneOrMoreNFT;
    /**
     * @type {?}
     * @private
     */
    BrandListItemComponent.prototype.displayMapperService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SafePipe {
    /**
     * @param {?} sanitizer
     */
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} value
     * @param {?=} type
     * @return {?}
     */
    transform(value, type = '') {
        switch (type) {
            case 'html':
                /** @type {?} */
                let _value = value || '';
                /** @type {?} */
                const searchRegExp = new RegExp('script', 'gi');
                _value = _value.replace(searchRegExp, '');
                return this.sanitizer.bypassSecurityTrustHtml(_value);
            case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default: return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        }
    }
}
SafePipe.decorators = [
    { type: Pipe, args: [{
                name: 'safe'
            },] }
];
/** @nocollapse */
SafePipe.ctorParameters = () => [
    { type: DomSanitizer }
];
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SafePipe.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InterceptorAbstractService {
    constructor() {
        this.proxify = (/**
         * @param {?} url
         * @return {?}
         */
        (url) => __awaiter(this, void 0, void 0, function* () {
            return url;
        }));
    }
}
InterceptorAbstractService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ InterceptorAbstractService.ngInjectableDef = ɵɵdefineInjectable({ factory: function InterceptorAbstractService_Factory() { return new InterceptorAbstractService(); }, token: InterceptorAbstractService, providedIn: "root" });
if (false) {
    /** @type {?} */
    InterceptorAbstractService.prototype.proxify;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ImageProxyPipe {
    /**
     * @param {?} interceptorService
     */
    constructor(interceptorService) {
        this.interceptorService = interceptorService;
    }
    /**
     * @param {?} url
     * @param {...?} args
     * @return {?}
     */
    transform(url, ...args) {
        return this.interceptorService.proxify(url);
    }
}
ImageProxyPipe.decorators = [
    { type: Pipe, args: [{
                name: 'imageProxy'
            },] }
];
/** @nocollapse */
ImageProxyPipe.ctorParameters = () => [
    { type: InterceptorAbstractService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    ImageProxyPipe.prototype.interceptorService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SafeHtmlPipe {
    /**
     * @param {?} sanitized
     */
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        /** @type {?} */
        let _value = value || '';
        // prevent scripting
        /** @type {?} */
        const searchRegExp = new RegExp('/</?script>/', 'gi');
        _value = _value.replace(searchRegExp, '');
        return this.sanitized.bypassSecurityTrustHtml(_value);
    }
}
SafeHtmlPipe.decorators = [
    { type: Pipe, args: [{ name: 'safeHtml' },] }
];
/** @nocollapse */
SafeHtmlPipe.ctorParameters = () => [
    { type: DomSanitizer }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    SafeHtmlPipe.prototype.sanitized;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ImageSourceService {
    /**
     * Set Assets url
     * @param {?} assetsSource
     * @return {?}
     */
    initAssetsUrl(assetsSource) {
        this.imageSource = assetsSource;
    }
}
ImageSourceService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ ImageSourceService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ImageSourceService_Factory() { return new ImageSourceService(); }, token: ImageSourceService, providedIn: "root" });
if (false) {
    /** @type {?} */
    ImageSourceService.prototype.imageSource;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ImageSourcePipe {
    /**
     * @param {?} imageSourceService
     */
    constructor(imageSourceService) {
        this.imageSourceService = imageSourceService;
    }
    /**
     * @param {?} path
     * @return {?}
     */
    transform(path) {
        // remove relative path (./ ../../)
        if (!path) {
            return '';
        }
        /** @type {?} */
        const index = path.indexOf('assets');
        path = path.substring(index, path.length);
        /** @type {?} */
        const isHttpHttps = path.startsWith('http') || path.startsWith('https');
        /** @type {?} */
        let url = this.imageSourceService.imageSource ? this.imageSourceService.imageSource : '';
        url = url[url.length - 1] === '/' ? url : url + '/';
        return url && !isHttpHttps ? url + path : path;
    }
}
ImageSourcePipe.decorators = [
    { type: Pipe, args: [{
                name: 'imageSrc'
            },] }
];
/** @nocollapse */
ImageSourcePipe.ctorParameters = () => [
    { type: ImageSourceService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    ImageSourcePipe.prototype.imageSourceService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const pipes = [
    SafePipe,
    SafeHtmlPipe,
    ImageProxyPipe,
    ImageSourcePipe
];
class PipeModule {
    /**
     * @param {?} interceptorService
     * @return {?}
     */
    static forRoot(interceptorService) {
        return {
            ngModule: PipeModule,
            providers: [
                {
                    provide: InterceptorAbstractService, useValue: interceptorService
                }
            ]
        };
    }
}
PipeModule.decorators = [
    { type: NgModule, args: [{
                declarations: pipes,
                imports: [],
                exports: pipes
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StyleService {
    constructor() {
        this.defaultStyleConfig = {
            buttons: {
                color: '#ffffff',
                bgColor: '#3880ff',
                bgHoverColor: '#2b71ea'
            },
            spinnerColor: '#000'
        };
        this.customStyle = new BehaviorSubject(this.defaultStyleConfig);
        this.libraryCustomTheme = new ReplaySubject(1);
    }
    /**
     * Init WEB WALLET Style + Modal Style
     * @param {?} style
     * @return {?}
     */
    initStyle(style) {
        /** @type {?} */
        const merged = Object.assign(this.defaultStyleConfig, style);
        this.customStyle.next(merged);
        // use theme to init custom style to some ui shared between Wallet & WebWallet
        this.libraryCustomTheme.pipe(take(1)).subscribe((/**
         * @param {?} theme
         * @return {?}
         */
        (theme) => {
            theme.fonts = {
                text: merged.fontFamily,
                title: merged.fontFamily,
            };
            this.setLibraryTheme(theme);
        }));
    }
    /**
     * Theme for all Shared Components
     * @param {?} theme
     * @return {?}
     */
    setLibraryTheme(theme) {
        this.libraryCustomTheme.next(theme);
    }
}
StyleService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ StyleService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StyleService_Factory() { return new StyleService(); }, token: StyleService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    StyleService.prototype.defaultStyleConfig;
    /** @type {?} */
    StyleService.prototype.customStyle;
    /** @type {?} */
    StyleService.prototype.libraryCustomTheme;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CustomizableButtonComponent {
    /**
     * @param {?} styleService
     */
    constructor(styleService) {
        this.styleService = styleService;
        this.label = 'label';
        this.displayBlock = true;
        this.onClick = new EventEmitter();
        this._disabled = false;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    onCustomClick() {
        if (this._disabled !== true) {
            this.onClick.emit();
        }
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set disabled(val) {
        this._disabled = !!val;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} s
         * @return {?}
         */
        (s) => { s.unsubscribe(); }));
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.subscriptions.push(this.styleService.customStyle.subscribe((/**
         * @param {?} style
         * @return {?}
         */
        (style) => {
            this.styleConfig = style;
            this.applyCustomStyle();
        })));
    }
    /**
     * @return {?}
     */
    applyCustomStyle() {
        if (this.styleConfig) {
            if (this.styleConfig.fontFamily) {
                this.customBtn.el.style.setProperty('--ion-font-family', this.styleConfig.fontFamily);
            }
            if (this.styleConfig.buttons) {
                if (this.styleConfig.buttons.color) {
                    this.customBtn.el.style.setProperty('--color', this.styleConfig.buttons.color);
                }
                if (this.styleConfig.buttons.bgColor) {
                    this.customBtn.el.style.setProperty('--background', this.styleConfig.buttons.bgColor);
                }
                if (this.styleConfig.buttons.bgHoverColor) {
                    this.customBtn.el.style.setProperty('--background-hover', this.styleConfig.buttons.bgHoverColor);
                }
                if (this.styleConfig.buttons.textHoverColor) {
                    this.customBtn.el.style.setProperty('--text-hover', this.styleConfig.buttons.textHoverColor);
                }
            }
        }
    }
}
CustomizableButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-customizable-button',
                template: "\n<ion-button #customBtn\n            (click)=\"onCustomClick()\"\n            [expand]=\"displayBlock ? 'block': null\" [disabled]=\"_disabled\">\n  {{label}}\n</ion-button>\n",
                styles: ["ion-button{text-transform:uppercase}ion-button:hover{--background:var(--background-hover)!important;--color:var(--text-hover, inherit)!important}"]
            }] }
];
/** @nocollapse */
CustomizableButtonComponent.ctorParameters = () => [
    { type: StyleService }
];
CustomizableButtonComponent.propDecorators = {
    label: [{ type: Input }],
    displayBlock: [{ type: Input }],
    onClick: [{ type: Output }],
    customBtn: [{ type: ViewChild, args: ['customBtn', { static: true },] }],
    disabled: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CustomizableButtonComponent.prototype.label;
    /** @type {?} */
    CustomizableButtonComponent.prototype.displayBlock;
    /** @type {?} */
    CustomizableButtonComponent.prototype.onClick;
    /** @type {?} */
    CustomizableButtonComponent.prototype.styleConfig;
    /** @type {?} */
    CustomizableButtonComponent.prototype.customBtn;
    /** @type {?} */
    CustomizableButtonComponent.prototype._disabled;
    /** @type {?} */
    CustomizableButtonComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    CustomizableButtonComponent.prototype.styleService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductCertVerifiedComponent {
    /**
     * @param {?} modalCtrl
     */
    constructor(modalCtrl) {
        this.modalCtrl = modalCtrl;
        this.isLoading = true;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.logScreen) {
            this.logScreen('product-cert-verified', { certificateId: this.certificateId, network: this.network, issuer: this.certificate.issuer.identity.address });
        }
        this.brandNameTranslation = { brandname: brandName(this.certificate.issuer.identity) };
        this.globalValidation = this.certificate.issuer.isIdentityAuthentic && this.certificate.issuer.isIdentityVerified && this.certificate.content.isAuthentic;
        this.isBrandAuthentic = this.certificate.issuer.isIdentityAuthentic;
        this.isBrandVerified = this.certificate.issuer.isIdentityVerified;
        this.isCertificateAuthentic = this.certificate.content.isAuthentic;
        this.arianeeId = this.certificate.certificateId;
        this.isLoading = false;
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
}
ProductCertVerifiedComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-cert-verified',
                template: "<lib-customizable-modal-wrapper>\n  <div class=\"inner-content\">\n    <div [ngClass]=\"(globalValidation)?'authentic_certificate':'not_authentic_certificate'\"\n         class=\"pd-cert-verified-header\">\n      <div class=\"icon-cert\">\n        <img [src]=\"(globalValidation?\n                'assets/imgs/img_product_cert.svg':\n                'assets/imgs/img_product_not_cert.svg') | imageSrc\n                \" data-e2e='validity-picture'/>\n      </div>\n      <div class=\"cert-status\">\n        {{(globalValidation) ? (\"ProductVerifiedDetails.authentic_certificate\" | translate) : (\"ProductVerifiedDetails.not_authentic_certificate\" | translate)}}\n      </div>\n      <div *ngIf=\"globalValidation\" class=\"cert-issued\">\n        {{\"ProductVerifiedDetails.issued_by\" | translate}}<br/>{{brandNameTranslation.brandname}}\n      </div>\n    </div>\n\n    <div *ngIf=\"!isLoading\" class=\"pd-cert-verified-content\">\n      <div class=\"pd-cert-verified-content-item\">\n        <ion-icon *ngIf=\"isCertificateAuthentic\" [src]=\"'assets/imgs/md-checkmark-circle-outline.svg' | imageSrc\"\n                  class='icon icon--valid'>\n        </ion-icon>\n        <ion-icon *ngIf=\"!isCertificateAuthentic\" [src]=\"'assets/imgs/ios-close-circle-outline.svg' | imageSrc\"\n                  class='icon icon--unvalid'>\n        </ion-icon>\n        <p>\n          {{\"ProductVerifiedDetails.authentic_certificate\" | translate}}\n        </p>\n      </div>\n      <div class=\"pd-cert-verified-content-item\">\n        <ion-icon *ngIf=\"isBrandVerified\" [src]=\"'assets/imgs/md-checkmark-circle-outline.svg' | imageSrc\"\n                  class='icon icon--valid'></ion-icon>\n        <ion-icon *ngIf=\"!isBrandVerified\" [src]=\"'assets/imgs/ios-close-circle-outline.svg' | imageSrc\"\n                  class='icon icon--unvalid'></ion-icon>\n        <p>\n          {{\"ProductVerifiedDetails.verified_brand\" | translate}}\n        </p>\n      </div>\n      <div class=\"pd-cert-verified-content-item\">\n        <ion-icon *ngIf=\"isBrandAuthentic\" [src]=\"'assets/imgs/md-checkmark-circle-outline.svg' | imageSrc\"\n                  class='icon icon--valid'></ion-icon>\n        <ion-icon *ngIf=\"!isBrandAuthentic\" [src]=\"'assets/imgs/ios-close-circle-outline.svg' | imageSrc\"\n                  class='icon icon--unvalid'></ion-icon>\n        <p>\n          {{\"ProductVerifiedDetails.authentic_brand\" | translate}}\n        </p>\n      </div>\n\n      <p [attr.data-e2e]=\"globalValidation?'cert_valid':'cert_unvalid'\" [innerHTML]=\"\n        ((globalValidation?'ProductVerifiedDetails.explanation':'ProductVerifiedDetails.explanationBrandKo')\n         | translate:brandNameTranslation) | safeHtml\">\n      </p>\n      <p>\n        ArianeeId: {{arianeeId}}\n        <ng-container *ngIf=\"network\">on {{network | titlecase}}</ng-container>\n      </p>\n      <div class=\" pd-cert-verified-content-close\">\n        <ion-button (click)=\"onClickClose()\" fill=\"clear\">\n          <ion-label>{{\"ProductVerifiedDetails.close\" | translate}}</ion-label>\n        </ion-button>\n      </div>\n    </div>\n  </div>\n</lib-customizable-modal-wrapper>\n",
                styles: [".pd-cert-verified-header{box-shadow:0 0 8px #ababab;border-top-left-radius:12px;border-top-right-radius:12px;margin:0 4px;height:75px}.pd-cert-verified-header>img{width:100%}.authentic_certificate{background-image:linear-gradient(to right,#4dcb5c,#409248)}.not_authentic_certificate{background-image:linear-gradient(to right,#db516b,#862e3e)}.pd-cert-verified-content{padding-top:1em;background-color:var(--modal-bg-color,#fff);margin:-12px 4px 8px;box-shadow:0 0 8px #ababab;border-bottom-left-radius:12px;border-bottom-right-radius:12px;border-top:1px solid #848484;color:var(--modal-text-color,#202224);font-family:var(--modal-font-family, \"Inter-Regular\")}.pd-cert-verified-content>p{color:var(--modal-text-color,#202224);padding:0 16px}.pd-cert-verified-content .icon{height:1.3em;width:1.3em}.pd-cert-verified-content .icon.icon--valid{color:#3cc04a}.pd-cert-verified-content .icon.icon--unvalid{color:#f93c65}.pd-cert-verified-content-item{display:flex;align-items:center;padding:8px 16px}.pd-cert-verified-content-item>p{margin:4px 0 0 12px}.pd-cert-verified-content-close{text-align:right}.pd-cert-verified-content-close ion-button ion-label{font-family:var(--modal-font-family, \"Inter-Regular\");color:#a0a0a0}.icon-cert{text-align:center;top:-25px;position:relative}.inner-content{padding-top:30px!important}:host ::ng-deep .modal-wrapper{width:100%!important}.cert-status{position:absolute;top:45px;color:#fff;left:25px;width:120px;font-weight:700;font-family:var(--modal-font-family)}.cert-issued{position:absolute;top:45px;color:#fff;right:25px;font-weight:700;text-align:right;font-family:var(--modal-font-family)}"]
            }] }
];
/** @nocollapse */
ProductCertVerifiedComponent.ctorParameters = () => [
    { type: ModalController }
];
ProductCertVerifiedComponent.propDecorators = {
    certificateId: [{ type: Input }],
    certificate: [{ type: Input }],
    logScreen: [{ type: Input }],
    network: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.certificateId;
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.certificate;
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.logScreen;
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.network;
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.isBrandAuthentic;
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.isBrandVerified;
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.isCertificateAuthentic;
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.globalValidation;
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.brandNameTranslation;
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.isLoading;
    /** @type {?} */
    ProductCertVerifiedComponent.prototype.arianeeId;
    /**
     * @type {?}
     * @private
     */
    ProductCertVerifiedComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductInfoHistoryComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} translate
     * @param {?} displayMapperService
     */
    constructor(modalCtrl, translate, displayMapperService) {
        this.modalCtrl = modalCtrl;
        this.translate = translate;
        this.displayMapperService = displayMapperService;
        this.viewedEvents = [];
        this.loader = true;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.locale = this.translate.currentLang;
        this.isOwner = this.certificateDisplay.isOwner;
        this.logScreen('product-info-history', { certificateId: this.certificateId, network: this.network, issuer: this.identityBase.address });
        if (this.displayEvents) {
            this.viewedEvents = this.displayEvents.map((/**
             * @param {?} event
             * @return {?}
             */
            (event) => event));
        }
        else {
            if (this.events.transfer[0]) {
                this.ownershipDate = new Date(this.events.transfer[this.events.transfer.length - 1].timestamp * 1000);
            }
            this.mergeEvents(this.events);
        }
        this.loader = false;
    }
    /**
     * @param {?} events
     * @return {?}
     */
    mergeEvents(events) {
        /** @type {?} */
        const transfer = Array.from(events ? events.transfer : []);
        if (transfer.length > 0) {
            /** @type {?} */
            let issuerFound = false;
            for (let i = 0; i < transfer.length; i++) {
                if (!issuerFound) {
                    if (transfer[i].returnValues._to === this.identityBase.address) {
                        issuerFound = true;
                    }
                    transfer.shift();
                }
            }
        }
        if (events.arianeeEvents.length > 0 || events.transfer.length > 0) {
            /** @type {?} */
            const history = ((/** @type {?} */ (Array.from(events.arianeeEvents))))
                // Don't display if no content
                .filter((/**
             * @param {?} arianeeEvent
             * @return {?}
             */
            arianeeEvent => arianeeEvent.content))
                // If arianeeEvent is pending, user should be owner to see it
                .filter((/**
             * @param {?} arianeeEvent
             * @return {?}
             */
            arianeeEvent => !arianeeEvent.pending || this.isOwner))
                .concat(transfer);
            history.sort(this.sortEventsDescending);
            this.viewedEvents = history.map((/**
             * @param {?} event
             * @return {?}
             */
            (event) => this.displayMapperService.eventDisplayMapper(event)));
        }
        else {
            this.viewedEvents = [];
        }
    }
    /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    sortEventsDescending(a, b) {
        if (a.timestamp > b.timestamp) {
            return -1;
        }
        else if (a.timestamp < b.timestamp) {
            return 1;
        }
        return 0;
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
    /**
     * @param {?} index
     * @return {?}
     */
    onClickViewMore(index) {
        if (this.viewedEvents[index].detail.description || this.viewedEvents[index].detail.imgurl) {
            this.viewedEvents[index].viewdetail = !this.viewedEvents[index].viewdetail;
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    refuseEvent($event) {
        /** @type {?} */
        const index = $event[1];
        this.viewedEvents.splice(index, 1);
        this.onDeclineEvent($event);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    acceptEvent($event) {
        /** @type {?} */
        const index = $event[1];
        this.viewedEvents[index].pending = false;
        this.onAcceptEvent($event);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} sub
         * @return {?}
         */
        sub => sub.unsubscribe()));
    }
}
ProductInfoHistoryComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-info-history',
                template: "<lib-customizable-modal-wrapper>\n  <div class=\"inner-content\" data-e2e=\"product_history\">\n      <div class=\"pd-history-header\">\n          <div>\n              <p class=\"arianee-wallet-font\">\n                  {{'CertificateEvents.history' | translate}}\n              </p>\n          </div>\n          <div class=\"icon-close\">\n            <icon name=\"close\" size=\"2em\" (click)=\"onClickClose()\"></icon>\n          </div>\n      </div>\n\n      <div class=\"pd-history-main\">\n          <div>\n              <p class=\"ownerSince\" *ngIf=\"ownershipDate && isOwner\">\n                  {{'CertificateEvents.ownerSince' | translate}}\n                  {{ ownershipDate | amLocale:locale | amDateFormat:'MMMM YYYY' }}\n\n              </p>\n              <div *ngIf=\"viewedEvents.length == 0\">\n                  <p>{{ 'CertificateEvents.noHistory' |\u00A0translate}}</p>\n              </div>\n\n              <app-events-list\n\n                      [eventType]=\"'history'\"\n                      [events]=\"viewedEvents\"\n                      [loader]=\"loader\"\n                      [address]=\"address\"\n                      (onClickViewMore)=\"onClickViewMore($event)\"\n                      (onClickRefuseEvent)=\"refuseEvent($event)\"\n                      (onClickAcceptEvent)=\"acceptEvent($event)\"\n              ></app-events-list>\n          </div>\n          <div class=\"pd-history-brand\">\n              <img *ngIf=\"brandLogoHeader\" src=\"{{brandLogoHeader | imageSrc }}\"/>\n          </div>\n      </div>\n  </div>\n</lib-customizable-modal-wrapper>\n\n\n",
                styles: [".inner-content{padding:0!important;background-color:#fefefe;border-radius:16px;overflow:hidden}.icon-close{cursor:pointer}.pd-history-header{display:flex;margin-top:16px;padding:0 16px;align-items:center}.pd-history-header>div:first-child{flex:3}.pd-history-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.pd-history-header>div:nth-child(2){flex:1;text-align:right}.pd-history-header>div:nth-child(2) ion-icon{font-size:2em}.pd-history-main{padding:8px;margin-top:20px;border-top:1px solid #eee;background-color:var(--modal-bg-color,transparent)}.pd-history-main p{text-align:center;color:var(--modal-text-color,#999)}.pd-history-brand{text-align:center;margin:3vh 0}.pd-history-brand>img{width:50%}.ownerSince{color:var(--modal-text-color,#999);text-align:center;font-weight:700}.date{color:var(--modal-text-color,#999);font-family:Inter-Regular;font-size:.9em}"]
            }] }
];
/** @nocollapse */
ProductInfoHistoryComponent.ctorParameters = () => [
    { type: ModalController },
    { type: TranslateService },
    { type: DisplayMapperService }
];
ProductInfoHistoryComponent.propDecorators = {
    displayEvents: [{ type: Input }],
    events: [{ type: Input }],
    certificateDisplay: [{ type: Input }],
    identityBase: [{ type: Input }],
    certificateId: [{ type: Input }],
    address: [{ type: Input }],
    logScreen: [{ type: Input }],
    onAcceptEvent: [{ type: Input }],
    onDeclineEvent: [{ type: Input }],
    network: [{ type: Input }],
    brandLogoHeader: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.displayEvents;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.events;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.certificateDisplay;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.identityBase;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.certificateId;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.address;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.logScreen;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.onAcceptEvent;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.onDeclineEvent;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.network;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.brandLogoHeader;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.viewedEvents;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.loader;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.ownershipDate;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.isOwner;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.locale;
    /**
     * @type {?}
     * @private
     */
    ProductInfoHistoryComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    ProductInfoHistoryComponent.prototype.modalCtrl;
    /** @type {?} */
    ProductInfoHistoryComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    ProductInfoHistoryComponent.prototype.displayMapperService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductInfoCertComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} displayMapperService
     */
    constructor(modalCtrl, displayMapperService) {
        this.modalCtrl = modalCtrl;
        this.displayMapperService = displayMapperService;
        this.subscriptions = [];
        this.createLink = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const link = yield this.createCertificateProofLink(this.certificateId);
            this.qrCodeLink = link.link;
        }));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.productInfo = this.displayMapperService.certificateDisplayMapper(this.certificate);
        this.logScreen('product-info-cert', { certificateId: this.certificateId, network: this.network, issuer: this.certificate.issuer.identity.address });
        this.createLink();
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
    /**
     * @return {?}
     */
    share() {
        this.logScreen('product-info-cert-share', { certificateId: this.certificateId, network: this.network, issuer: this.certificate.issuer.identity.address });
        this.shareLink('Share.subjectProof', 'Share.messageProof', this.qrCodeLink);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} sub
         * @return {?}
         */
        sub => sub.unsubscribe()));
    }
}
ProductInfoCertComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-info-cert',
                template: "<lib-customizable-modal-wrapper>\n  <div class=\"inner-content\" data-e2e=\"proof_cert\">\n    <div class=\"pd-cert-header\">\n      <div>\n        <p class=\"arianee-wallet-font\">\n          {{'CertificateInfos.proofOfOwnership' | translate}}\n        </p>\n      </div>\n      <div class=\"icon-close\">\n        <icon name=\"close\" size=\"2em\" (click)=\"onClickClose()\"></icon>\n      </div>\n    </div>\n\n    <div class=\"pd-cert-main\" [style.backgroundImage]=\"'url('+ (productInfo.certificateBackgroundPicture   | imageSrc | imageProxy | async)+')'\">\n\n      <div class=\"pd-cert-main-content\">\n\n        <img src=\"{{productInfo.brandLogoHeaderReversed | imageSrc | imageProxy | async}}\" alt=\"\">\n\n        <p class=\"pd-cert-main-prod-title\">\n          {{productInfo.name}}\n        </p>\n\n        <p class=\"pd-cert-main-prod-description\" [innerHTML]=\"(productInfo.description | translate) | safeHtml\" *ngIf=\"0\">\n        </p>\n\n        <div class=\"pd-cert-main-prod-qr\">\n          <div [class.show]=\"qrCodeLink\">\n            <angular-qr-code link=\"{{qrCodeLink}}\" *ngIf=\"qrCodeLink\" data-e2e=\"qrcode\"></angular-qr-code>\n            <div class=\"loader\" *ngIf=\"!qrCodeLink\">\n              <lib-loading-spinner\n                [loading]=\"true\" [fullScreen]=\"false\" background=\"transparent\">\n              </lib-loading-spinner>\n            </div>\n          </div>\n        </div>\n\n        <p class=\"pd-cert-main-prod-date\" *ngIf=\"productInfo.serialNumber[0] && productInfo.serialNumber[0].value\">\n          {{ 'CertificateInfos.serialNumber' | translate }} : {{productInfo.serialNumber[0].value}}\n        </p>\n      </div>\n    </div>\n\n    <div class=\"tf-cert-footer\">\n      <lib-customizable-button *ngIf=\"qrCodeLink\"\n                               label=\"{{'CertificateInfos.shareCertificate' | translate}}\"\n                               (click)=\"share()\">\n      </lib-customizable-button>\n    </div>\n  </div>\n</lib-customizable-modal-wrapper>\n",
                styles: [".inner-content{display:flex;flex-direction:column;justify-content:space-between;padding:16px}.icon-close{cursor:pointer}.pd-cert-header{display:flex;margin:16px 0;align-items:center;padding:0 16px}.pd-cert-header>div:first-child{flex:3}.pd-cert-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.2em;margin:0}.pd-cert-header>div:nth-child(2){flex:1;text-align:right}.pd-cert-header>div:nth-child(2) ion-icon{font-size:1.6em}.pd-cert-main{display:flex;height:80%;border-radius:8px;background-size:cover;background-repeat:no-repeat;background-position:top center;background-color:var(--modal-bg-color,transparent)}.pd-cert-main-content{flex-grow:1;position:relative;padding:16px;display:flex;flex-direction:column;justify-content:flex-start;align-items:center}.pd-cert-main-content img{max-width:80%}.pd-cert-main-title{color:#fff;text-align:center;font-family:Inter-Bold;margin:0}.pd-cert-main-prod-description,.pd-cert-main-prod-title{text-align:center;color:var(--modal-title-color,#f93c65);font-family:var(--modal-font-family, \"Inter-Bold\");margin:10px 0}.pd-cert-main-prod-qr{text-align:center;margin-bottom:20px;display:flex;align-items:center;justify-content:center;height:196px}.pd-cert-main-prod-qr>div{display:flex;align-items:center;justify-content:center;margin:auto;background-color:#fff;padding:16px;overflow:hidden;box-sizing:content-box;border-radius:50%;width:24px;height:24px;transition:.4s}.pd-cert-main-prod-qr>div.show{width:160px;height:164px;border-radius:12px}.pd-cert-main-prod-qr .loader{display:flex;width:100%;align-items:center;justify-content:center}.pd-cert-main-prod-text{text-align:center;color:#fff;font-family:Inter-Bold;font-size:1em;margin:8px 0}.pd-cert-main-prod-date{font-family:Inter-Regular;font-style:italic;text-align:center;color:#fff;margin:4px 0}.tf-cert-footer{height:44px}"]
            }] }
];
/** @nocollapse */
ProductInfoCertComponent.ctorParameters = () => [
    { type: ModalController },
    { type: DisplayMapperService }
];
ProductInfoCertComponent.propDecorators = {
    certificateId: [{ type: Input }],
    certificate: [{ type: Input }],
    logScreen: [{ type: Input }],
    shareLink: [{ type: Input }],
    network: [{ type: Input }],
    createCertificateProofLink: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductInfoCertComponent.prototype.certificateId;
    /** @type {?} */
    ProductInfoCertComponent.prototype.certificate;
    /** @type {?} */
    ProductInfoCertComponent.prototype.logScreen;
    /** @type {?} */
    ProductInfoCertComponent.prototype.shareLink;
    /** @type {?} */
    ProductInfoCertComponent.prototype.network;
    /** @type {?} */
    ProductInfoCertComponent.prototype.createCertificateProofLink;
    /** @type {?} */
    ProductInfoCertComponent.prototype.productInfo;
    /** @type {?} */
    ProductInfoCertComponent.prototype.qrCodeLink;
    /**
     * @type {?}
     * @private
     */
    ProductInfoCertComponent.prototype.subscriptions;
    /** @type {?} */
    ProductInfoCertComponent.prototype.createLink;
    /**
     * @type {?}
     * @private
     */
    ProductInfoCertComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    ProductInfoCertComponent.prototype.displayMapperService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Events {
    constructor() {
        this.channels = {};
    }
    /**
     * Subscribe to a topic and provide a single handler/observer.
     * @param {?} topic The name of the topic to subscribe to.
     * @param {?} observer The observer or callback function to listen when changes are published.
     *
     * @return {?} Subscription from which you can unsubscribe to release memory resources and to prevent memory leak.
     */
    subscribe(topic, observer) {
        if (!this.channels[topic]) {
            // You can also use ReplaySubject with one concequence
            this.channels[topic] = new Subject();
        }
        return this.channels[topic].subscribe(observer);
    }
    /**
     * Publish some data to the subscribers of the given topic.
     * @param {?} topic The name of the topic to emit data to.
     * @param {?=} data data in any format to pass on.
     * @return {?}
     */
    publish(topic, data) {
        /** @type {?} */
        const subject = this.channels[topic];
        if (!subject) {
            // Or you can create a new subject for future subscribers
            return;
        }
        subject.next(data);
    }
    /**
     * When you are sure that you are done with the topic and the subscribers no longer needs to listen to a particular topic, you can
     * destroy the observable of the topic using this method.
     * @param {?} topic The name of the topic to destroy.
     * @return {?}
     */
    destroy(topic) {
        /** @type {?} */
        const subject = this.channels[topic];
        if (!subject) {
            return;
        }
        subject.complete();
        delete this.channels[topic];
    }
}
Events.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ Events.ngInjectableDef = ɵɵdefineInjectable({ factory: function Events_Factory() { return new Events(); }, token: Events, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    Events.prototype.channels;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TransferCertComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} events
     * @param {?} displayMapperService
     */
    constructor(modalCtrl, events, displayMapperService) {
        this.modalCtrl = modalCtrl;
        this.events = events;
        this.displayMapperService = displayMapperService;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // Dismiss popin if a TransferFrom event occurs
        /** @type {?} */
        const eventsSub = this.events.subscribe('TransferFrom', (/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            this.modalCtrl.dismiss();
        }));
        this.subscriptions.push(eventsSub);
        this.productInfo = this.displayMapperService.certificateDisplayMapper(this.certificate);
        this.logScreen('transfer-cert', { certificateId: this.certificateId, network: this.network, issuer: this.certificate.issuer.identity.address });
        this.generateQrCode();
    }
    /**
     * @return {?}
     */
    generateQrCode() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const link = yield this.createCertificateRequestOwnershipLink(this.certificateId);
            this.qrCodeLink = link.link;
        });
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
    /**
     * @return {?}
     */
    share() {
        this.logScreen('transfer-cert-share', { certificateId: this.certificateId, network: this.network, issuer: this.certificate.issuer.identity.address });
        this.shareLink('Share.subjectTransfer', 'Share.messageTransfer', this.qrCodeLink);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} sub
         * @return {?}
         */
        sub => sub ? sub.unsubscribe() : null));
    }
}
TransferCertComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-transfer-cert',
                template: "<lib-customizable-modal-wrapper>\n  <div class=\"inner-content\" data-e2e=\"transfer_cert\">\n    <div class=\"tf-cert-header\">\n      <div>\n        <p>\n          {{'TransferCertificate.transferCert' | translate}}\n        </p>\n      </div>\n      <div class=\"icon-close\">\n        <icon name=\"close\" size=\"2em\" (click)=\"onClickClose()\"></icon>\n      </div>\n    </div>\n\n    <div class=\"tf-cert-main\" [style.backgroundImage]=\"'url('+ (productInfo.certificateBackgroundPicture  | imageSrc | imageProxy | async) +')'\">\n\n      <div class=\"tf-cert-main-content\">\n\n        <div class=\"tf-cert-main-prod-img\">\n          <img [src]=\"productInfo.brandLogoHeaderReversed | imageSrc | imageProxy | async\" />\n        </div>\n\n        <p class=\"tf-cert-main-prod-title\">\n          {{productInfo.name}}\n        </p>\n\n        <p class=\"tf-cert-main-prod-description\" [innerHTML]=\"('productCertificate.description' | translate) | safeHtml\" *ngIf=\"0\">\n        </p>\n\n        <div class=\"tf-cert-main-prod-qr\">\n\n          <div [class.show]=\"qrCodeLink\">\n            <angular-qr-code link=\"{{qrCodeLink}}\" *ngIf=\"qrCodeLink\" data-e2e=\"qrcode\"></angular-qr-code>\n\n            <div class=\"loader\" *ngIf=\"!qrCodeLink\">\n              <lib-loading-spinner\n                [loading]=\"true\" [fullScreen]=\"false\" background=\"transparent\">\n              </lib-loading-spinner>\n            </div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n\n    <div class=\"tf-cert-footer\">\n      <lib-customizable-button\n        *ngIf=\"qrCodeLink\"\n        label=\"{{'TransferCertificate.sendToNewOwner' | translate}}\"\n        (click)=\"share()\">\n      </lib-customizable-button>\n    </div>\n  </div>\n</lib-customizable-modal-wrapper>\n",
                styles: [".inner-content{display:flex;flex-direction:column;justify-content:space-between;padding:16px}.icon-close{cursor:pointer}.tf-cert-header{display:flex;margin:16px 0;align-items:center;padding:0 16px}.tf-cert-header>div:first-child{flex:3}.tf-cert-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.2em;margin:0}.tf-cert-header>div:nth-child(2){flex:1;text-align:right}.tf-cert-header>div:nth-child(2) ion-icon{font-size:1.6em}.tf-cert-main{display:flex;height:80%;border-radius:8px;background-size:cover;background-repeat:no-repeat;background-position:top center;background-color:var(--modal-bg-color,transparent)}.tf-cert-main-content{flex-grow:1;position:relative;padding:16px;display:flex;flex-direction:column;justify-content:flex-start;align-items:center}.tf-cert-main-title{color:#fff;text-align:center;font-family:Inter-Bold;margin:0}.tf-cert-main-prod-img{text-align:center}.tf-cert-main-prod-img img{max-width:80%}.tf-cert-main-prod-description,.tf-cert-main-prod-title{text-align:center;color:var(--modal-title-color,#f93c65);font-family:var(--modal-font-family, \"Inter-Bold\");margin:10px 0}.tf-cert-main-prod-qr{text-align:center;display:flex;align-items:center;justify-content:center;height:196px}.tf-cert-main-prod-qr>div{display:flex;align-items:center;justify-content:center;margin:auto;background-color:#fff;padding:16px;overflow:hidden;box-sizing:content-box;border-radius:50%;width:24px;height:24px;transition:.4s}.tf-cert-main-prod-qr>div.show{width:160px;height:164px;border-radius:12px}.tf-cert-main-prod-qr .loader{position:relative;display:flex;width:100%;align-items:center;justify-content:center}.tf-cert-main-prod-text{text-align:center;color:#000;font-family:Inter-Bold;font-size:1em}.tf-cert-main-prod-date{font-family:Inter-Regular;font-style:italic;text-align:center;color:#fff;margin:4px 0}.tf-cert-footer{height:44px}"]
            }] }
];
/** @nocollapse */
TransferCertComponent.ctorParameters = () => [
    { type: ModalController },
    { type: Events },
    { type: DisplayMapperService }
];
TransferCertComponent.propDecorators = {
    certificateId: [{ type: Input }],
    certificate: [{ type: Input }],
    logScreen: [{ type: Input }],
    createCertificateRequestOwnershipLink: [{ type: Input }],
    shareLink: [{ type: Input }],
    network: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    TransferCertComponent.prototype.certificateId;
    /** @type {?} */
    TransferCertComponent.prototype.certificate;
    /** @type {?} */
    TransferCertComponent.prototype.logScreen;
    /** @type {?} */
    TransferCertComponent.prototype.createCertificateRequestOwnershipLink;
    /** @type {?} */
    TransferCertComponent.prototype.shareLink;
    /** @type {?} */
    TransferCertComponent.prototype.network;
    /** @type {?} */
    TransferCertComponent.prototype.productInfo;
    /** @type {?} */
    TransferCertComponent.prototype.qrCodeLink;
    /**
     * @type {?}
     * @private
     */
    TransferCertComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    TransferCertComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    TransferCertComponent.prototype.events;
    /**
     * @type {?}
     * @private
     */
    TransferCertComponent.prototype.displayMapperService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UnavailableActionModalComponent {
    /**
     * @param {?} modalCtrl
     */
    constructor(modalCtrl) {
        this.modalCtrl = modalCtrl;
    }
    /**
     * @return {?}
     */
    closeModal() {
        this.modalCtrl.dismiss().then();
    }
    /**
     * @return {?}
     */
    connectWallet() {
        this.connectToWalletClicked();
        this.closeModal();
    }
    /**
     * @return {?}
     */
    goToWallet() {
        this.goToWalletClicked();
        this.closeModal();
    }
}
UnavailableActionModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-unavailable-action-modal',
                template: "<lib-customizable-modal-wrapper>\n\n  <div class=\"header\" data-e2e=\"unavailable-action-modal\">\n    <h3 class=\"arianee-wallet-font\">{{'UnavailableActionModal.title' | translate}}</h3>\n    <ion-icon name=\"close\" (click)=\"closeModal()\"></ion-icon>\n  </div>\n\n  <div class=\"body arianee-wallet-font\">\n    <p>{{'UnavailableActionModal.description1' | translate}}</p>\n    <p>{{'UnavailableActionModal.description2' | translate}}</p>\n\n    <lib-customizable-button\n      (click)=\"connectWallet() \"\n      label=\"{{'UnavailableActionModal.linkMyWallet' | translate}}\" [displayBlock]=\"false\">\n    </lib-customizable-button>\n\n    <span class=\"divider\">{{'UnavailableActionModal.or' | translate}}</span>\n\n    <lib-customizable-button\n      (click)=\"goToWallet()\"\n      label=\"{{'UnavailableActionModal.goToMyWallet' | translate}}\" [displayBlock]=\"false\">\n    </lib-customizable-button>\n  </div>\n\n</lib-customizable-modal-wrapper>\n",
                styles: [".header{display:flex;justify-content:space-between;align-items:center;padding:16px;border-bottom:1px solid var(--modal-border-color,#e0e0e0)}.header>h3{margin:5px 0;color:var(--modal-title-color,var(--modal-text-color,#202224))}.header>ion-icon{font-size:1.6em;color:var(--modal-title-color,var(--modal-text-color,#202224))}.body{display:flex;flex-direction:column;align-items:center;padding:16px;background-color:var(--modal-bg-color,transparent)}.body>p{color:var(--modal-text-color,#202224);text-align:center;font-size:.9em}.divider{width:100%;box-sizing:border-box;padding:0 15%;margin:10px 0;display:flex;align-items:center;text-transform:uppercase;font-size:.8em;color:var(--modal-text-color,#202224)}.divider::before{content:\"\";flex:1;display:block;height:1px;background-color:var(--modal-border-color,#e0e0e0);margin-right:10px}.divider::after{content:\"\";flex:1;display:block;height:1px;background-color:var(--modal-border-color,#e0e0e0);margin-left:10px}"]
            }] }
];
/** @nocollapse */
UnavailableActionModalComponent.ctorParameters = () => [
    { type: ModalController }
];
UnavailableActionModalComponent.propDecorators = {
    connectToWalletClicked: [{ type: Input }],
    goToWalletClicked: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    UnavailableActionModalComponent.prototype.connectToWalletClicked;
    /** @type {?} */
    UnavailableActionModalComponent.prototype.goToWalletClicked;
    /**
     * @type {?}
     * @private
     */
    UnavailableActionModalComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CertificateCardModalComponent {
    /**
     * @param {?} displayMapperService
     * @param {?} modalCtrl
     */
    constructor(displayMapperService, modalCtrl) {
        this.displayMapperService = displayMapperService;
        this.modalCtrl = modalCtrl;
        this.generateProof = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            this.proofLinkModal();
            this.closeModal();
        }));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.certificateDisplay = this.displayMapperService.certificateDisplayMapper(this.certificateSummary);
    }
    /**
     * @return {?}
     */
    closeModal() {
        this.modalCtrl.dismiss();
    }
}
CertificateCardModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-certificate-card-modal',
                template: "<lib-customizable-modal-wrapper>\n\n  <div id=\"my-certificate-card-modal\" data-e2e=\"my_certificate_card_modal\">\n\n    <icon name=\"close\" size=\"2em\" color=\"#FFF\" (click)=\"closeModal()\"></icon>\n\n    <div *ngIf=\"certificateSummary\">\n      <div>\n        <div>\n          <img class=\"brand-logo\" [src]=\"certificateDisplay.brandLogoHeaderReversed\" alt=\"\">\n        </div>\n\n\n        <app-certificate-card\n          [certificate]=\"certificateSummary\"\n          [isBrandAuthentic]=\"certificateSummary.issuer.isIdentityAuthentic\"\n          [isBrandVerified]=\"certificateSummary.issuer.isIdentityVerified\"\n          [isCertificateAuthentic]=\"certificateSummary.content.isAuthentic\"\n        ></app-certificate-card>\n\n        <div class=\"buttonProof\" data-e2e=\"generate_proof_button\">\n          <lib-customizable-button (click)=\"generateProof()\" label=\"Generate proof of ownership\"></lib-customizable-button>\n        </div>\n\n\n      </div>\n    </div>\n  </div>\n\n</lib-customizable-modal-wrapper>\n\n",
                styles: ["#my-certificate-card-modal{display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:var(--modal-bg-color,#222);padding:20px}#my-certificate-card-modal>icon{cursor:pointer;align-self:flex-end}#my-certificate-card-modal .brand-logo{width:70%;display:block;margin:auto;padding-bottom:30px}#my-certificate-card-modal .buttonProof{margin-top:50px;display:flex;justify-content:center}#my-certificate-card-modal .buttonProof>ion-button{font-family:var(--font-title)}"]
            }] }
];
/** @nocollapse */
CertificateCardModalComponent.ctorParameters = () => [
    { type: DisplayMapperService },
    { type: ModalController }
];
CertificateCardModalComponent.propDecorators = {
    certificateSummary: [{ type: Input }],
    proofLinkModal: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CertificateCardModalComponent.prototype.certificateDisplay;
    /** @type {?} */
    CertificateCardModalComponent.prototype.certificateSummary;
    /** @type {?} */
    CertificateCardModalComponent.prototype.proofLinkModal;
    /** @type {?} */
    CertificateCardModalComponent.prototype.generateProof;
    /**
     * @type {?}
     * @private
     */
    CertificateCardModalComponent.prototype.displayMapperService;
    /**
     * @type {?}
     * @private
     */
    CertificateCardModalComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RequestOwnershipSuccessModalComponent {
    /**
     * @param {?} modalCtrl
     */
    constructor(modalCtrl) {
        this.modalCtrl = modalCtrl;
    }
    /**
     * @return {?}
     */
    closeModal() {
        this.modalCtrl.dismiss().then();
    }
}
RequestOwnershipSuccessModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-request-ownership-success-modal',
                template: "<lib-customizable-modal-wrapper>\n\n  <div class=\"inner-content\">\n    <div class=\"header\" data-e2e=\"request-ownership-success-modal\">\n      <h3 class=\"arianee-wallet-font\">{{'requestOwnershipModal.successTitle' | translate}}</h3>\n      <ion-icon name=\"close\" (click)=\"closeModal()\"></ion-icon>\n    </div>\n\n    <div class=\"body arianee-wallet-font\">\n      <p>{{'requestOwnershipModal.successMessage' | translate}}</p>\n    </div>\n  </div>\n\n</lib-customizable-modal-wrapper>\n",
                styles: [".header{display:flex;justify-content:space-between;align-items:center;padding:16px;border-bottom:1px solid var(--modal-border-color,#e0e0e0)}.header>h3{margin:5px 0;color:#202224}.header>ion-icon{font-size:1.6em;color:#202224}.body{display:flex;flex-direction:column;align-items:center;padding:16px;background-color:var(--modal-bg-color,transparent)}.body>p{color:var(--modal-text-color,#202224);text-align:center;font-size:.9em}"]
            }] }
];
/** @nocollapse */
RequestOwnershipSuccessModalComponent.ctorParameters = () => [
    { type: ModalController }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    RequestOwnershipSuccessModalComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RequestOwnershipFailModalComponent {
    /**
     * @param {?} modalCtrl
     */
    constructor(modalCtrl) {
        this.modalCtrl = modalCtrl;
    }
    /**
     * @return {?}
     */
    closeModal() {
        this.modalCtrl.dismiss().then();
    }
}
RequestOwnershipFailModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-request-ownership-fail-modal',
                template: "<lib-customizable-modal-wrapper>\n\n  <div class=\"header\" data-e2e=\"request-ownership-failed-modal\">\n    <h3 class=\"arianee-wallet-font\">{{'requestOwnershipModal.errorTitle' | translate}}</h3>\n    <ion-icon name=\"close\" (click)=\"closeModal()\"></ion-icon>\n  </div>\n\n  <div class=\"body arianee-wallet-font\">\n    <p>{{'requestOwnershipModal.errorMessage' | translate}}</p>\n  </div>\n\n</lib-customizable-modal-wrapper>\n",
                styles: [".header{display:flex;justify-content:space-between;align-items:center;padding:16px;border-bottom:1px solid var(--modal-border-color,#e0e0e0)}.header>h3{margin:5px 0;color:#202224}.header>ion-icon{font-size:1.6em;color:#202224}.body{display:flex;flex-direction:column;align-items:center;padding:16px;background-color:var(--modal-bg-color,transparent)}.body>p{color:var(--modal-text-color,#202224);text-align:center;font-size:.9em}"]
            }] }
];
/** @nocollapse */
RequestOwnershipFailModalComponent.ctorParameters = () => [
    { type: ModalController }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    RequestOwnershipFailModalComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TransparencyItemModalComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} photoViewer
     */
    constructor(modalCtrl, photoViewer) {
        this.modalCtrl = modalCtrl;
        this.photoViewer = photoViewer;
        this.hideMiniPreview = false;
        this.specialExternalContentType = ['resellLink', 'repairLink', 'lostLink'];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this._transparencyItem = cloneDeep(this.transparencyItem);
            if (this._transparencyItem.medias) {
                this._transparencyItem.pictures = (this._transparencyItem.pictures || []).concat(this._transparencyItem.medias
                    .filter((/**
                 * @param {?} media
                 * @return {?}
                 */
                media => media.mediaType === 'picture' && media.type === 'transparencyPicture'))
                    .map((/**
                 * @param {?} media
                 * @return {?}
                 */
                media => media.url))
                    .filter((/**
                 * @param {?} i
                 * @return {?}
                 */
                i => i !== undefined)));
                if ((this._transparencyItem.pictures || []).length <= 1) {
                    this.hideMiniPreview = true;
                }
                this._transparencyItem.medias = this._transparencyItem.medias
                    .filter((/**
                 * @param {?} media
                 * @return {?}
                 */
                media => media.mediaType !== 'picture'))
                    .map((/**
                 * @param {?} media
                 * @return {?}
                 */
                media => media))
                    .filter((/**
                 * @param {?} i
                 * @return {?}
                 */
                i => i !== undefined));
            }
            if (this._transparencyItem.externalContents) {
                this._transparencyItem.links = this._transparencyItem.externalContents.filter((/**
                 * @param {?} link
                 * @return {?}
                 */
                (link) => !this.specialExternalContentType.includes(link.type)));
            }
            this.selectMainPicture(0);
        });
    }
    /**
     * @param {?} link
     * @return {?}
     */
    linkClick(link) {
        this.onLinkClick(link);
    }
    /**
     * @param {?} link
     * @return {?}
     */
    onLinkClick(link) {
        return __awaiter(this, void 0, void 0, function* () {
            this.openBrowser(link.url);
        });
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
    /**
     * @param {?} index
     * @return {?}
     */
    selectMainPicture(index) {
        this.embedURL = null;
        this.hightlightPicture = this._transparencyItem.pictures[index];
        this.hightlightMediaIndex = null;
        this.hightlightPictureIndex = index;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    selectMedia(index) {
        this.hightlightPicture = null;
        this.embedURL = this._transparencyItem.medias[index].url;
        this.hightlightPictureIndex = null;
        this.hightlightMediaIndex = index;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    zoom(url) {
        /** @type {?} */
        const options = {
            share: false,
            // default is false
            closeButton: true,
            // default is true
            copyToReference: true,
            // default is false
            headers: '',
            // If it is not provided, it will trigger an exception
            piccasoOptions: {} // If it is not provided, it will trigger an exception
        };
        this.photoViewer.show(url, '', options);
    }
}
TransparencyItemModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-transparency-item-modal',
                template: "<div class=\"inner-content\" id=\"labelModal\">\n  <div class=\"pd-label-header\">\n    <div>\n      <p>\n        {{_transparencyItem.title }}\n      </p>\n      <p class=\"subtitle\">\n        {{_transparencyItem.subtitle }}\n      </p>\n    </div>\n    <div>\n      <ion-icon (click)=\"onClickClose()\" name=\"close\"></ion-icon>\n    </div>\n  </div>\n\n  <div class=\"pd-cert-main\">\n    <div>\n      <div *ngIf=\"hightlightPicture\" data-e2e=\"product-image\" id=\"pd-product-main-img\">\n        <img (click)=\"zoom(hightlightPicture)\" [attr.data-e2e]=\"'hightlight-'+hightlightPictureIndex\"\n             [src]=\"hightlightPicture | imageProxy | async\"/>\n\n        <div *ngIf=\"embedURL\" id=\"playerIframe\">\n          <iframe [src]=\"embedURL | safe\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\"\n                  allowfullscreen\n                  frameborder=\"0\"></iframe>\n        </div>\n      </div>\n\n      <ion-grid *ngIf=\"hightlightPicture && !hideMiniPreview\" class=\"altPictureGrid\">\n        <ion-row nowrap>\n          <ion-col *ngFor=\"let image of _transparencyItem.pictures; let index=index;\" class=\"altPictureCol\"\n                   data-e2e=\"product-pictures\">\n            <div (click)=\"selectMainPicture(index)\" [attr.data-e2e]=\"'picture-'+index\"\n                 [ngClass]=\"{'highlightedPicture':index===hightlightPictureIndex}\"\n                 class=\"altPicture\">\n              <img [src]=\"image | imageProxy | async\"/>\n            </div>\n          </ion-col>\n          <ion-col (click)=\"selectMedia(index)\" *ngFor=\"let media of _transparencyItem.medias; let index=index;\"\n                   class=\"altPictureCol\">\n            <div [ngClass]=\"{'highlightedPicture':index===hightlightMediaIndex}\" [ngStyle]=\"{'background-image': 'url(' + (media.thumbnail)  + ')'}\"\n                 class=\"videoThumbnail altPicture\"></div>\n          </ion-col>\n        </ion-row>\n      </ion-grid>\n\n      <div [innerHTML]=\"_transparencyItem.description | safeHtml\"></div>\n\n\n      <div *ngIf=\"_transparencyItem.links\" data-e2e=\"product-links\" id=\"pd-info-links\">\n\n        <p (click)=\"linkClick(link)\"\n           *ngFor=\"let link of _transparencyItem.links\"\n           class=\"pd-info-link\"\n           data-e2e=\"product-link\">\n          <a [attr.data-e2e]=\"link.type\"\n             class=\"externalLinks\"\n          > {{link.title}}</a>\n          <ion-icon color=\"primary\" item-right name=\"chevron-forward\"></ion-icon>\n\n        </p>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".inner-content{padding:0!important;background-color:#fefefe;overflow:auto}#labelModal .pd-cert-main{margin-bottom:15px;border-top:1px solid #eee;padding:8px;margin-top:20px;display:block;background-size:cover;background-repeat:no-repeat;background-position:top center;font-family:Inter-Regular;text-align:justify;overflow:auto;max-width:100%}#labelModal .pd-cert-main img{display:block;margin:0 auto}#labelModal .highlightedPicture{display:flex;justify-content:center;border:1px solid #000!important;border-radius:8px}#labelModal .altPicture{width:100px;height:100px;border:1px solid transparent}#labelModal .altPicture img{border-radius:8px;width:auto;max-width:100%;max-height:100%;margin:auto}#labelModal .altPictureGrid{padding:0}#labelModal .altPictureCol{max-width:110px}#labelModal #playerIframe{align-self:center;width:100%;padding-top:56.25%;position:relative}#labelModal #playerIframe iframe{top:0;left:0;position:absolute;width:100%;height:100%}#labelModal ion-row{overflow-y:auto;border-bottom:1px solid #202224;padding-bottom:10px;margin-bottom:10px}#labelModal ion-row ion-col{text-align:center}#labelModal ion-row ion-col>div{display:flex;border-radius:8px;overflow:hidden;align-items:center;max-height:100px}#labelModal #pd-product-main-img{text-align:center;margin-left:auto;margin-right:auto;max-width:90%;overflow:hidden;align-items:center;justify-content:center;display:flex;height:300px}#labelModal #pd-product-main-img img{border-radius:20px;max-height:100%;max-width:100%;width:290px}#labelModal .inner-content{padding:0!important}#labelModal .pd-label-header{display:flex;margin-top:16px;padding:0 16px;align-items:center}#labelModal .pd-label-header>div:first-child{flex:3}#labelModal .pd-label-header>div:first-child>.subtitle{color:#666;font-size:1em}#labelModal .pd-label-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}#labelModal .pd-label-header>div:nth-child(2){flex:1;text-align:right}#labelModal .pd-label-header>div:nth-child(2) ion-icon{font-size:2em}#labelModal .pd-cert-header{display:flex;margin:16px 0;align-items:center;padding:0 16px}#labelModal .pd-cert-header>div:first-child{flex:3}#labelModal .pd-cert-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.2em;margin:0}#labelModal .pd-cert-header>div:nth-child(2){flex:1;text-align:right}#labelModal .pd-cert-header>div:nth-child(2) ion-icon{font-size:1.6em}#labelModal #pd-info-links{font-family:Inter-Bold;color:#202224;font-size:1.2em;margin:16px 0 8px}#labelModal #pd-info-links>p:first-child{border-top:0}#labelModal #pd-info-links>p{border-top:1px solid #f1f1f1;padding-top:5px}#labelModal .pd-info-link{margin:8px 0;font-family:Inter-Regular;color:#3c9eff}#labelModal .externalLinks{cursor:pointer;text-decoration:none;font-size:.9em;color:#cd9a59}#labelModal .externalLinks.externalLinks--isNotOwner{color:rgba(205,154,89,.4)}#labelModal .pd-info-link ion-icon{font-size:24px;float:right;fill:var(--ion-color-primary)}#labelModal .center{text-align:center}#labelModal .closeModal{font-size:2em;position:absolute;top:5px;right:5px}"]
            }] }
];
/** @nocollapse */
TransparencyItemModalComponent.ctorParameters = () => [
    { type: ModalController },
    { type: PhotoViewer }
];
TransparencyItemModalComponent.propDecorators = {
    transparencyItem: [{ type: Input }],
    openBrowser: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    TransparencyItemModalComponent.prototype.transparencyItem;
    /** @type {?} */
    TransparencyItemModalComponent.prototype.openBrowser;
    /** @type {?} */
    TransparencyItemModalComponent.prototype._transparencyItem;
    /** @type {?} */
    TransparencyItemModalComponent.prototype.hideMiniPreview;
    /** @type {?} */
    TransparencyItemModalComponent.prototype.embedURL;
    /** @type {?} */
    TransparencyItemModalComponent.prototype.hightlightPicture;
    /** @type {?} */
    TransparencyItemModalComponent.prototype.hightlightMediaIndex;
    /** @type {?} */
    TransparencyItemModalComponent.prototype.hightlightPictureIndex;
    /**
     * @type {?}
     * @private
     */
    TransparencyItemModalComponent.prototype.specialExternalContentType;
    /**
     * @type {?}
     * @private
     */
    TransparencyItemModalComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    TransparencyItemModalComponent.prototype.photoViewer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductInfoTransparencyItemsComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} translate
     * @param {?} displayMapper
     */
    constructor(modalCtrl, translate, displayMapper) {
        this.modalCtrl = modalCtrl;
        this.translate = translate;
        this.displayMapper = displayMapper;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.transparencyItems = (this.displayMapper.certificateDisplayMapper(this.certificate).transparencyItems).filter((/**
             * @param {?} transparencyItem
             * @return {?}
             */
            (transparencyItem) => transparencyItem !== null));
            // this.eventLogger.logScreen('product-info-transparencyitems', { });
        });
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
    /**
     * @param {?} index
     * @return {?}
     */
    onClickViewMore(index) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.transparencyItems[index].description) {
                this.onTransparencyItemClick(this.transparencyItems[index]);
            }
        });
    }
}
ProductInfoTransparencyItemsComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-info-transparencyitems',
                template: "<lib-customizable-modal-wrapper>\n  <div class=\"inner-content\" data-e2e=\"product_history\">\n    <div class=\"pd-history-header\">\n      <div>\n        <p>\n          {{'CertificateTransparency.transparency' | translate}}\n        </p>\n      </div>\n      <div>\n        <ion-icon name=\"close\" (click)=\"onClickClose()\"></ion-icon>\n      </div>\n    </div>\n\n    <div class=\"pd-history-main\">\n      <div>\n\n        <app-events-list [events]=\"transparencyItems\" [eventType]=\"'transparency'\"\n                         (onClickViewMore)=\"onClickViewMore($event)\" [loader]=\"false\"></app-events-list>\n\n\n      </div>\n\n      <div *ngIf=\"brandLogoHeader\" class=\"pd-history-brand\">\n        <img src=\"{{brandLogoHeader}}\"/>\n      </div>\n    </div>\n  </div>\n</lib-customizable-modal-wrapper>\n\n\n",
                styles: [":host{overflow:auto}.inner-content{padding:0!important;background-color:#fefefe}.pd-history-header{display:flex;margin-top:16px;padding:0 16px;align-items:center}.pd-history-header>div:first-child{flex:3}.pd-history-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.pd-history-header>div:nth-child(2){flex:1;text-align:right}.pd-history-header>div:nth-child(2) ion-icon{font-size:2em}.pd-history-main{padding:8px;margin-top:20px;border-top:1px solid #eee;overflow:auto}.pd-history-main>p{text-align:center}.pd-history-brand{text-align:center;margin:3vh 0}.pd-history-brand>img{width:50%}.pd-history-main-item-footer{text-align:center}.ownerSince{color:#999;text-align:center;font-weight:700;margin-bottom:30px}.date{color:#999;font-family:Inter-Regular;font-size:.9em}"]
            }] }
];
/** @nocollapse */
ProductInfoTransparencyItemsComponent.ctorParameters = () => [
    { type: ModalController },
    { type: TranslateService },
    { type: DisplayMapperService }
];
ProductInfoTransparencyItemsComponent.propDecorators = {
    certificate: [{ type: Input }],
    brandLogoHeader: [{ type: Input }],
    onTransparencyItemClick: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductInfoTransparencyItemsComponent.prototype.certificate;
    /** @type {?} */
    ProductInfoTransparencyItemsComponent.prototype.brandLogoHeader;
    /** @type {?} */
    ProductInfoTransparencyItemsComponent.prototype.onTransparencyItemClick;
    /** @type {?} */
    ProductInfoTransparencyItemsComponent.prototype.transparencyItems;
    /**
     * @type {?}
     * @private
     */
    ProductInfoTransparencyItemsComponent.prototype.modalCtrl;
    /** @type {?} */
    ProductInfoTransparencyItemsComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    ProductInfoTransparencyItemsComponent.prototype.displayMapper;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WebWalletService {
    /**
     * @param {?} modalController
     * @param {?} styleService
     * @param {?} toastController
     */
    constructor(modalController, styleService, toastController) {
        this.modalController = modalController;
        this.styleService = styleService;
        this.toastController = toastController;
        this.showModal = true;
        this.subscriptions = [];
        this.loading = new Subject();
        /**
         * Open Verify Authenticity Dialog
         */
        this.openAuthenticityModal = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const modal = yield this.modalController.create({
                component: ProductCertVerifiedComponent,
                componentProps: {
                    certificateId: this.certSummary.certificateId,
                    certificate: this.certSummary,
                    logScreen: (/**
                     * @return {?}
                     */
                    () => {
                    })
                },
                cssClass: 'arianee-modal arianee-modal-transparent-bg'
            });
            return modal.present();
        }));
        /**
         * Open History Dialog
         */
        this.openHistoryModal = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const modal = yield this.modalController.create({
                component: ProductInfoHistoryComponent,
                componentProps: {
                    certificateId: this.certSummary.certificateId,
                    certificateDisplay: this.certSummary,
                    logScreen: (/**
                     * @return {?}
                     */
                    () => {
                    }),
                    address: this.wallet.address,
                    identityBase: { address: this.wallet.address, data: null },
                    events: this.certSummary.events,
                    onAcceptEvent: this.acceptEvent,
                    onDeclineEvent: this.declineEvent,
                    brandLogoHeader: brandDisplayMapper(this.certSummary.issuer.identity).brandlogo
                },
                cssClass: 'arianee-modal'
            });
            return modal.present();
        }));
        this.openTransparencyItemModal = (/**
         * @param {?} transparencyItem
         * @return {?}
         */
        (transparencyItem) => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const detailModal = yield this.modalController.create({
                component: TransparencyItemModalComponent,
                cssClass: 'auto-height middle light-round',
                componentProps: {
                    transparencyItem: transparencyItem,
                    openBrowser: (/**
                     * @param {?} url
                     * @return {?}
                     */
                    (url) => {
                        this.openBrowser(url);
                    })
                }
            });
            yield detailModal.present();
        }));
        /**
         * Open Transparency Dialog
         */
        this.openTransparencyItemsModal = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const historyModal = yield this.modalController.create({
                // eslint-disable-next-line no-undef
                component: ProductInfoTransparencyItemsComponent,
                cssClass: 'auto-height middle light-round',
                componentProps: {
                    certificate: this.certSummary,
                    onTransparencyItemClick: this.openTransparencyItemModal
                }
            });
            yield historyModal.present();
        }));
        /**
         * History Dialog Accept Event Handler
         * @param $event
         */
        this.acceptEvent = (/**
         * @param {?} $event
         * @return {?}
         */
        ($event) => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const eventId = $event[0];
            yield this.wallet.methods.acceptArianeeEvent(eventId);
        }));
        /**
         * History Dialog Decline Event Handler
         * @param $event
         */
        this.declineEvent = (/**
         * @param {?} $event
         * @return {?}
         */
        ($event) => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const eventId = $event[0];
            yield this.wallet.methods.refuseArianeeEvent(eventId);
        }));
        /**
         * Open Share Passport Dialog
         */
        this.openSharePassportModal = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            if (this.showModal) {
                /** @type {?} */
                const modal = yield this.modalController.create({
                    component: ProductInfoCertComponent,
                    componentProps: {
                        certificateId: this.certSummary.certificateId,
                        certificate: this.certSummary,
                        logScreen: (/**
                         * @return {?}
                         */
                        () => {
                        }),
                        createCertificateProofLink: this.createCertificateProofLink,
                        shareLink: this.shareLink
                    },
                    cssClass: 'arianee-modal'
                });
                return modal.present();
            }
            else {
                yield this.openActionUnavailableModal();
            }
        }));
        /**
         * Shared Passport Create Proof Link Handler
         */
        this.createCertificateProofLink = (/**
         * @return {?}
         */
        () => {
            return this.wallet.methods.createCertificateProofLink(this.certSummary.certificateId);
        });
        /**
         * Open Transfer Passport Dialog
         */
        this.openTransferPassportModal = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            if (this.showModal) {
                /** @type {?} */
                const modal = yield this.modalController.create({
                    component: TransferCertComponent,
                    componentProps: {
                        certificateId: this.certSummary.certificateId,
                        certificate: this.certSummary,
                        logScreen: (/**
                         * @return {?}
                         */
                        () => {
                        }),
                        createCertificateRequestOwnershipLink: this.createCertificateRequestOwnershipLink,
                        styleConfig: this.styleConfig,
                        shareLink: this.shareLink
                    },
                    cssClass: 'arianee-modal'
                });
                return modal.present();
            }
            else {
                yield this.openActionUnavailableModal();
            }
        }));
        /**
         * Transfer Passport Create Ship Link Handler
         */
        this.createCertificateRequestOwnershipLink = (/**
         * @return {?}
         */
        () => {
            return this.wallet.methods.createCertificateRequestOwnershipLink(this.certSummary.certificateId);
        });
        /**
         * Display Toaster with Message
         * @param subject
         * @param message
         * @param url
         */
        this.shareLink = (/**
         * @param {?} subject
         * @param {?} message
         * @param {?} url
         * @return {?}
         */
        (subject, message, url) => __awaiter(this, void 0, void 0, function* () {
            this.clipboardUrl = url;
            document.addEventListener('copy', this.copyToClipboard);
            document.execCommand('copy');
            /** @type {?} */
            const toast = yield this.toastController.create({
                message: 'The link has been successfully copied to your clipboard',
                cssClass: 'arianee-wallet-font',
                duration: 2000
            });
            toast.present();
            document.removeEventListener('copy', this.copyToClipboard);
        }));
        /**
         * Copy url to clipboard
         * @param e: Clipboard Event Object
         */
        this.copyToClipboard = (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            e.clipboardData.setData('text/plain', (this.clipboardUrl));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        /**
         * Open Unavailable Action Modal when user is not owner or non-custodial
         */
        this.openActionUnavailableModal = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            console.error('unauthorized action ! you are not the owner of this certificate.');
            /** @type {?} */
            const modal = yield this.modalController.create({
                component: UnavailableActionModalComponent,
                componentProps: {
                    connectToWalletClicked: this.connectToWalletCallback,
                    goToWalletClicked: this.goToWalletCallback
                },
                cssClass: 'arianee-modal'
            });
            return modal.present();
        }));
        this.openMyPassport = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            if (this.showModal) {
                /** @type {?} */
                const modal = yield this.modalController.create({
                    component: CertificateCardModalComponent,
                    componentProps: {
                        proofLinkModal: this.openSharePassportModal,
                        certificateSummary: this.certSummary
                    },
                    cssClass: 'arianee-modal'
                });
                return modal.present();
            }
            else {
                yield this.openActionUnavailableModal();
            }
        }));
        /**
         * Open Request Ownership Success Modal
         */
        this.requestOwnershipSuccessModal = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const modal = yield this.modalController.create({
                component: RequestOwnershipSuccessModalComponent,
                componentProps: {},
                cssClass: 'arianee-modal'
            });
            return modal.present();
        }));
        /**
         * Open Request Ownership Failed Modal
         */
        this.requestOwnershipFailedModal = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const modal = yield this.modalController.create({
                component: RequestOwnershipFailModalComponent,
                componentProps: {},
                cssClass: 'arianee-modal'
            });
            return modal.present();
        }));
        /**
         * Open link in new tab
         * @param url
         */
        this.openBrowser = (/**
         * @param {?} url
         * @return {?}
         */
        (url) => {
            window.open(url, '_blank').focus();
        });
        this.subscriptions.push(this.styleService.customStyle.subscribe((/**
         * @param {?} style
         * @return {?}
         */
        (style) => {
            this.styleConfig = style;
            this.initModalGlobalStyle(style);
        })));
    }
    /**
     * Override Ionic Modal Style
     * @param {?} configStyle
     * @return {?}
     */
    initModalGlobalStyle(configStyle) {
        /** @type {?} */
        const style = document.createElement('style');
        style.appendChild(document.createTextNode(`
    ion-modal.arianee-modal {
      position: fixed;
    }
    ion-modal.arianee-modal.mini {
      position: fixed;
    }
    ion-modal.arianee-modal div.modal-wrapper {
      background-color: #FFF;
      box-shadow: none !important;
      height: auto !important;
      border-radius: 16px;
      max-width: 90%;
    }
    /* Fix ion-page issue */
    ion-modal.arianee-modal div.modal-wrapper .ion-page {
      position: relative !important;
      contain: none !important;
    }
    ion-modal.arianee-modal-transparent-bg div.modal-wrapper {
      background-color: transparent !important;
    }
    .arianee-wallet-font {
      font-family: ${configStyle.fontFamily}!important;
    }
    div.modal-wrapper {
      overflow: auto !important;
    }
    `));
        document.getElementsByTagName('head')[0].appendChild(style);
    }
    /**
     * Request ownership
     * @return {?}
     */
    requestOwnership() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.certSummary.owner.isOwner && this.certSummary.isRequestable && this.passphrase) {
                this.loading.next(true);
                try {
                    yield this.wallet.methods.requestCertificateOwnership(this.certSummary.certificateId, this.passphrase);
                    yield this.requestOwnershipSuccessModal();
                    this.loading.next(false);
                }
                catch (e) {
                    yield this.requestOwnershipFailedModal();
                    this.loading.next(false);
                }
            }
        });
    }
}
WebWalletService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
WebWalletService.ctorParameters = () => [
    { type: ModalController },
    { type: StyleService },
    { type: ToastController }
];
if (false) {
    /** @type {?} */
    WebWalletService.prototype.showModal;
    /** @type {?} */
    WebWalletService.prototype.wallet;
    /** @type {?} */
    WebWalletService.prototype.certSummary;
    /** @type {?} */
    WebWalletService.prototype.subscriptions;
    /** @type {?} */
    WebWalletService.prototype.styleConfig;
    /** @type {?} */
    WebWalletService.prototype.connectToWalletCallback;
    /** @type {?} */
    WebWalletService.prototype.goToWalletCallback;
    /** @type {?} */
    WebWalletService.prototype.clipboardUrl;
    /** @type {?} */
    WebWalletService.prototype.loading;
    /** @type {?} */
    WebWalletService.prototype.passphrase;
    /**
     * Open Verify Authenticity Dialog
     * @type {?}
     */
    WebWalletService.prototype.openAuthenticityModal;
    /**
     * Open History Dialog
     * @type {?}
     */
    WebWalletService.prototype.openHistoryModal;
    /** @type {?} */
    WebWalletService.prototype.openTransparencyItemModal;
    /**
     * Open Transparency Dialog
     * @type {?}
     */
    WebWalletService.prototype.openTransparencyItemsModal;
    /**
     * History Dialog Accept Event Handler
     * \@param $event
     * @type {?}
     */
    WebWalletService.prototype.acceptEvent;
    /**
     * History Dialog Decline Event Handler
     * \@param $event
     * @type {?}
     */
    WebWalletService.prototype.declineEvent;
    /**
     * Open Share Passport Dialog
     * @type {?}
     */
    WebWalletService.prototype.openSharePassportModal;
    /**
     * Shared Passport Create Proof Link Handler
     * @type {?}
     */
    WebWalletService.prototype.createCertificateProofLink;
    /**
     * Open Transfer Passport Dialog
     * @type {?}
     */
    WebWalletService.prototype.openTransferPassportModal;
    /**
     * Transfer Passport Create Ship Link Handler
     * @type {?}
     */
    WebWalletService.prototype.createCertificateRequestOwnershipLink;
    /**
     * Display Toaster with Message
     * \@param subject
     * \@param message
     * \@param url
     * @type {?}
     */
    WebWalletService.prototype.shareLink;
    /**
     * Copy url to clipboard
     * \@param e: Clipboard Event Object
     * @type {?}
     */
    WebWalletService.prototype.copyToClipboard;
    /**
     * Open Unavailable Action Modal when user is not owner or non-custodial
     * @type {?}
     */
    WebWalletService.prototype.openActionUnavailableModal;
    /** @type {?} */
    WebWalletService.prototype.openMyPassport;
    /**
     * Open Request Ownership Success Modal
     * @type {?}
     */
    WebWalletService.prototype.requestOwnershipSuccessModal;
    /**
     * Open Request Ownership Failed Modal
     * @type {?}
     */
    WebWalletService.prototype.requestOwnershipFailedModal;
    /**
     * Open link in new tab
     * \@param url
     * @type {?}
     */
    WebWalletService.prototype.openBrowser;
    /** @type {?} */
    WebWalletService.prototype.modalController;
    /**
     * @type {?}
     * @private
     */
    WebWalletService.prototype.styleService;
    /** @type {?} */
    WebWalletService.prototype.toastController;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WalletActionButtonsComponent {
    /**
     * @param {?} styleService
     * @param {?} webWalletService
     */
    constructor(styleService, webWalletService) {
        this.styleService = styleService;
        this.webWalletService = webWalletService;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} s
         * @return {?}
         */
        (s) => { s.unsubscribe(); }));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.subscriptions.push(this.styleService.customStyle.subscribe((/**
         * @param {?} style
         * @return {?}
         */
        (style) => {
            this.setSpinnerColor(style);
        })));
    }
    /**
     * Set Spinner Color
     * @param {?} configStyle
     * @return {?}
     */
    setSpinnerColor(configStyle) {
        this.spinner.el.style.setProperty('--spinner-color', configStyle.spinnerColor);
    }
}
WalletActionButtonsComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-wallet-action-buttons',
                template: "<ul>\n  <li data-e2e=\"BlockchainAuthenticity\">\n    <lib-customizable-button\n      label=\"{{'walletActionButtons.BlockchainAuthenticity' | translate}}\"\n      (onClick)=\"webWalletService.openAuthenticityModal()\">\n    </lib-customizable-button>\n  </li>\n  <li data-e2e=\"WatchHistory\">\n    <lib-customizable-button\n      label=\"{{'walletActionButtons.WatchHistory' | translate}}\"\n      (onClick)=\"webWalletService.openHistoryModal()\">\n    </lib-customizable-button>\n  </li>\n  <li data-e2e=\"MyCertificate\">\n    <lib-customizable-button\n      label=\"{{'walletActionButtons.MyPassport' | translate}}\"\n      (onClick)=\"webWalletService.openMyPassport()\">\n    </lib-customizable-button>\n  </li>\n  <li data-e2e=\"SharePassport\">\n    <lib-customizable-button\n      label=\"{{'walletActionButtons.SharePassport' | translate}}\"\n      (onClick)=\"webWalletService.openSharePassportModal()\">\n    </lib-customizable-button>\n  </li>\n  <li data-e2e=\"TransferPassport\">\n    <lib-customizable-button\n      label=\"{{'walletActionButtons.TransferPassport' | translate}}\"\n      (onClick)=\"webWalletService.openTransferPassportModal()\">\n    </lib-customizable-button>\n  </li>\n  <li data-e2e=\"RequestOwnership\" *ngIf=\"webWalletService.certSummary?.isRequestable\">\n    <lib-customizable-button\n      label=\"{{'walletActionButtons.requestCertificateOwnership' | translate}}\"\n      (onClick)=\"webWalletService.requestOwnership()\">\n    </lib-customizable-button>\n  </li>\n\n  <li data-e2e=\"Transparency\" >\n    <lib-customizable-button *ngIf=\"certificateSummary && certificateSummary.content.data.transparencyItems\"\n      label=\"{{'walletActionButtons.transparency' | translate}}\"\n      (onClick)=\"webWalletService.openTransparencyItemsModal()\">\n    </lib-customizable-button>\n  </li>\n\n  <li *ngIf=\"!certificateSummary\"\n      data-e2e=\"buttons-loader\"\n      class=\"loader\">\n    <ion-spinner #spinner data-e2e=\"loader\"></ion-spinner>\n  </li>\n</ul>\n",
                styles: ["ul{position:relative;display:flex;flex-direction:column;list-style:none;padding:10px;margin:0}ul li.loader{position:absolute;top:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:100%;background-color:rgba(255,255,255,.9)}ion-spinner{--color:var(--spinner-color)}"]
            }] }
];
/** @nocollapse */
WalletActionButtonsComponent.ctorParameters = () => [
    { type: StyleService },
    { type: WebWalletService }
];
WalletActionButtonsComponent.propDecorators = {
    spinner: [{ type: ViewChild, args: ['spinner', { static: false },] }],
    wallet: [{ type: Input }],
    certificateSummary: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    WalletActionButtonsComponent.prototype.spinner;
    /** @type {?} */
    WalletActionButtonsComponent.prototype.wallet;
    /** @type {?} */
    WalletActionButtonsComponent.prototype.certificateSummary;
    /** @type {?} */
    WalletActionButtonsComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    WalletActionButtonsComponent.prototype.styleService;
    /** @type {?} */
    WalletActionButtonsComponent.prototype.webWalletService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CustomizableModalWrapperComponent {
    /**
     * @param {?} elementRef
     * @param {?} styleService
     */
    constructor(elementRef, styleService) {
        this.elementRef = elementRef;
        this.styleService = styleService;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.applyCustomStyle();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} s
         * @return {?}
         */
        (s) => s.unsubscribe()));
    }
    /**
     * Apply Custom Modal Style
     * @return {?}
     */
    applyCustomStyle() {
        this.subscriptions.push(this.styleService.customStyle.subscribe((/**
         * @param {?} styleConfig
         * @return {?}
         */
        (styleConfig) => {
            if (styleConfig.fontFamily) {
                this.elementRef.nativeElement.style.setProperty('--modal-font-family', styleConfig.fontFamily);
            }
            if (styleConfig.modal) {
                if (styleConfig.modal.bgColor) {
                    this.elementRef.nativeElement.style.setProperty('--modal-bg-color', styleConfig.modal.bgColor);
                }
                if (styleConfig.modal.borderColor) {
                    this.elementRef.nativeElement.style.setProperty('--modal-border-color', styleConfig.modal.borderColor);
                }
                if (styleConfig.modal.textColor) {
                    this.elementRef.nativeElement.style.setProperty('--modal-text-color', styleConfig.modal.textColor);
                }
                if (styleConfig.modal.titleColor) {
                    this.elementRef.nativeElement.style.setProperty('--modal-title-color', styleConfig.modal.titleColor);
                }
            }
        })));
    }
}
CustomizableModalWrapperComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-customizable-modal-wrapper',
                template: "<ng-content></ng-content>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
CustomizableModalWrapperComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: StyleService }
];
if (false) {
    /** @type {?} */
    CustomizableModalWrapperComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    CustomizableModalWrapperComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    CustomizableModalWrapperComponent.prototype.styleService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LoadingSpinnerComponent {
    /**
     * @param {?} styleService
     * @param {?} elementRef
     */
    constructor(styleService, elementRef) {
        this.styleService = styleService;
        this.elementRef = elementRef;
        this.loading = false;
        this.fullScreen = true;
        this.background = 'rgb(239, 239, 239)';
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.applySpinnerCustomColor();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} s
         * @return {?}
         */
        (s) => s.unsubscribe()));
    }
    /**
     * Apply Spinner Custom Color
     * @return {?}
     */
    applySpinnerCustomColor() {
        this.subscriptions.push(this.styleService.customStyle.subscribe((/**
         * @param {?} styleConfig
         * @return {?}
         */
        (styleConfig) => {
            if (styleConfig.spinnerColor) {
                this.elementRef.nativeElement.style.setProperty('--arianee-spinner-color', styleConfig.spinnerColor);
            }
        })));
    }
}
LoadingSpinnerComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-loading-spinner',
                template: "<div\n  *ngIf=\"loading\"\n  [class.full-screen]=\"fullScreen\"\n  [class.small]=\"smallSpinner\"\n  [ngStyle]=\"{ 'background': background }\"\n>\n</div>\n",
                styles: ["div{box-sizing:border-box;margin:0;padding:0;list-style:none;width:100%;height:100%;z-index:1001;background-color:#efefef;display:flex;align-items:center;justify-content:center}div.full-screen{position:absolute;top:0;left:0}div:after{content:\"\";display:block;width:40px;height:40px;border:4px solid #dedede;border-top-color:var(--arianee-spinner-color,#000);border-radius:50%;-webkit-animation:.8s linear infinite spin;animation:.8s linear infinite spin}div.small:after{width:24px;height:24px}@-webkit-keyframes spin{from{-webkit-transform:rotate(0)}to{-webkit-transform:rotate(360deg)}}@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}"]
            }] }
];
/** @nocollapse */
LoadingSpinnerComponent.ctorParameters = () => [
    { type: StyleService },
    { type: ElementRef }
];
LoadingSpinnerComponent.propDecorators = {
    loading: [{ type: Input }],
    fullScreen: [{ type: Input }],
    background: [{ type: Input }],
    smallSpinner: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    LoadingSpinnerComponent.prototype.loading;
    /** @type {?} */
    LoadingSpinnerComponent.prototype.fullScreen;
    /** @type {?} */
    LoadingSpinnerComponent.prototype.background;
    /** @type {?} */
    LoadingSpinnerComponent.prototype.smallSpinner;
    /** @type {?} */
    LoadingSpinnerComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    LoadingSpinnerComponent.prototype.styleService;
    /**
     * @type {?}
     * @private
     */
    LoadingSpinnerComponent.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IconComponent {
    /**
     * @param {?} http
     * @param {?} elementRef
     * @param {?} renderer
     * @param {?} platform
     * @param {?} imageSourcePipe
     */
    constructor(http, elementRef, renderer, platform, imageSourcePipe) {
        this.http = http;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.platform = platform;
        this.imageSourcePipe = imageSourcePipe;
        this.size = '24px';
        this.color = '#000';
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if ((changes.size && changes.size.currentValue) ||
            (changes.color && changes.color.currentValue)) {
            this.setIconStyle();
        }
        if (changes.name && changes.name.currentValue) {
            this.removeIcon();
            this.appendIcon();
        }
    }
    /**
     * Append Icon to the current Element
     * @return {?}
     */
    appendIcon() {
        this.getIcon().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            /** @type {?} */
            const parser = new DOMParser();
            /** @type {?} */
            const document = parser.parseFromString(data, 'text/html');
            this.svg = document.body.firstElementChild;
            this.renderer.appendChild(this.iconContainer.nativeElement, this.svg);
            this.setIconStyle();
        }));
    }
    /**
     * Apply Custom Style to current Icon
     * @return {?}
     */
    setIconStyle() {
        if (this.svg) {
            this.svg.setAttribute('fill', this.color);
            this.svg.setAttribute('width', this.size);
            this.svg.setAttribute('height', this.size);
        }
    }
    /**
     * Remove Icon
     * @return {?}
     */
    removeIcon() {
        if (this.svg) {
            this.iconContainer.nativeElement.removeChild(this.svg);
            this.svg = null;
        }
    }
    /**
     * Get SVG File as string
     * @return {?}
     */
    getIcon() {
        /** @type {?} */
        const url = this.imageSourcePipe.transform(`./svg/${this.name}.svg`);
        return this.http.get(url, { responseType: 'text' });
    }
}
IconComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-icon, icon',
                template: "\n<span #iconContainer></span>\n",
                providers: [ImageSourcePipe],
                styles: ["span{display:inline-flex;align-items:center;justify-content:center;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}"]
            }] }
];
/** @nocollapse */
IconComponent.ctorParameters = () => [
    { type: HttpClient },
    { type: ElementRef },
    { type: Renderer2 },
    { type: Platform },
    { type: ImageSourcePipe }
];
IconComponent.propDecorators = {
    iconContainer: [{ type: ViewChild, args: ['iconContainer', { static: true },] }],
    name: [{ type: Input }],
    size: [{ type: Input }],
    color: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    IconComponent.prototype.iconContainer;
    /** @type {?} */
    IconComponent.prototype.name;
    /** @type {?} */
    IconComponent.prototype.size;
    /** @type {?} */
    IconComponent.prototype.color;
    /** @type {?} */
    IconComponent.prototype.svg;
    /**
     * @type {?}
     * @private
     */
    IconComponent.prototype.http;
    /**
     * @type {?}
     * @private
     */
    IconComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    IconComponent.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    IconComponent.prototype.platform;
    /**
     * @type {?}
     * @private
     */
    IconComponent.prototype.imageSourcePipe;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CustomThemeWrapperComponent {
    /**
     * @param {?} elementRef
     * @param {?} styleService
     */
    constructor(elementRef, styleService) {
        this.elementRef = elementRef;
        this.styleService = styleService;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.applyCustomStyle();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} s
         * @return {?}
         */
        (s) => s.unsubscribe()));
    }
    /**
     * @return {?}
     */
    applyCustomStyle() {
        this.subscriptions.push(this.styleService.libraryCustomTheme.subscribe((/**
         * @param {?} theme
         * @return {?}
         */
        (theme) => {
            if (theme.fonts) {
                if (theme.fonts.text) {
                    this.elementRef.nativeElement.style.setProperty('--arianee-font-text', theme.fonts.text);
                }
                if (theme.fonts.title) {
                    this.elementRef.nativeElement.style.setProperty('--arianee-font-title', theme.fonts.title);
                }
            }
            if (theme.colors) {
                if (theme.colors.primary) {
                    this.elementRef.nativeElement.style.setProperty('--arianee-color-primary', theme.colors.primary);
                }
                if (theme.colors.secondary) {
                    this.elementRef.nativeElement.style.setProperty('--arianee-color-secondary', theme.colors.secondary);
                }
                if (theme.colors.action) {
                    this.elementRef.nativeElement.style.setProperty('--arianee-color-action', theme.colors.action);
                }
            }
        })));
    }
}
CustomThemeWrapperComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-custom-theme-wrapper',
                template: "<ng-content></ng-content>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
CustomThemeWrapperComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: StyleService }
];
if (false) {
    /** @type {?} */
    CustomThemeWrapperComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    CustomThemeWrapperComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    CustomThemeWrapperComponent.prototype.styleService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Returns the first picture (png / jpg) of a certificateDisplay accross all medias types
 * \@param certificateDisplay certificate display to extract first picture from
 * \@return the first picture or null if none
 * @type {?}
 */
const getFirstPicture = (/**
 * @param {?} certificateDisplay
 * @return {?}
 */
(certificateDisplay) => {
    // Medias whose objects are of shape { url: string; }
    /** @type {?} */
    const singleMediasProperties = ['pictures', 'medias', 'otherMedias'];
    // Medias whose objects are of shape { preview: { url: string; } asset: { ... } }
    /** @type {?} */
    const assetAndPreviewMediasProperties = ['threeDimensionalMedias', 'arMedias', 'videoMedias'];
    /** @type {?} */
    let picture = null;
    for (const property of singleMediasProperties) {
        if (picture)
            break;
        picture = get(certificateDisplay, `${property}[0]`, null);
    }
    for (const property of assetAndPreviewMediasProperties) {
        if (picture)
            break;
        picture = get(certificateDisplay, `${property}[0].preview`, null);
    }
    return picture;
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CertificateCardComponent {
    /**
     * @param {?} displayMapperService
     */
    constructor(displayMapperService) {
        this.displayMapperService = displayMapperService;
        this.hammer = Hammer;
        this.flipClass = false;
        this.certificatePicture = null;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.certificateDisplay = this.displayMapperService.certificateDisplayMapper(this.certificate);
        this.certificatePicture = getFirstPicture(this.certificateDisplay);
        /** @type {?} */
        const instance = new Hammer(this.card.nativeElement);
        instance.get('swipe').set({ direction: this.hammer.DIRECTION_HORIZONTAL, threshold: 5 });
        instance.on('swipe', (/**
         * @param {?} event
         * @return {?}
         */
        event => this.flipCard()));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isArray(value) {
        return Array.isArray(value);
    }
    /**
     * @return {?}
     */
    flipCard() {
        this.flipClass = !this.flipClass;
    }
}
CertificateCardComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-certificate-card',
                template: "<lib-custom-theme-wrapper>\n  <div #card (click)=\"flipCard()\" class=\"card\" data-e2e=\"certificate_card\">\n    <div [ngClass]=\"{'flipCard':flipClass}\" class=\"card-inner\">\n\n\n      <div class=\"card-front\">\n\n        <div class=\"pb-item\">\n          <div class=\"pb-logo\">\n            <img *ngIf=\"certificatePicture\" [src]=\"certificatePicture.url\" class=\"product\"/>\n\n            <div class=\"card-title\">{{'CertificateCard.CertificateOfOwnership' | translate}}</div>\n\n            <div class=\"product-infos\">\n\n\n              <div class=\"product-text\">\n                <div class=\"orange\">\n                  <p>{{certificateDisplay.name}}</p>\n                  <p>{{certificateDisplay.model}}</p>\n                </div>\n\n                <div *ngIf=\"isArray(certificateDisplay.serialNumber)\">\n                  <div *ngFor=\"let serialnumber of certificateDisplay.serialNumber\">\n\n                    <p *ngIf=\"serialnumber.type=='serialnumber'\" class=\"serial\">\n                      <b>{{ 'CertificateInfos.serialNumber' | translate }} :</b> {{ serialnumber.value }}</p>\n                    <p *ngIf=\"serialnumber.type=='casenumber'\" class=\"serial\">\n                      <b>{{ 'CertificateInfos.caseNumber' | translate }} : </b>{{ serialnumber.value }}</p>\n                    <p *ngIf=\"serialnumber.type=='movementnumber'\" class=\"serial\">\n                      <b>{{ 'CertificateInfos.movementNumber' | translate }} : </b>{{ serialnumber.value }}</p>\n                    <p *ngIf=\"serialnumber.type=='millesimation'\" class=\"serial\">\n                      <b>{{ 'CertificateInfos.millesimation' | translate }} : </b>{{ serialnumber.value }}</p>\n\n                  </div>\n                </div>\n\n                <div class=\"issuedBy\">\n                  <p>{{'ProductVerifiedDetails.issued_by' | translate}} {{certificateDisplay.brandName}}</p></div>\n              </div>\n\n            </div>\n\n          </div>\n          <div class=\"pb-info\">\n\n\n          </div>\n\n        </div>\n        <div class=\"arianeeLabel\">\n          <img data-e2e='validity-picture' src=\"{{'assets/imgs/img_product_cert.svg' | imageSrc}}\"/>\n        </div>\n\n      </div>\n\n      <div class=\"card-back\">\n\n        <div class=\"card-title\">\n          <div>\n            <div class=\"certified\">\n              <p>{{'CertificateCard.SecuredBy' | translate }}</p><img\n              src=\"{{'assets/imgs/logo-arianee-blanc.png' | imageSrc}}\">\n            </div>\n          </div>\n\n        </div>\n\n        <div class=\"card-verify\">\n          <div>\n            <div class=\"pd-cert-verified-content-item\">\n              <ion-icon *ngIf=\"isCertificateAuthentic\" [src]=\"'assets/imgs/md-checkmark-circle-outline.svg' | imageSrc\"\n                        class='icon icon--valid'>\n              </ion-icon>\n              <ion-icon *ngIf=\"!isCertificateAuthentic\" [src]=\"'assets/imgs/ios-close-circle-outline.svg' | imageSrc\"\n                        class='icon icon--unvalid'>\n              </ion-icon>\n              <p>\n                {{\"ProductVerifiedDetails.authentic_certificate\" | translate}}\n              </p>\n            </div>\n            <div class=\"pd-cert-verified-content-item\">\n              <ion-icon *ngIf=\"isBrandVerified\" [src]=\"'assets/imgs/md-checkmark-circle-outline.svg' | imageSrc\"\n                        class='icon icon--valid'></ion-icon>\n              <ion-icon *ngIf=\"!isBrandVerified\" [src]=\"'assets/imgs/ios-close-circle-outline.svg' | imageSrc\"\n                        class='icon icon--unvalid'></ion-icon>\n              <p>\n                {{\"ProductVerifiedDetails.verified_brand\" | translate}}\n              </p>\n            </div>\n            <div class=\"pd-cert-verified-content-item\">\n              <ion-icon *ngIf=\"isBrandAuthentic\" [src]=\"'assets/imgs/md-checkmark-circle-outline.svg' | imageSrc\"\n                        class='icon icon--valid'></ion-icon>\n              <ion-icon *ngIf=\"!isBrandAuthentic\" [src]=\"'assets/imgs/ios-close-circle-outline.svg' | imageSrc\"\n                        class='icon icon--unvalid'></ion-icon>\n              <p>\n                {{\"ProductVerifiedDetails.authentic_brand\" | translate}}\n              </p>\n            </div>\n          </div>\n        </div>\n        <div class=\"arianeeLabel\">\n          <img data-e2e='validity-picture' src=\"{{'assets/imgs/img_product_cert.svg' | imageSrc}}\"/>\n        </div>\n\n      </div>\n    </div>\n  </div>\n  <div class=\"dot\">\n    <div [ngClass]=\"{'active':!flipClass}\"></div>\n    <div [ngClass]=\"{'active':flipClass}\"></div>\n  </div>\n</lib-custom-theme-wrapper>\n",
                styles: [".pb-item>.pb-logo{max-height:250px;height:250px}.pb-item{position:relative;margin:16px 0}.pb-logo{position:relative;width:100%;border-radius:10px;overflow:hidden}.pb-logo>img{width:100%;height:100%;position:absolute;top:50%;left:50%;transform:translate(10%,-50%);-o-object-fit:cover;object-fit:cover}.card{background-color:transparent;min-width:350px;width:95%;height:250px;margin:20px auto 0;border-radius:20px;color:#fff}.card .card-inner{position:relative;width:100%;height:100%;text-align:center;transition:transform .8s;transform-style:preserve-3d}.card .card-inner .arianeeLabel{position:absolute;right:5px;bottom:5px}.card .card-inner .arianeeLabel p{margin:0 0 2px;font-size:6pt;text-align:center}.card .card-inner .arianeeLabel img{width:80%}.card .flipCard{transform:rotateY(180deg)}.card .card-back,.card .card-front{display:flex;flex-direction:column;position:absolute;width:100%;height:100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;background:linear-gradient(to right,#55555d 0,#424249 100%);border-radius:20px;box-shadow:1px 1px 2px #ababab}.card .card-front .card-title{margin:10px auto 20px;text-align:center;text-transform:uppercase;font-family:var(--arianee-font-title, \"Inter-Bold\")}.card .card-front .product-infos{position:relative;display:flex;flex-direction:row}.card .card-front .product-infos .product-image{margin-left:-5%;width:50%}.card .card-front .product-infos .product-text{position:absolute;left:33%;top:0}.card .card-front .product-infos .product-text p{text-align:left;margin:0}.card .card-front .product-infos .product-text .orange{margin:10px 0 20px;color:var(--arianee-color-secondary,#ce9917)}.card .card-front .product-infos .product-text .serial{padding-bottom:.3em;font-size:.7em}.card .card-front .product-infos .product-text .issuedBy{margin-top:20px;display:flex;align-items:center;flex-direction:row;font-size:.7em}.card .card-front .product-infos .product-text .issuedBy img{width:100px;margin-left:5px}.card .card-back{transform:rotateY(180deg)}.card .card-back .card-title{margin:20px auto;display:flex;justify-content:center;width:100%;font-family:var(--arianee-font-title, \"Inter-Bold\")}.card .card-back .card-title>div .certified{display:flex;flex-direction:row;align-items:baseline}.card .card-back .card-title>div .certified p{margin:0;font-size:1.3em}.card .card-back .card-title>div .certified img{margin-left:10px;width:100px}.card .card-back .card-title>div p{text-align:left;margin:0;font-size:.8em}.card .card-back .card-verify{margin-top:5px;display:flex;flex-direction:column;align-items:center}.card .card-back .card-verify .pd-cert-verified-content-item{display:flex;flex-direction:row;align-items:center}.card .card-back .card-verify .pd-cert-verified-content-item ion-icon{margin-right:5px}.card .card-back .card-verify .pd-cert-verified-content-item ion-icon.icon--valid{color:#3cc04a}.card .card-back .card-verify .pd-cert-verified-content-item ion-icon.icon--unvalid{color:#f93c65}.card .card-back .card-verify .pd-cert-verified-content-item p{font-size:.8em}.dot{margin-top:10px;display:flex;flex-direction:row;justify-content:center}.dot div{transition:.8s;width:10px;height:10px;margin-left:3px;background:#7f7f7f;border-radius:100%}.dot div.active{background:#fff}.product{width:100px!important;height:100px!important;left:0!important;border-radius:100px}b{font-family:var(--arianee-font-text, \"Inter-Bold\")}"]
            }] }
];
/** @nocollapse */
CertificateCardComponent.ctorParameters = () => [
    { type: DisplayMapperService }
];
CertificateCardComponent.propDecorators = {
    certificate: [{ type: Input }],
    isCertificateAuthentic: [{ type: Input }],
    isBrandVerified: [{ type: Input }],
    isBrandAuthentic: [{ type: Input }],
    card: [{ type: ViewChild, args: ['card', { static: true },] }]
};
if (false) {
    /** @type {?} */
    CertificateCardComponent.prototype.certificate;
    /** @type {?} */
    CertificateCardComponent.prototype.isCertificateAuthentic;
    /** @type {?} */
    CertificateCardComponent.prototype.isBrandVerified;
    /** @type {?} */
    CertificateCardComponent.prototype.isBrandAuthentic;
    /** @type {?} */
    CertificateCardComponent.prototype.card;
    /**
     * @type {?}
     * @private
     */
    CertificateCardComponent.prototype.hammer;
    /** @type {?} */
    CertificateCardComponent.prototype.certificateDisplay;
    /** @type {?} */
    CertificateCardComponent.prototype.flipClass;
    /** @type {?} */
    CertificateCardComponent.prototype.certificatePicture;
    /**
     * @type {?}
     * @private
     */
    CertificateCardComponent.prototype.displayMapperService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ImageRatioFullWidthDirective {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.elementRef.nativeElement.onload = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const width = this.elementRef.nativeElement.clientWidth;
            /** @type {?} */
            const height = this.elementRef.nativeElement.clientHeight;
            if (width > 0 && height > 0 && width === height) {
                this.renderer.setStyle(this.elementRef.nativeElement, 'width', '100%');
            }
        });
    }
}
ImageRatioFullWidthDirective.decorators = [
    { type: Directive, args: [{
                selector: '[libImageRatioFullWidth]'
            },] }
];
/** @nocollapse */
ImageRatioFullWidthDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    ImageRatioFullWidthDirective.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    ImageRatioFullWidthDirective.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DirectivesModule {
}
DirectivesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [ImageRatioFullWidthDirective],
                imports: [],
                exports: [ImageRatioFullWidthDirective]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const components = [
    BackCertComponent,
    BackConfirmComponent,
    BackupItemComponent,
    BackupPopoverComponent,
    CheckIconComponent,
    JazziconComponent,
    LoaderComponent,
    TitleIconComponent,
    BrandListItemComponent,
    CustomizableButtonComponent,
    WalletActionButtonsComponent,
    CustomizableModalWrapperComponent,
    UnavailableActionModalComponent,
    LoadingSpinnerComponent,
    IconComponent,
    CustomThemeWrapperComponent,
    CertificateCardComponent,
    CertificateCardModalComponent,
    RequestOwnershipFailModalComponent,
    RequestOwnershipSuccessModalComponent,
];
class CommonComponentsModule {
}
CommonComponentsModule.decorators = [
    { type: NgModule, args: [{
                declarations: components,
                imports: [
                    CommonModule,
                    IonicModule,
                    TranslateModule,
                    MomentModule,
                    FormsModule,
                    HttpClientModule,
                    PipeModule,
                    DirectivesModule
                ],
                exports: components,
                entryComponents: components
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const backupTypeEnum = {
    google: 'google',
    icloud: 'icloud',
    manual: 'manual',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const mockIdentity = (/**
 * @return {?}
 */
() => {
    /** @type {?} */
    const data = {
        name: 'brand name',
        pictures: []
    };
    return {
        isIdentityAuthentic: true,
        isIdentityVerified: true,
        imprint: 'zefzef',
        identity: {
            isAuthentic: true,
            address: 'addres',
            data,
            isApproved: true,
            imprint: 'zefzef'
        }
    };
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const mockFactoryV2 = (/**
 * @return {?}
 */
() => {
    /** @type {?} */
    const data = {
        $schema: 'https://cert.arianee.org/version1/ArianeeProductCertificate-i18n.json',
        name: 'My certificate',
        sku: 'My sku',
        gtin: 'My gtin',
        brandInternalId: 'My internal brand id',
        category: 'apparel',
        subCategory: 'shirt',
        intended: 'neutral',
        serialnumber: [{ type: 'serialnumber', value: 'serial number #12345' }, {
                type: 'casenumber',
                value: 'case number #12345'
            }, { type: 'movementnumber', value: 'movement number #12345' }],
        subBrand: 'my sub brand',
        model: 'my model',
        language: 'en-US',
        description: 'my description very very very long ...',
        subDescription: [{
                type: 'service',
                title: 'servicing title',
                content: '(servicing) my description very very very long ...',
                order: 0
            }, {
                type: 'recycling',
                title: 'recycling title',
                content: '(recycling) my description very very very long ...',
                order: 1
            }],
        externalContents: [{
                type: 'website',
                title: 'Arianee website',
                url: 'https://arianee.org',
                order: 0
            }, { type: 'other', title: 'Arianee docs', url: 'https://docs.arianee.org', order: 1 }],
        i18n: [{
                language: 'fr-FR',
                description: 'ma description',
                subDescription: [{
                        type: 'service',
                        title: 'service titre description',
                        content: 'description service contenu',
                        order: 0
                    }, { type: 'recycling', title: 'recyclage titre description', content: 'description recyclage contenu', order: 1 }],
                externalContents: [{
                        type: 'website',
                        title: 'Site arianee',
                        url: 'https://arianee.org',
                        order: 0
                    }, { type: 'other', title: 'Documentation arianee', url: 'https://docs.arianee.org', order: 1 }]
            }],
        msrp: [{ msrp: '1000', currency: 'EUR', msrpCountry: 'FRA' }, { msrp: '1100', currency: 'USD', msrpCountry: 'USA' }],
        medias: [{
                mediaType: 'picture',
                type: 'product',
                url: 'https://www.arianee.org/wp-content/uploads/2019/02/Screen-Shot-2019-02-27-at-12.12.53-PM.png',
                order: 0
            }, {
                mediaType: 'picture',
                type: 'product',
                url: 'https://www.arianee.org/wp-content/uploads/2019/02/Screen-Shot-2019-02-27-at-12.14.36-PM.png',
                order: 1
            }],
        attributes: [{ type: 'color', value: 'red' }, { type: 'material', value: 'leather' }],
        materials: [{ material: 'cashmere', value: 'white', pourcentage: '10' }, {
                material: 'denim-jeans',
                value: 'blue',
                pourcentage: '90'
            }],
        size: [{ type: 'depth', value: 'XXXXL', unit: 'us' }],
        manufacturingCountry: 'FRA',
        facilityId: 'facility id',
        productCertification: [{ name: 'fairtrade' }, { name: 'wwf' }]
    };
    return {
        owner: (/** @type {?} */ ({
            isOwner: true
        })),
        issuer: mockIdentity(),
        certificateId: '2',
        content: {
            imprint: 'mockImprint',
            isAuthentic: true,
            data,
            raw: {}
        }
    };
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const mapperChecker = (/**
 * @param {?} certificate
 * @param {?} model
 * @return {?}
 */
(certificate, model) => {
    /** @type {?} */
    const areMatching = Object.keys(model)
        .map((/**
     * @param {?} key
     * @return {?}
     */
    key => {
        /** @type {?} */
        const propertyName = model[key];
        /** @type {?} */
        const value = certificate[propertyName];
        if (value === undefined) {
            console.error('missing', propertyName);
        }
        return value;
    }))
        .filter((/**
     * @param {?} value
     * @return {?}
     */
    value => value === undefined));
    return areMatching.length === 0;
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TranslationService {
    constructor() {
        // These names should match files name in assets/i18n/*.json
        this.availableLanguages = [
            'en-US', 'fr-FR', 'de', 'ko-KR', 'zh-CN', 'zh-TW', 'ja-JP', 'es', 'it', 'pt', 'ru'
        ];
        this.macros = ['fr-FR', 'en-US', 'ko-KR', 'ja-JP'];
        this.defaultLanguage = 'en-US';
    }
    /**
     * @param {?=} forcedLanguage
     * @return {?}
     */
    pickLanguageAccordingToUserLanguages(forcedLanguage) {
        /** @type {?} */
        const userLanguages = forcedLanguage || (/** @type {?} */ (navigator.languages));
        return pickLanguageAccordingToUserLanguagesWithMacrosFallback(this.macros, userLanguages, this.availableLanguages, this.defaultLanguage);
    }
}
TranslationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ TranslationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function TranslationService_Factory() { return new TranslationService(); }, token: TranslationService, providedIn: "root" });
if (false) {
    /** @type {?} */
    TranslationService.prototype.availableLanguages;
    /**
     * @type {?}
     * @private
     */
    TranslationService.prototype.macros;
    /** @type {?} */
    TranslationService.prototype.defaultLanguage;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DeclareLostComponent {
    /**
     * @param {?} modalCtrl
     */
    constructor(modalCtrl) {
        this.modalCtrl = modalCtrl;
        this.subscriptions = [];
        this.isInquirus = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.logScreen) {
                this.logScreen('declare-lost', { certificateId: this.certificateId });
            }
            this.brandNameTranslation = { brandname: brandName(this.certificate.issuer.identity) };
            if (this.brandNameTranslation.brandname === 'Vacheron Constantin') {
                this.isInquirus = true;
            }
        });
    }
    /**
     * @return {?}
     */
    toggleIsLost() {
        return __awaiter(this, void 0, void 0, function* () {
            this.onToggleLost(this.isLost);
        });
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss(this.isLost);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} sub
         * @return {?}
         */
        sub => sub.unsubscribe()));
    }
}
DeclareLostComponent.decorators = [
    { type: Component, args: [{
                template: "<div class=\"inner-content\" data-e2e=\"declare-lost\">\n  <div class=\"tf-cert-header\">\n    <div>\n      <p>\n        {{'DeclareMissing.title' | translate}}\n      </p>\n    </div>\n    <div>\n      <ion-icon name=\"close\" (click)=\"onClickClose()\" data-e2e=\"close\"></ion-icon>\n    </div>\n  </div>\n\n    <ion-item *ngIf=\"this.isLost!==undefined\" lines=\"none\"\n              [attr.data-e2e]=\"'lost_value_'+this.isLost\"\n    >\n        <ion-label>{{'DeclareMissing.label' | translate}}</ion-label>\n        <ion-toggle color=\"primary\" [checked]=\"this.isLost\"\n                    (ionChange)=\"toggleIsLost()\"\n                    [(ngModel)]=\"this.isLost\"\n                    data-e2e=\"lost-toggle\"></ion-toggle>\n      </ion-item>\n</div>\n",
                styles: [".inner-content{display:flex;flex-direction:column;justify-content:space-between;padding:16px}.tf-cert-header{display:flex;margin:16px 0;align-items:center;padding:0 16px}.tf-cert-header>div:first-child{flex:3}.tf-cert-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.2em;margin:0}.tf-cert-header>div:nth-child(2){flex:1;text-align:right}.tf-cert-header>div:nth-child(2) ion-icon{font-size:1.6em}.tf-cert-main{display:flex;height:80%;border-radius:8px;background-size:cover;background-repeat:no-repeat;background-position:top center}.tf-cert-main-content{flex-grow:1;position:relative;padding:16px;display:flex;flex-direction:column;justify-content:flex-start}.tf-cert-main-title{color:#fff;text-align:center;font-family:Inter-Bold;margin:0}.tf-cert-main-prod-img{text-align:center;margin-bottom:3vh}.tf-cert-main-prod-img img{max-width:80%}.tf-cert-main-prod-description,.tf-cert-main-prod-title{text-align:center;color:#f93c65;font-family:Inter-Bold;margin:4px 0;font-size:1.4em}.tf-cert-main-prod-qr{text-align:center}.tf-cert-main-prod-qr>div{display:flex;margin:auto;background-color:#fff;padding:16px;border-radius:12px;overflow:hidden;width:60%}.tf-cert-main-prod-qr .loader{display:flex;width:100%;height:160px;align-items:center;justify-content:center}.tf-cert-main-prod-text{text-align:center;color:#000;font-family:Inter-Bold;font-size:1em}.tf-cert-main-prod-date{font-family:Inter-Regular;font-style:italic;text-align:center;color:#fff;margin:4px 0}.tf-cert-footer{padding:0 16px}"]
            }] }
];
/** @nocollapse */
DeclareLostComponent.ctorParameters = () => [
    { type: ModalController }
];
DeclareLostComponent.propDecorators = {
    certificateId: [{ type: Input }],
    certificate: [{ type: Input }],
    onToggleLost: [{ type: Input }],
    isLost: [{ type: Input }],
    logScreen: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    DeclareLostComponent.prototype.certificateId;
    /** @type {?} */
    DeclareLostComponent.prototype.certificate;
    /** @type {?} */
    DeclareLostComponent.prototype.onToggleLost;
    /** @type {?} */
    DeclareLostComponent.prototype.isLost;
    /** @type {?} */
    DeclareLostComponent.prototype.logScreen;
    /**
     * @type {?}
     * @private
     */
    DeclareLostComponent.prototype.subscriptions;
    /** @type {?} */
    DeclareLostComponent.prototype.brandNameTranslation;
    /** @type {?} */
    DeclareLostComponent.prototype.isInquirus;
    /**
     * @type {?}
     * @private
     */
    DeclareLostComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductInfoComponent {
    /**
     * @param {?} modalCtrl
     */
    constructor(modalCtrl) {
        this.modalCtrl = modalCtrl;
        this.productDetail = {
            title: 'Duomètre',
            description: 'Quantième Lunaire',
            property: [
                {
                    key: 'Jaeger-LeCoultre Calibre',
                    value: '381'
                },
                {
                    key: 'Case',
                    value: 'Pink Gold'
                },
                {
                    key: 'Water-resistance',
                    value: '5 bar'
                },
                {
                    key: 'Diameter',
                    value: '42mm'
                },
                {
                    key: 'Functions',
                    value: 'Date, Hour - Minute, Moon phases, Flyback seconds, Seconds, Jumping seconds, Twin Power-Reserve'
                },
                {
                    key: 'Recto Hands',
                    value: 'Feuille'
                },
                {
                    key: 'Movement',
                    value: 'Manual-winding'
                },
                {
                    key: 'Components',
                    value: '374'
                },
                {
                    key: 'Vibrations per hour',
                    value: '374'
                }
            ]
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
}
ProductInfoComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-info',
                template: "<div class=\"inner-content\">\n  <div class=\"pd-comp-header\">\n    <div>\n      <p>\n        {{productDetail.title}}\n      </p>\n      <p>\n        {{productDetail.description}}\n      </p>\n    </div>\n    <div>\n      <ion-icon name=\"close\" (click)=\"onClickClose()\"></ion-icon>\n    </div>\n  </div>\n\n  <div class=\"pd-comp-main\">\n    <div class=\"pd-comp-main-description\">\n      <p class=\"pd-comp-text\">\n        {{'CertificateInfos.description' | translate}}\n      </p>\n    </div>\n\n    <div class=\"pd-comp-main-techinfo\">\n      <p class=\"pd-comp-text\">\n        {{'CertificateInfos.techDetail' | translate}}\n      </p>\n      <div *ngFor=\"let property of productDetail.property\">\n        <span class=\"pd-comp-property-title\">{{property.key}}: </span><span class=\"pd-comp-property-value\">{{property.value}}</span>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [".inner-content{padding:16px!important}.pd-comp-header{display:flex;border-bottom:1px solid #cacaca}.pd-comp-header p{color:#202224;font-family:Inter-Bold;font-size:1.4em}.pd-comp-header>div:first-child{flex:5}.pd-comp-header>div:first-child>p{margin:8px 0}.pd-comp-header>div:nth-child(2){flex:1;text-align:right}.pd-comp-header>div:nth-child(2) ion-icon{font-size:2em}.pd-comp-main-description{margin-top:6vh}.pd-comp-main-description>p:nth-child(2){color:rgba(32,34,36,.6);font-family:Inter-Regular}.pd-comp-text{color:#202224;font-family:Inter-Bold;text-transform:capitalize}.pd-comp-property-title{font-family:Inter-Bold;color:rgba(32,34,36,.6)}.pd-comp-property-value{font-family:Inter-Regular;color:rgba(32,34,36,.6)}.pd-comp-main-techinfo{margin-top:6vh;margin-bottom:4vh}"]
            }] }
];
/** @nocollapse */
ProductInfoComponent.ctorParameters = () => [
    { type: ModalController }
];
if (false) {
    /** @type {?} */
    ProductInfoComponent.prototype.productDetail;
    /**
     * @type {?}
     * @private
     */
    ProductInfoComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProdPopoverComponent {
    /**
     * @param {?} styleService
     */
    constructor(styleService) {
        this.styleService = styleService;
        this.subscription = Subscription.EMPTY;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.subscription = this.styleService.libraryCustomTheme
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            this.externalFontFamily = data.fonts && data.fonts.text ? data.fonts.text : '';
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * @param {?} index
     * @return {?}
     */
    clickItem(index) {
        this.onClickItem(index);
    }
}
ProdPopoverComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-prod-popover',
                template: "<div class=\"prod-popover\" data-e2e=\"popover\">\n  <ng-container *ngFor=\"let item of actionMenuItems; let i = index;\">\n    <ion-item  button=true (click)=\"clickItem(i)\" [attr.data-e2e]=\"item.e2e\" >\n      <ion-label [style.font-family]=\"externalFontFamily\">{{item.title | translate}}</ion-label>\n    </ion-item>\n  </ng-container>\n\n</div>\n",
                styles: [".prod-popover ion-label{color:#202224;font-family:Inter-Bold}.popoverMore .popover-content{width:820px!important}"]
            }] }
];
/** @nocollapse */
ProdPopoverComponent.ctorParameters = () => [
    { type: StyleService }
];
ProdPopoverComponent.propDecorators = {
    actionMenuItems: [{ type: Input }],
    onClickItem: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProdPopoverComponent.prototype.actionMenuItems;
    /** @type {?} */
    ProdPopoverComponent.prototype.onClickItem;
    /** @type {?} */
    ProdPopoverComponent.prototype.subscription;
    /** @type {?} */
    ProdPopoverComponent.prototype.externalFontFamily;
    /** @type {?} */
    ProdPopoverComponent.prototype.subCategory;
    /**
     * @type {?}
     * @private
     */
    ProdPopoverComponent.prototype.styleService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductInfoResellComponent {
    /**
     * @param {?} modalCtrl
     */
    constructor(modalCtrl) {
        this.modalCtrl = modalCtrl;
        this.resellItems = [
            'assets/imgs/img_resell1.png',
            'assets/imgs/img_resell2.png',
            'assets/imgs/img_resell3.png'
        ];
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
}
ProductInfoResellComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-info-resell',
                template: "<div class=\"inner-content\">\n  <div class=\"pd-resell-header\">\n    <div>\n      <p>\n        {{'CertificateInfos.resell' | translate}}\n      </p>\n    </div>\n    <div>\n      <ion-icon name=\"close\" (click)=\"onClickClose()\"></ion-icon>\n    </div>\n  </div>\n\n  <div class=\"pd-resell-main\">\n    <div *ngFor=\"let image of resellItems\">\n      <img [src]=\"image\" />\n    </div>\n  </div>\n</div>",
                styles: [".inner-content{padding:16px}.pd-resell-header{display:flex;margin-top:16px;align-items:center}.pd-resell-header>div:first-child{flex:3}.pd-resell-header>div:first-child>p{color:#202224;font-family:Inter-Bold;margin:0;font-size:1.4em}.pd-resell-header>div:nth-child(2){flex:1;text-align:right}.pd-resell-header>div:nth-child(2)>ion-icon{font-size:2em}.pd-resell-main{text-align:center;margin-top:4vh}.pd-resell-main>div{display:inline-block}"]
            }] }
];
/** @nocollapse */
ProductInfoResellComponent.ctorParameters = () => [
    { type: ModalController }
];
if (false) {
    /** @type {?} */
    ProductInfoResellComponent.prototype.resellItems;
    /**
     * @type {?}
     * @private
     */
    ProductInfoResellComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductInfoPGeneveComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} translateService
     * @param {?} displayMapperService
     */
    constructor(modalCtrl, translateService, displayMapperService) {
        this.modalCtrl = modalCtrl;
        this.translateService = translateService;
        this.displayMapperService = displayMapperService;
        this.togglePanel = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.events = [
                { title: this.translateService.instant('PGeneve.Provenance'), subtitle: this.translateService.instant('PGeneve.genevamade'), type: 'type', id: 1, date: null, viewdetail: true, avatar: 'no', detail: { description: this.translateService.instant('PGeneve.ProvenanceDescription') } },
                { title: this.translateService.instant('PGeneve.Craftmanship'), subtitle: this.translateService.instant('PGeneve.workofart'), type: 'type', id: 1, date: null, viewdetail: true, avatar: 'no', detail: { description: this.translateService.instant('PGeneve.CraftmanshipDescription') } },
                { title: this.translateService.instant('PGeneve.Reliability'), subtitle: this.translateService.instant('PGeneve.testedforquality'), type: 'type', id: 1, date: null, viewdetail: true, avatar: 'no', detail: { description: this.translateService.instant('PGeneve.ReliabilityDescription') } }
            ];
            this.pgeneve = this.displayMapperService.certificateDisplayMapper(this.certificate).pgeneve;
            this.logScreen('product-info-pgeneve', {});
        });
    }
    /**
     * @param {?} index
     * @return {?}
     */
    openPanel(index) {
        this.currentIndex = index;
        this.togglePanel = true;
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
    /**
     * @param {?} index
     * @return {?}
     */
    clickViewMore(index) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.events[index].detail.htmlPage) {
                this.onClickViewMore({
                    labelOverride: {
                        description: this.events[index].detail.htmlPage
                    },
                    labelTitle: this.events[index].title
                });
            }
        });
    }
    /**
     * @return {?}
     */
    onClickUniqueId() {
        this.openBrowser(this.pgeneveUrl + this.pgeneve);
    }
    /**
     * @return {?}
     */
    openPgeneve() {
        this.openBrowser('https://poincondegeneve.ch/en');
    }
}
ProductInfoPGeneveComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-info-pgeneve',
                template: "<div class=\"inner-content\" data-e2e=\"product_history\">\n  <div class=\"pd-history-header\">\n    <div>\n      <p>\n        <img (click)=\"openPgeneve()\" src=\"{{'/assets/imgs/pgeneve2.png' | imageSrc}}\" />\n      </p>\n    </div>\n    <div>\n      <ion-icon name=\"close\" (click)=\"onClickClose()\"></ion-icon>\n    </div>\n  </div>\n\n  <div class=\"pd-history-main\">\n    <div id=\"congrats\" [innerHTML]=\"('PGeneve.congrats' | translate) | safeHtml\"></div>\n    <div id=\"oldest\" [innerHTML]=\"('PGeneve.oldest' | translate) | safeHtml\"></div>\n\n    <div id=\"uniquecode\">\n      {{\"PGeneve.UniqueAuthenticationCode\" | translate}} : <br/><span class=\"uniqueid\" (click)=\"onClickUniqueId()\">{{pgeneve}}</span>\n    </div>\n    <div>\n      <app-events-list [isSlide]=\"false\" [eventType]=\"'pgeneve'\" [events]=\"events\" (onClickViewMore)=\"onClickViewMore($event);openPanel($event)\" [loader]=\"false\"></app-events-list>\n    </div>\n\n  </div>\n</div>\n\n<!-- Hidden pgeneve Panel -->\n<!--------------------------->\n<ul class=\"pgeneve-slides index-{{currentIndex}}\" [class.open]=\"togglePanel\">\n  <li *ngIf=\"currentIndex || currentIndex === 0\">\n\n    <div class=\"header\">\n      <span class=\"title\">{{events[currentIndex].title}}</span>\n      <ion-icon name=\"close\" color=\"black\" class=\"iconSize\" (click)=\"togglePanel = false\"></ion-icon>\n    </div>\n\n    <div class=\"body\" [innerHTML]=\"events[currentIndex].detail.description | safeHtml\"></div>\n  </li>\n</ul>\n\n\n",
                styles: [":host ::ng-deep table.pgeneve-table{margin-bottom:10px}:host ::ng-deep table.pgeneve-table td{vertical-align:top}:host ::ng-deep table.pgeneve-table span.title{font-weight:700;margin-bottom:5px}:host ::ng-deep table.pgeneve-table p{margin:0 0 3px}:host ::ng-deep table.pgeneve-table ul{padding:0;margin:0;list-style:none}:host ::ng-deep table.pgeneve-table ul li{padding-left:10px}:host ::ng-deep table.pgeneve-table ul li:before{content:\"-\";margin-right:5px;margin-left:-10px}:host ::ng-deep table.pgeneve-table span.img{border-radius:10px;margin-right:10px;display:block;height:80px;width:80px;background-size:cover}:host ::ng-deep table.pgeneve-table.origin:first-child span.img{background-image:url(/assets/imgs/pgeneve/origin1.jpg)}:host ::ng-deep table.pgeneve-table.origin:nth-child(2) span.img{background-image:url(/assets/imgs/pgeneve/origin2.jpg)}:host ::ng-deep table.pgeneve-table.origin:nth-child(3) span.img{background-image:url(/assets/imgs/pgeneve/origin3.jpg)}:host ::ng-deep table.pgeneve-table.origin:nth-child(4) span.img{background-image:url(/assets/imgs/pgeneve/origin4.jpg)}:host ::ng-deep table.pgeneve-table.watchmaking:first-child span.img{background-image:url(/assets/imgs/pgeneve/watchmaking1.jpg)}:host ::ng-deep table.pgeneve-table.reliability:first-child span.img{background-image:url(/assets/imgs/pgeneve/reliability1.jpg)}:host ::ng-deep table.pgeneve-table.reliability:nth-child(2) span.img{background-image:url(/assets/imgs/pgeneve/reliability2.jpg)}:host ::ng-deep table.pgeneve-table.reliability:nth-child(3) span.img{background-image:url(/assets/imgs/pgeneve/reliability3.jpg)}:host ::ng-deep table.pgeneve-table.reliability:nth-child(4) span.img{background-image:url(/assets/imgs/pgeneve/reliability4.jpg)}ul.pgeneve-slides{display:flex;width:100%;height:100%;position:absolute;top:0;left:0;margin:0;padding:0;border-radius:15px;overflow:hidden;overflow-y:auto;z-index:3;transform:translateX(110%);transition:transform .3s ease-in-out;background-size:cover}ul.pgeneve-slides.open{transform:translateX(0)}ul.pgeneve-slides.index-0{background-image:url(/assets/imgs/Origin.jpg)}ul.pgeneve-slides.index-1{background-image:url(/assets/imgs/High_Watchmaking.jpg)}ul.pgeneve-slides.index-2{background-image:url(/assets/imgs/Reliability.jpg)}ul.pgeneve-slides li{width:100%;min-height:100%;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;background-color:#fffD;padding:10px}ul.pgeneve-slides li>.header{display:flex;align-items:center;margin-bottom:20px}ul.pgeneve-slides li>.header .title{flex:1;font-size:1.5em;color:#bea182;font-family:PreloCondensed-Medium;text-transform:uppercase}ul.pgeneve-slides li>.header ion-icon{font-size:1.5em}.inner-content{padding:0!important;background-color:#fefefe}.pd-history-header{display:flex;margin-top:16px;padding:0 16px;align-items:center}.pd-history-header>div:first-child{flex:3}.pd-history-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.pd-history-header>div:nth-child(2){text-align:right}.pd-history-header>div:nth-child(2) ion-icon{font-size:2em}.pd-history-main{padding:8px;margin-top:20px;border-top:1px solid #eee;overflow:hidden!important}.pd-history-main>p{text-align:center}.pd-history-brand{text-align:center;margin:3vh 0}.pd-history-main-item-footer{text-align:center}.ownerSince{color:#999;text-align:center;font-weight:700;margin-bottom:30px}.date{color:#999;font-family:Inter-Regular;font-size:.9em}#uniquecode{font-family:PreloCondensed-Light;padding-bottom:5px;background-image:url(/assets/imgs/PGE-Seal.png);background-repeat:no-repeat;background-size:contain;background-position-y:0;font-weight:700;height:45px;display:flex;flex-direction:column;align-items:center;justify-content:center}.uniqueid{text-decoration:underline;font-family:PreloCondensed-Light;color:#bea182}.pd-geneve-intro{color:#666;font-family:Inter-Regular;font-size:.9em;margin-top:5px}.subtitle{font-size:30px}#congrats{text-align:center;font-family:PreloCondensed-Light;padding-bottom:10px;font-weight:700}#oldest{text-align:center;font-family:PreloCondensed-Light;padding-bottom:10px}"]
            }] }
];
/** @nocollapse */
ProductInfoPGeneveComponent.ctorParameters = () => [
    { type: ModalController },
    { type: TranslateService },
    { type: DisplayMapperService }
];
ProductInfoPGeneveComponent.propDecorators = {
    certificate: [{ type: Input }],
    logScreen: [{ type: Input }],
    openBrowser: [{ type: Input }],
    onClickViewMore: [{ type: Input }],
    pgeneveUrl: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductInfoPGeneveComponent.prototype.certificate;
    /** @type {?} */
    ProductInfoPGeneveComponent.prototype.logScreen;
    /** @type {?} */
    ProductInfoPGeneveComponent.prototype.openBrowser;
    /** @type {?} */
    ProductInfoPGeneveComponent.prototype.onClickViewMore;
    /** @type {?} */
    ProductInfoPGeneveComponent.prototype.pgeneveUrl;
    /** @type {?} */
    ProductInfoPGeneveComponent.prototype.events;
    /** @type {?} */
    ProductInfoPGeneveComponent.prototype.pgeneve;
    /** @type {?} */
    ProductInfoPGeneveComponent.prototype.currentIndex;
    /** @type {?} */
    ProductInfoPGeneveComponent.prototype.togglePanel;
    /**
     * @type {?}
     * @private
     */
    ProductInfoPGeneveComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    ProductInfoPGeneveComponent.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    ProductInfoPGeneveComponent.prototype.displayMapperService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductInfoSwissMadeComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} translateService
     */
    constructor(modalCtrl, translateService) {
        this.modalCtrl = modalCtrl;
        this.translateService = translateService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.events = [
                { title: this.translateService.instant('SwissMade.Provenance'), subtitle: this.translateService.instant('SwissMade.genevamade'), type: 'type', id: 1, date: null, viewdetail: true, avatar: 'no', detail: { description: this.translateService.instant('SwissMade.ProvenanceDescription') } },
                { title: this.translateService.instant('SwissMade.Craftmanship'), subtitle: this.translateService.instant('SwissMade.workofart'), type: 'type', id: 1, date: null, viewdetail: true, avatar: 'no', detail: { description: this.translateService.instant('SwissMade.CraftmanshipDescription') } },
                { title: this.translateService.instant('SwissMade.Reliability'), subtitle: this.translateService.instant('SwissMade.testedforquality'), type: 'type', id: 1, date: null, viewdetail: true, avatar: 'no', detail: { description: this.translateService.instant('SwissMade.ReliabilityDescription') } }
            ];
            this.logScreen('product-info-swissmade', {});
        });
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
    /**
     * @param {?} index
     * @return {?}
     */
    clickViewMore(index) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.events[index].detail.htmlPage) {
                this.onClickViewMore({
                    labelOverride: {
                        description: this.events[index].detail.htmlPage
                    },
                    labelTitle: this.events[index].title
                });
            }
        });
    }
    /**
     * @return {?}
     */
    onClickUniqueId() {
        // this.browserService.openBrowser(environment.swissmadeUrl + this.swissmade);
    }
    /**
     * @return {?}
     */
    openPgeneve() {
        this.openBrowser('https://poincondegeneve.ch/en');
    }
}
ProductInfoSwissMadeComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-info-swissmade',
                template: "<div class=\"inner-content\" data-e2e=\"product_history\">\n  <div class=\"pd-history-header\">\n    <div>\n      <p>\n        <img (click)=\"openPgeneve()\" src=\"{{'assets/imgs/swiss-made06.png' | imageSrc}}\" />\n      </p>\n    </div>\n    <div>\n      <ion-icon name=\"close\" (click)=\"onClickClose()\"></ion-icon>\n    </div>\n  </div>\n\n  <div class=\"pd-history-main\">\n    <div id=\"congrats\" [innerHTML]=\"('SwissMade.congrats' | translate) | safeHtml\"></div>\n    <div id=\"oldest\" [innerHTML]=\"('SwissMade.oldest' | translate) | safeHtml\"></div>\n\n    <div id=\"uniquecode\">\n      {{\"SwissMade.UniqueAuthenticationCode\" | translate}}<br/><span class=\"uniqueid\" (click)=\"onClickUniqueId()\">{{swissmade}}</span>\n    </div>\n    <div>\n      <app-events-list [isSlide]=true [eventType]=\"'swissmade'\" [events]=\"events\" (onClickViewMore)=\"onClickViewMore($event)\" [loader]=\"false\"></app-events-list>\n    </div>\n\n  </div>\n</div>\n\n\n",
                styles: [".inner-content{padding:0!important;background-color:#fefefe}.pd-history-header{display:flex;margin-top:16px;padding:0 16px;align-items:center}.pd-history-header>div:first-child{flex:3}.pd-history-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.pd-history-header>div:nth-child(2){flex:1;text-align:right}.pd-history-header>div:nth-child(2) ion-icon{font-size:2em}.pd-history-main{padding:8px;margin-top:20px;border-top:1px solid #eee;overflow:hidden!important}.pd-history-main>p{text-align:center}.pd-history-brand{text-align:center;margin:3vh 0}.pd-history-main-item-footer{text-align:center}.ownerSince{color:#999;text-align:center;font-weight:700;margin-bottom:30px}.date{color:#999;font-family:Inter-Regular;font-size:.9em}#uniquecode{font-family:PreloCondensed-Light;padding-bottom:5px;background-position-y:-30px;background-repeat:no-repeat;background-size:contain;background-position-y:0;font-size:1em;text-align:center;background-image:url(/assets/imgs/swiss-made-logo.png);margin-bottom:10px}.uniqueid{text-decoration:underline;font-family:PreloCondensed-Light}.pd-geneve-intro{color:#666;font-family:Inter-Regular;font-size:.9em;margin-top:5px}.subtitle{font-size:30px}#congrats,#oldest{text-align:center;font-family:PreloCondensed-Light;padding-bottom:10px}"]
            }] }
];
/** @nocollapse */
ProductInfoSwissMadeComponent.ctorParameters = () => [
    { type: ModalController },
    { type: TranslateService }
];
ProductInfoSwissMadeComponent.propDecorators = {
    swissmade: [{ type: Input, args: ['jsonswissmadeUrl',] }],
    brandName: [{ type: Input, args: ['brandName',] }],
    logScreen: [{ type: Input }],
    openBrowser: [{ type: Input }],
    onClickViewMore: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductInfoSwissMadeComponent.prototype.swissmade;
    /** @type {?} */
    ProductInfoSwissMadeComponent.prototype.brandName;
    /** @type {?} */
    ProductInfoSwissMadeComponent.prototype.logScreen;
    /** @type {?} */
    ProductInfoSwissMadeComponent.prototype.openBrowser;
    /** @type {?} */
    ProductInfoSwissMadeComponent.prototype.onClickViewMore;
    /** @type {?} */
    ProductInfoSwissMadeComponent.prototype.events;
    /**
     * @type {?}
     * @private
     */
    ProductInfoSwissMadeComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    ProductInfoSwissMadeComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function LineI() { }
if (false) {
    /** @type {?} */
    LineI.prototype.angle;
    /** @type {?} */
    LineI.prototype.distance;
    /** @type {?} */
    LineI.prototype.direction;
    /** @type {?} */
    LineI.prototype.speed;
}
class CongratOnClaimModalComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} displayMapperService
     */
    constructor(modalCtrl, displayMapperService) {
        this.modalCtrl = modalCtrl;
        this.displayMapperService = displayMapperService;
        this.lines = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.logScreen('CongratOnClaimModal');
        /** @type {?} */
        const certificateDisplay = this.certificateDisplay ? this.certificateDisplay : this.displayMapperService.certificateDisplayMapper(this.certificate);
        /** @type {?} */
        const serialNumber = certificateDisplay.serialNumber.find((/**
         * @param {?} d
         * @return {?}
         */
        d => d.type === 'serialnumber'));
        this.serialNumber = serialNumber ? serialNumber.value : undefined;
        this.productName = certificateDisplay.name;
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        /** @type {?} */
        var canvas = document.getElementById('myCanvas');
        // @ts-ignore
        /** @type {?} */
        var context = canvas.getContext('2d');
        /** @type {?} */
        const width = 500;
        /** @type {?} */
        const height = 300;
        // @ts-ignore
        canvas.width = width.toString();
        // @ts-ignore
        canvas.height = height.toString();
        /**
         * @param {?} min
         * @param {?} max
         * @return {?}
         */
        function getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
        /**
         * @param {?} min
         * @param {?} max
         * @return {?}
         */
        function getRandomArbitrary(min, max) {
            return Math.random() * (max - min) + min;
        }
        /** @type {?} */
        const drawCircle = (/**
         * @param {?} x
         * @param {?} y
         * @return {?}
         */
        (x, y) => {
            context.beginPath();
            context.arc(x, y, 3, 0, 2 * Math.PI);
            context.fill();
            context.fillStyle = '#cd9a59';
            context.lineWidth = 0.5;
            context.strokeStyle = '#cd9a59';
            context.stroke();
        });
        /** @type {?} */
        const makeAnimations = (/**
         * @return {?}
         */
        () => {
            context.clearRect(0, 0, width, height); // effacer le canvas
            this.lines = this.lines.map((/**
             * @param {?} line
             * @return {?}
             */
            line => {
                /** @type {?} */
                const minLimit = 60;
                /** @type {?} */
                const maxLimit = 130;
                if (line.distance < minLimit) {
                    line.direction = 1;
                }
                else if (line.distance > maxLimit) {
                    line.direction = -1;
                }
                line.distance = line.distance + 0.2 * (line.direction * line.speed) * (100 / line.distance);
                drawLine(line);
                return line;
            }));
            window.requestAnimationFrame(makeAnimations);
        });
        /** @type {?} */
        const drawLine = (/**
         * @param {?} line
         * @return {?}
         */
        (line) => {
            const { distance, angle, direction } = line;
            /** @type {?} */
            const startX = width / 2;
            /** @type {?} */
            const startY = height / 2;
            context.beginPath();
            context.moveTo(startX, startY);
            /** @type {?} */
            const AngleToRadians = (/**
             * @param {?} angle
             * @return {?}
             */
            (angle) => {
                return (Math.PI / 180) * angle;
            });
            /** @type {?} */
            const endX = startX + distance * Math.cos(AngleToRadians(angle));
            /** @type {?} */
            const endY = startY + distance * Math.sin(AngleToRadians(angle));
            context.lineTo(endX, endY);
            context.fillStyle = '#cd9a59';
            context.lineWidth = 0.3;
            context.strokeStyle = '#cd9a59';
            context.stroke();
            drawCircle(endX, endY);
            return line;
        });
        for (let angle = 0; angle < 350; angle = angle + 12 + getRandomArbitrary(0, 6)) {
            /** @type {?} */
            const baseDistance = 100 + getRandomInt(-40, 30);
            /** @type {?} */
            const line = drawLine({
                direction: getRandomInt(0, 2) ? 1 : -1,
                distance: baseDistance,
                angle,
                speed: getRandomArbitrary(1, 2)
            });
            this.lines.push(line);
        }
        makeAnimations();
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.logEvent('CongratOnClaimModal_close');
        this.modalCtrl.dismiss();
    }
}
CongratOnClaimModalComponent.decorators = [
    { type: Component, args: [{
                template: "<lib-custom-theme-wrapper>\n  <div class=\"congrat_container\" data-e2e=\"congratonclaim\">\n    <canvas id=\"myCanvas\"></canvas>\n\n    <div class=\"mdl-header congrat_txt\" ion-padding-top>\n      {{'CertificateInfos.claimCongrat.congratulation' | translate}}\n\n    </div>\n\n    <div class=\"congrat_description\">\n      <div class=\"mdl-text\" [innerHTML]=\"((descriptionKey || 'CertificateInfos.claimCongrat.description') | translate) | safeHtml\">\n      </div>\n      <div class=\"mdl-text\" *ngIf=\"productName\"><strong>{{productName}}</strong></div>\n      <div class=\"mdl-text\" *ngIf=\"serialNumber\">\n        {{'CertificateInfos.claimCongrat.serialNumberLabel' | translate}} {{serialNumber}}\n      </div>\n    </div>\n\n    <ion-button color=\"primary\" expand=\"full\" (click)=\"onClickClose()\" data-e2e=\"validate\">\n      {{(buttonKey || 'CertificateInfos.claimCongrat.buttonLabel') | translate}}\n    </ion-button>\n  </div>\n</lib-custom-theme-wrapper>\n",
                styles: [".congrat_container{display:flex;flex-direction:column;align-items:center;padding-top:15px;padding-bottom:20px}.congrat_container .congrat_img{height:auto;width:100%}.congrat_container .congrat_description{margin-top:20px;margin-bottom:30px}.congrat_container .congrat_description>div{padding-top:12px}.congrat_container .mdl-text{font-family:var(--arainee-font-text)}.congrat_container .congrat_txt,.congrat_container ion-button{font-family:var(--arainee-font-title)}"]
            }] }
];
/** @nocollapse */
CongratOnClaimModalComponent.ctorParameters = () => [
    { type: ModalController },
    { type: DisplayMapperService }
];
CongratOnClaimModalComponent.propDecorators = {
    certificateId: [{ type: Input }],
    certificate: [{ type: Input }],
    certificateDisplay: [{ type: Input }],
    logScreen: [{ type: Input }],
    logEvent: [{ type: Input }],
    descriptionKey: [{ type: Input }],
    buttonKey: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CongratOnClaimModalComponent.prototype.certificateId;
    /** @type {?} */
    CongratOnClaimModalComponent.prototype.certificate;
    /** @type {?} */
    CongratOnClaimModalComponent.prototype.certificateDisplay;
    /** @type {?} */
    CongratOnClaimModalComponent.prototype.logScreen;
    /** @type {?} */
    CongratOnClaimModalComponent.prototype.logEvent;
    /** @type {?} */
    CongratOnClaimModalComponent.prototype.descriptionKey;
    /** @type {?} */
    CongratOnClaimModalComponent.prototype.buttonKey;
    /** @type {?} */
    CongratOnClaimModalComponent.prototype.serialNumber;
    /** @type {?} */
    CongratOnClaimModalComponent.prototype.productName;
    /**
     * @type {?}
     * @private
     */
    CongratOnClaimModalComponent.prototype.lines;
    /**
     * @type {?}
     * @private
     */
    CongratOnClaimModalComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    CongratOnClaimModalComponent.prototype.displayMapperService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ClaimSwiperComponent {
    /**
     * @param {?} renderer2
     * @param {?} styleService
     */
    constructor(renderer2, styleService) {
        this.renderer2 = renderer2;
        this.styleService = styleService;
        this.onSwipeComplete = new EventEmitter();
        this.hasStarted = false;
        this.subscription = Subscription.EMPTY;
        this.onSlide = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            if (this.hasStarted) {
                /** @type {?} */
                const sliderSize = this.swiper.nativeElement.getBoundingClientRect().width;
                /** @type {?} */
                const newValue = (event.clientX || event.touches[0].clientX) - this.originFinger;
                /** @type {?} */
                const maxValue = this.swiperContainer.nativeElement.getBoundingClientRect().width - sliderSize;
                if (newValue >= maxValue) {
                    this.onSwipeComplete.emit(true);
                    this.reset();
                    return;
                }
                if (newValue > 0 && newValue < maxValue) {
                    this.swiper.nativeElement.style.transform = `translateX(${newValue}px)`;
                }
            }
        });
        this.start = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            this.renderer2.removeClass(this.swiper.nativeElement, 'slider-reset');
            this.hasStarted = true;
            this.originFinger = event.clientX || event.touches[0].clientX;
        });
        this.reset = (/**
         * @return {?}
         */
        () => {
            this.hasStarted = false;
            this.renderer2.addClass(this.swiper.nativeElement, 'slider-reset');
            this.swiper.nativeElement.style.transform = `translateX(${0}px)`;
        });
        this.removelistener = (/**
         * @return {?}
         */
        () => {
            this.swiper.nativeElement.removeEventListener('mousedown', this.start);
            this.swiper.nativeElement.removeEventListener('touchstart', this.start);
            this.swiper.nativeElement.removeEventListener('mouseup', this.reset);
            this.swiper.nativeElement.removeEventListener('touchend', this.reset);
            this.swiperContainer.nativeElement.removeEventListener('mousemove', this.onSlide);
            this.swiperContainer.nativeElement.removeEventListener('touchmove', this.onSlide);
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.subscription = this.styleService.libraryCustomTheme
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            this.externalFontFamily = data.fonts && data.fonts.text ? data.fonts.text : '';
        }));
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.addListner();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.removelistener();
        this.subscription.unsubscribe();
    }
    /**
     * @return {?}
     */
    addListner() {
        this.swiper.nativeElement.addEventListener('mousedown', this.start);
        this.swiper.nativeElement.addEventListener('touchstart', this.start);
        this.swiper.nativeElement.addEventListener('mouseup', this.reset);
        this.swiper.nativeElement.addEventListener('touchend', this.reset);
        this.swiperContainer.nativeElement.addEventListener('mousemove', this.onSlide);
        this.swiperContainer.nativeElement.addEventListener('touchmove', this.onSlide);
    }
}
ClaimSwiperComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-claim-swiper',
                template: "<div class=\"pd-info-claim\"\n     #swiperContainer\n     id=\"sliderContainer\"\n>\n  <div class=\"slider\"\n  #swiper>\n  </div>\n  <p [style.font-family]=\"externalFontFamily\">\n    {{'CertificateInfos.claimOwnership' | translate}}\n  </p>\n</div>\n\n",
                styles: [".pd-info-claim{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:flex;margin:5px;border-radius:40px;align-items:center;box-shadow:0 0 8px #5f5f5f inset;padding:2px;height:50px;background-color:#fff;width:100%}.pd-info-claim .slider{background:url(/assets/imgs/img_product_claim.svg) center center/contain no-repeat;height:100%;width:95px}.pd-info-claim .slider.slider-reset{transition:.2s}.pd-info-claim>p{font-family:Inter-Regular;color:#494949;font-size:1.2em;margin:12px 0}"]
            }] }
];
/** @nocollapse */
ClaimSwiperComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: StyleService }
];
ClaimSwiperComponent.propDecorators = {
    onSwipeComplete: [{ type: Output }],
    swiper: [{ type: ViewChild, args: ['swiper', { static: true },] }],
    swiperContainer: [{ type: ViewChild, args: ['swiperContainer', { static: true },] }]
};
if (false) {
    /** @type {?} */
    ClaimSwiperComponent.prototype.onSwipeComplete;
    /** @type {?} */
    ClaimSwiperComponent.prototype.swiper;
    /** @type {?} */
    ClaimSwiperComponent.prototype.swiperContainer;
    /**
     * @type {?}
     * @private
     */
    ClaimSwiperComponent.prototype.hasStarted;
    /**
     * @type {?}
     * @private
     */
    ClaimSwiperComponent.prototype.originFinger;
    /** @type {?} */
    ClaimSwiperComponent.prototype.subscription;
    /** @type {?} */
    ClaimSwiperComponent.prototype.externalFontFamily;
    /** @type {?} */
    ClaimSwiperComponent.prototype.onSlide;
    /** @type {?} */
    ClaimSwiperComponent.prototype.start;
    /** @type {?} */
    ClaimSwiperComponent.prototype.reset;
    /** @type {?} */
    ClaimSwiperComponent.prototype.removelistener;
    /**
     * @type {?}
     * @private
     */
    ClaimSwiperComponent.prototype.renderer2;
    /**
     * @type {?}
     * @private
     */
    ClaimSwiperComponent.prototype.styleService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductInfoYoutubeComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} translate
     */
    constructor(modalCtrl, translate) {
        this.modalCtrl = modalCtrl;
        this.translate = translate;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.locale = this.translate.currentLang;
        this.media = getYoutubeMedia(this.link);
        this.logScreen('product-info-youtube', { link: this.link.title });
        this.embedURL = this.media.embedURL;
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} sub
         * @return {?}
         */
        sub => sub.unsubscribe()));
    }
}
ProductInfoYoutubeComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-info-youtube',
                template: "<div class=\"inner-content\" data-e2e=\"product_history\">\n    <div class=\"pd-history-header\">\n        <div>\n            <p>\n                {{link.title}}\n            </p>\n        </div>\n        <div>\n            <ion-icon name=\"close\" (click)=\"onClickClose()\"></ion-icon>\n        </div>\n    </div>\n\n    <div class=\"pd-history-main\">\n        <div>\n            <div id=\"playerIframe\" >\n                <iframe [src]=\"embedURL | safe\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n            </div>\n        </div>\n\n\n    </div>\n</div>\n\n\n\n",
                styles: [".inner-content{padding:0!important;background-color:#fefefe}#playerIframe{align-self:center;width:100%;padding-top:56.25%;position:relative}#playerIframe iframe{top:0;left:0;position:absolute;width:100%;height:100%}.pd-history-header{display:flex;margin-top:16px;padding:0 16px;align-items:center}.pd-history-header>div:first-child{flex:3}.pd-history-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.pd-history-header>div:nth-child(2){flex:1;text-align:right}.pd-history-header>div:nth-child(2) ion-icon{font-size:2em}.pd-history-main{padding:8px;margin-top:20px;border-top:1px solid #eee}.pd-history-main>p{text-align:center}.pd-history-brand{text-align:center;margin:3vh 0}.pd-history-brand>img{width:50%}.pd-history-main-item-footer{text-align:center}.ownerSince{color:#999;text-align:center;font-weight:700;margin-bottom:30px}.date{color:#999;font-family:Inter-Regular;font-size:.9em}"]
            }] }
];
/** @nocollapse */
ProductInfoYoutubeComponent.ctorParameters = () => [
    { type: ModalController },
    { type: TranslateService }
];
ProductInfoYoutubeComponent.propDecorators = {
    link: [{ type: Input }],
    logScreen: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductInfoYoutubeComponent.prototype.link;
    /** @type {?} */
    ProductInfoYoutubeComponent.prototype.logScreen;
    /** @type {?} */
    ProductInfoYoutubeComponent.prototype.locale;
    /** @type {?} */
    ProductInfoYoutubeComponent.prototype.media;
    /** @type {?} */
    ProductInfoYoutubeComponent.prototype.embedURL;
    /**
     * @type {?}
     * @private
     */
    ProductInfoYoutubeComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    ProductInfoYoutubeComponent.prototype.modalCtrl;
    /** @type {?} */
    ProductInfoYoutubeComponent.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ModelViewerWebComponent() { }
if (false) {
    /** @type {?} */
    ModelViewerWebComponent.prototype.play;
    /** @type {?} */
    ModelViewerWebComponent.prototype.cameraOrbit;
    /** @type {?} */
    ModelViewerWebComponent.prototype.resetTurntableRotation;
}
class ModelViewerComponent {
    constructor() {
        this.selected3dModel = null;
        this.afterViewInit = new Subject();
        this.modelViewerNativeElement = null;
        this.modelViewerInitialized = false;
        this.modelViewerEventListeners = [];
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.modelViewerNativeElement = (/** @type {?} */ (this.modelViewer.nativeElement));
        this.afterViewInit.next();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.modelViewerEventListeners) {
            this.modelViewerEventListeners.forEach((/**
             * @param {?} eventListener
             * @return {?}
             */
            (eventListener) => {
                this.modelViewer.nativeElement.removeEventListener(eventListener.type, eventListener.eventListener);
            }));
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        /** @type {?} */
        const selected3dModel = changes.selected3dModel.currentValue;
        if (selected3dModel) {
            if (this.modelViewerNativeElement) {
                this.show3DModel(selected3dModel.asset.url);
            }
            else {
                /** @type {?} */
                const subscription = this.afterViewInit.subscribe((/**
                 * @return {?}
                 */
                () => {
                    this.show3DModel(selected3dModel.asset.url);
                    subscription.unsubscribe();
                }));
            }
        }
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    onModelProgress(event) {
        /** @type {?} */
        const currentProgress = event.detail.totalProgress;
        this.modelViewerLoader.nativeElement.style.display = currentProgress >= 1 ? 'none' : 'block';
    }
    /**
     * @private
     * @return {?}
     */
    onModelLoad() {
        // Reset zoom, rotation and auto-rotation delay
        this.modelViewerNativeElement.removeAttribute('auto-rotate');
        this.modelViewerNativeElement.setAttribute('auto-rotate-delay', '300');
        this.modelViewerNativeElement.setAttribute('auto-rotate', '');
        this.modelViewerNativeElement.cameraOrbit = 'camera-orbit', '0deg 75deg 105%';
        this.modelViewerNativeElement.resetTurntableRotation(0);
        // Play animation if any
        this.modelViewerNativeElement.play();
    }
    /**
     * @private
     * @return {?}
     */
    initModelViewer() {
        if (!this.modelViewer)
            throw new Error('modelViewer not yet defined');
        if (this.modelViewerInitialized)
            return;
        this.modelViewerEventListeners.push({ type: 'progress', eventListener: this.onModelProgress });
        this.modelViewerNativeElement.addEventListener('progress', (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            this.onModelProgress(event);
        }));
        this.modelViewerEventListeners.push({ type: 'load', eventListener: this.onModelLoad });
        this.modelViewerNativeElement.addEventListener('load', (/**
         * @return {?}
         */
        () => {
            this.onModelLoad();
        }));
        this.modelViewerInitialized = true;
    }
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    show3DModel(url) {
        try {
            this.initModelViewer();
        }
        catch (_a) {
            /** @type {?} */
            const subscription = this.afterViewInit.subscribe((/**
             * @return {?}
             */
            () => {
                this.initModelViewer();
                subscription.unsubscribe();
            }));
        }
        this.modelViewerNativeElement.setAttribute('src', url);
    }
}
ModelViewerComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-model-viewer',
                template: "<div class=\"model-viewer-container\">\n  <model-viewer\n    camera-controls\n    auto-rotate\n    auto-rotate-delay=\"300\"\n    rotation-per-second=\"12deg\"\n    loading=\"eager\"\n    interaction-prompt=\"none\"\n    field-of-view=\"20deg\"\n    #modelViewer\n  >\n    <div slot=\"progress-bar\"></div>\n  </model-viewer>\n  <div class=\"loader\" #modelViewerLoader>\n    <lib-loading-spinner\n      [fullScreen]=\"false\"\n      [loading]=\"true\"\n      background=\"transparent\"\n    ></lib-loading-spinner>\n  </div>\n</div>\n",
                styles: ["div.model-viewer-container{position:relative;width:100%;height:100%}div.model-viewer-container model-viewer{position:relative;width:100%;height:100%;background:0 0;--poster-color:transparent}div.model-viewer-container div.loader{position:absolute;display:block;width:64px;height:64px;left:calc(50% - 32px);top:calc(50% - 32px)}"]
            }] }
];
ModelViewerComponent.propDecorators = {
    modelViewer: [{ type: ViewChild, args: ['modelViewer', { static: false },] }],
    modelViewerLoader: [{ type: ViewChild, args: ['modelViewerLoader', { static: false },] }],
    selected3dModel: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ModelViewerComponent.prototype.modelViewer;
    /** @type {?} */
    ModelViewerComponent.prototype.modelViewerLoader;
    /** @type {?} */
    ModelViewerComponent.prototype.selected3dModel;
    /**
     * @type {?}
     * @private
     */
    ModelViewerComponent.prototype.afterViewInit;
    /**
     * @type {?}
     * @private
     */
    ModelViewerComponent.prototype.modelViewerNativeElement;
    /**
     * @type {?}
     * @private
     */
    ModelViewerComponent.prototype.modelViewerInitialized;
    /**
     * @type {?}
     * @private
     */
    ModelViewerComponent.prototype.modelViewerEventListeners;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CustomValidator {
    /**
     * @param {?} publicKey
     * @return {?}
     */
    static publicKeyValidator(publicKey) {
        if (publicKey.pristine) {
            return null;
        }
        /** @type {?} */
        const URL_REGEXP = /^0x[a-fA-F0-9]{40}$/;
        publicKey.markAsTouched();
        if (URL_REGEXP.test(publicKey.value)) {
            return null;
        }
        return {
            invalidPublicKey: true
        };
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductViewComponent {
    /**
     * @param {?} photoViewer
     * @param {?} renderer
     * @param {?} formBuilder
     */
    constructor(photoViewer, renderer, formBuilder) {
        this.photoViewer = photoViewer;
        this.renderer = renderer;
        this.formBuilder = formBuilder;
        this.displayHistoryBtn = true;
        this.allowClaimWithAddress = false;
        this.displayViewCert = true;
        this.onBrandClick = new EventEmitter();
        this.onLinkClick = new EventEmitter();
        this.onSwipeClick = new EventEmitter();
        this.onMessageClick = new EventEmitter();
        this.onToggleLost = new EventEmitter();
        this.onShowProofModal = new EventEmitter();
        this.onClickViewCert = new EventEmitter();
        this.onClickHistory = new EventEmitter();
        this.onClickTransaprency = new EventEmitter();
        this.onClickTransparencyItems = new EventEmitter();
        this.onClickLabelModal = new EventEmitter();
        this.onClickPGeneve = new EventEmitter();
        this.onClickSwissMade = new EventEmitter();
        this.onClickMore = new EventEmitter();
        this.onClickCtaButton = new EventEmitter();
        this.onClickShareBtn = new EventEmitter();
        this.onClickClaimBtn = new EventEmitter();
        this.claimForm = this.formBuilder.group({
            publicKey: ['', [Validators.required, CustomValidator.publicKeyValidator]]
        });
        this.showClaimForm = false;
        this.selected3dModel = null;
        this.selected3dModelIndex = null;
        this.selectedVideo = null;
        this.selectedVideoIndex = null;
        this.hostedWallet = null;
        this.seeMore = false;
        this.hideMiniPreview = false;
        this.specialExternalContentType = ['resellLink', 'repairLink', 'lostLink'];
        /**
         *
         * GET responsive width
         * (not page width but parent width, PWA constraint)
         * AND Set Height to make a perfect square for viewer
         */
        this.setViewerHeight = (/**
         * @return {?}
         */
        () => {
            if (this.mainViewParent.nativeElement.clientWidth === 0) {
                setTimeout(this.setViewerHeight, 10);
                return;
            }
            /** @type {?} */
            const height = this.mainViewParent.nativeElement.clientWidth - 32;
            this.renderer.setStyle(this.viewer.nativeElement, 'height', height + 'px');
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.showProof) {
            if (this.showProof) {
                this.showProofModal();
            }
        }
        if (changes.certificateDisplay) {
            this.certificateDisplay.medias = this.certificateDisplay.medias.map((/**
             * @param {?} media
             * @return {?}
             */
            media => {
                if (media.mediaType === 'youtube') {
                    return getYoutubeMedia(media);
                }
                return media;
            }));
            if (this.certificateDisplay.pictures.length > 0) {
                this.selectMainPicture(0);
            }
            else if (this.certificateDisplay.threeDimensionalMedias && this.certificateDisplay.threeDimensionalMedias.length > 0) {
                this.selectThreeDimensionalMedia(0);
            }
            else if (get(this.certificateDisplay, 'videoMedias.length', 0) > 0) {
                this.selectVideoMedia(0);
            }
            if ((this.certificateDisplay.pictures || []).length +
                (this.certificateDisplay.medias || []).length +
                (this.certificateDisplay.threeDimensionalMedias || []).length +
                (this.certificateDisplay.videoMedias || []).length <= 1) {
                this.hideMiniPreview = true;
            }
            if (this.certificateDisplay.description.length > 100) {
                this.seeMore = true;
            }
            this.certificateDisplay.links = this.certificateDisplay.links
                .filter((/**
             * @param {?} link
             * @return {?}
             */
            (link) => {
                return !this.specialExternalContentType.includes(link.type);
            }));
            /** @type {?} */
            const shareOverlayMedia = (this.certificateDisplay.otherMedias || []).filter((/**
             * @param {?} m
             * @return {?}
             */
            m => m.type === 'shareOverlay'));
            this.overlayImg = shareOverlayMedia && shareOverlayMedia.length ? shareOverlayMedia[0].url : null;
            this.changeLinksTags();
        }
        if (changes.identity) {
            this.hostedWallet = (this.identity.data.externalContents || [])
                .find((/**
             * @param {?} externalContent
             * @return {?}
             */
            externalContent => externalContent.type === 'hostedWallet'));
            this.footerTranslateParam = { brandName: this.identity.data.name };
        }
    }
    /**
     * @param {?} index
     * @return {?}
     */
    selectMainPicture(index) {
        this.embedURL = null;
        this.hightlightPicture = this.certificateDisplay.pictures[index].url || this.certificateDisplay.pictures[index];
        this.hightlightMediaIndex = null;
        this.hightlightPictureIndex = index;
        this.selected3dModel = null;
        this.selected3dModelIndex = null;
        this.highlightARMediaIndex = null;
        this.selectedVideo = null;
        this.selectedVideoIndex = null;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    selectMedia(index) {
        switch (this.certificateDisplay.medias[index].type) {
            case 'ARPrimaryAsset':
            case 'ARAsset':
                this.linkClick({ type: 'system', url: this.certificateDisplay.medias[index].url, title: '' });
                break;
            case 'ARPreview':
                this.hightlightPicture = this.certificateDisplay.medias[index].url;
                this.hightlightMediaIndex = null;
                this.highlightARMediaIndex = index;
                this.hightlightPicture = null;
                this.hightlightPictureIndex = null;
                this.selected3dModel = null;
                this.selected3dModelIndex = null;
                this.selectedVideo = null;
                this.selectedVideoIndex = null;
                break;
            default:
                this.hightlightPicture = null;
                this.embedURL = this.certificateDisplay.medias[index].embedURL;
                this.hightlightPictureIndex = null;
                this.highlightARMediaIndex = null;
                this.hightlightMediaIndex = index;
                this.selected3dModel = null;
                this.selected3dModelIndex = null;
                this.selectedVideo = null;
                this.selectedVideoIndex = null;
                break;
        }
    }
    /**
     * @param {?} index
     * @return {?}
     */
    selectThreeDimensionalMedia(index) {
        this.selected3dModel = this.certificateDisplay.threeDimensionalMedias[index];
        this.selected3dModelIndex = index;
        this.embedURL = null;
        this.hightlightPicture = null;
        this.highlightARMediaIndex = null;
        this.hightlightMediaIndex = null;
        this.hightlightPictureIndex = null;
        this.selectedVideo = null;
        this.selectedVideoIndex = null;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    selectVideoMedia(index) {
        this.selected3dModel = null;
        this.selected3dModelIndex = null;
        this.embedURL = null;
        this.hightlightPicture = null;
        this.highlightARMediaIndex = null;
        this.hightlightMediaIndex = null;
        this.hightlightPictureIndex = null;
        this.selectedVideo = this.certificateDisplay.videoMedias[index];
        this.selectedVideoIndex = index;
    }
    /**
     * @return {?}
     */
    changeLinksTags() {
        /** @type {?} */
        const linksElement = this.description.nativeElement.querySelectorAll('a');
        for (const link of Array.from(linksElement)) {
            /** @type {?} */
            const url = link.href;
            if (url && url !== 'javascript:void(0);') {
                this.renderer.setAttribute(link, 'href', 'javascript:void(0);');
                this.renderer.listen(link, 'click', (/**
                 * @param {?} event
                 * @return {?}
                 */
                (event) => {
                    event.stopPropagation();
                    this.linkClick({ type: 'external', url });
                }));
            }
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.setViewerHeight();
        this.changeLinksTags();
    }
    /**
     * @param {?} url
     * @return {?}
     */
    zoom(url) {
        /** @type {?} */
        const options = {
            share: false,
            // default is false
            closeButton: true,
            // default is true
            copyToReference: true,
            // default is false
            headers: '',
            // If it is not provided, it will trigger an exception
            piccasoOptions: {} // If it is not provided, it will trigger an exception
        };
        this.photoViewer.show(url, '', options);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isArray(value) {
        return Array.isArray(value);
    }
    /**
     * @return {?}
     */
    toggleSeeMore() {
        this.seeMore = !this.seeMore;
    }
    /**
     * @return {?}
     */
    brandClick() {
        this.onBrandClick.emit();
    }
    /**
     * @param {?} link
     * @return {?}
     */
    linkClick(link) {
        this.onLinkClick.emit(link);
    }
    /**
     * @return {?}
     */
    swipeComplete() {
        this.onSwipeClick.emit();
    }
    /**
     * @return {?}
     */
    messageClick() {
        this.onMessageClick.emit();
    }
    /**
     * @return {?}
     */
    showProofModal() {
        this.onShowProofModal.emit();
    }
    /**
     * @return {?}
     */
    clickViewCert() {
        this.onClickViewCert.emit();
    }
    /**
     * @return {?}
     */
    clickHistory() {
        this.onClickHistory.emit();
    }
    /**
     * @param {?} url
     * @return {?}
     */
    clickTransparency(url) {
        this.onClickTransaprency.emit(url);
    }
    /**
     * @return {?}
     */
    clickTransparencyItem() {
        this.onClickTransparencyItems.emit();
    }
    /**
     * @param {?} labelName
     * @return {?}
     */
    clickLabelModal(labelName) {
        this.onClickLabelModal.emit(labelName);
    }
    /**
     * @return {?}
     */
    clickPGeneve() {
        this.onClickPGeneve.emit();
    }
    /**
     * @return {?}
     */
    clickSwissMade() {
        this.onClickSwissMade.emit();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    clickMore($event) {
        this.onClickMore.emit($event);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    clickCTA($event) {
        this.onClickCtaButton.emit($event);
    }
    /**
     * @return {?}
     */
    clickShareBtn() {
        this.onClickShareBtn.emit(this.overlayImg);
    }
    /**
     * @return {?}
     */
    onClaimSubmit() {
        this.onClickClaimBtn.emit(this.claimForm.get('publicKey').value);
    }
    /**
     * @return {?}
     */
    pastePublicKey() {
        navigator.clipboard.readText().then((/**
         * @param {?} publicKey
         * @return {?}
         */
        publicKey => {
            this.claimForm.get('publicKey').setValue(publicKey);
        }));
    }
}
ProductViewComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-view',
                template: "<lib-custom-theme-wrapper>\n  <ion-content #scrollElement>\n    <div\n      [ngStyle]=\"{'background-image': 'linear-gradient(to bottom, rgba(255, 255, 255, 0.1), var(--arianee-color-primary, rgba(255,255,255,1))),url(' + certificateDisplay?.itemBackgroundPicture + ')'}\"\n      id=\"pd-bg\">\n    </div>\n\n    <div #mainViewParent [ngClass]=\"{'isRequestable': 'certificateDisplay?.isRequestable'}\" id=\"pd-main\">\n\n      <div *ngIf=\"displayNavBar\" class=\"to-claim\" id=\"pd-navbar\">\n        <ng-container *ngIf=\"certificateDisplay?.isOwner\">\n          <ion-button (click)=\"messageClick()\" class=\"ion-no-padding\" data-e2e=\"chat_link\" fill=\"clear\">\n            <ion-icon src=\"{{'assets/icon/ic_message_white.svg' | imageSrc}}\"></ion-icon>\n            <ion-badge *ngIf=\"unreadNotification | async\" class=\"ion-notification\"\n                       color=\"primary\">{{unreadNotification | async}}</ion-badge>\n          </ion-button>\n          <ion-button (click)=\"clickMore($event)\" class=\"ion-no-padding moreActions\" data-e2e=\"more_item\" fill=\"clear\">\n            <ion-icon class=\"iconSize\" color=\"tertiary\" name=\"ellipsis-horizontal\"></ion-icon>\n          </ion-button>\n        </ng-container>\n      </div>\n\n\n      <div (click)=\"brandClick()\" data-e2e=\"brand-image\" id=\"pd-brand-image\">\n        <img [src]=\"certificateDisplay?.brandLogoHeaderReversed | imageSrc | imageProxy | async\"/>\n      </div>\n\n      <div\n        #viewer\n        data-e2e=\"product-image\"\n        id=\"pd-product-main-img\"\n      >\n        <lib-model-viewer\n          #modelViewer\n          *ngIf=\"selected3dModel\"\n          [selected3dModel]=\"selected3dModel\">\n        </lib-model-viewer>\n\n        <video\n          *ngIf=\"selectedVideo\"\n          [autoplay]=\"true\" [loop]=\"true\"\n          [muted]=\"true\" [poster]=\"selectedVideo?.preview?.url\" [src]=\"selectedVideo.video.url\"\n          data-e2e=\"product_view_video\"\n          libImageRatioFullWidth playsinline\n          webkit-playsinline>\n        </video>\n\n        <img #hightlightPictureElement (click)=\"zoom(hightlightPicture)\"\n             [attr.data-e2e]=\"'hightlight-'+hightlightPictureIndex\"\n             [hidden]=\"!hightlightPicture\" [src]=\"hightlightPicture | imageProxy | async\"\n             libImageRatioFullWidth/>\n\n        <div *ngIf=\"embedURL\" id=\"playerIframe\">\n          <iframe [src]=\"embedURL | safe\"\n                  allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\"\n                  allowfullscreen\n                  frameborder=\"0\">\n          </iframe>\n        </div>\n\n        <ng-container *ngIf=\"(hightlightPictureIndex===0)\">\n          <ng-container *ngFor=\"let media of certificateDisplay?.medias; let index=index;\">\n            <div (click)=\"selectMedia(index)\" *ngIf=\"media.type == 'ARPrimaryAsset' || media.type == 'ARAsset'\"\n                 class=\"ARPrimary\">\n              <img height=\"30\" src=\"{{'assets/icon/ar.png' | imageSrc}}\" width=\"30\">\n              <span class=\"label-wrapper\">AR</span>\n            </div>\n          </ng-container>\n        </ng-container>\n\n        <ng-container *ngIf=\"(highlightARMediaIndex===0)\">\n          <ng-container *ngFor=\"let media of certificateDisplay?.medias; let index=index;\">\n            <div (click)=\"selectMedia(index)\" *ngIf=\"media.type == 'ARPrimaryAsset' || media.type == 'ARAsset'\"\n                 class=\"ARPrimary\">\n              <img height=\"30\" src=\"{{'assets/icon/ar.png' | imageSrc}}\" width=\"30\">\n              <span class=\"label-wrapper\">AR</span>\n            </div>\n          </ng-container>\n        </ng-container>\n      </div>\n\n      <div *ngIf=\"certificateDisplay && isMissing\" class=\"lost\" data-e2e=\"product-details-lost-footer\">\n        {{(isStolen ? \"CertificateInfos.certificateDeclareAsStolen\" : \"CertificateInfos.certificateDeclareAsMissing\") | translate}}\n      </div>\n\n      <ion-grid #productMainImg *ngIf=\"!hideMiniPreview\" class=\"altPictureGrid\">\n        <ion-row class=\"ion-nowrap flex-row\" nowrap>\n          <ion-col\n            *ngFor=\"let image of certificateDisplay?.pictures; let index=index;\"\n            [style.order]=\"image.order\"\n            class=\"altPictureCol pictures-column\"\n            data-e2e=\"product-pictures\"\n          >\n            <div (click)=\"selectMainPicture(index)\" [attr.data-e2e]=\"'picture-'+index\"\n                 [ngClass]=\"{'highlightedPicture':index===hightlightPictureIndex}\"\n                 class=\"altPicture  pictures-column\">\n              <img [src]=\"image.url | imageProxy | async\"/>\n            </div>\n          </ion-col>\n\n          <ion-col (click)=\"selectThreeDimensionalMedia(index)\"\n\n                   *ngFor=\"let threeDimensionalMedia of certificateDisplay?.threeDimensionalMedias || []; let index=index;\"\n                   [style.order]=\"threeDimensionalMedia.preview.order\"\n                   class=\"altPictureCol 3d-column\">\n            <div class=\"altPicture\">\n              <img [class.highlightedPicture]=\"index === selected3dModelIndex\"\n                   [src]=\"threeDimensionalMedia.preview.url\">\n            </div>\n          </ion-col>\n\n          <ion-col (click)=\"selectVideoMedia(index)\"\n\n                   *ngFor=\"let videoMedia of certificateDisplay?.videoMedias || []; let index=index;\"\n                   [style.order]=\"videoMedia.preview.order\"\n\n                   class=\"altPictureCol video-column\">\n            <div class=\"altPicture\">\n              <img [class.highlightedPicture]=\"index === selectedVideoIndex\"\n                   [src]=\"videoMedia.preview.url\"\n                   data-e2e=\"product_view_video_preview\">\n            </div>\n          </ion-col>\n\n\n          <ng-container\n            *ngFor=\"let media of certificateDisplay?.medias; let index=index;\">\n            <ion-col\n              (click)=\"selectMedia(index)\"\n              *ngIf=\"media.mediaType=='youtube'\"\n              [style.order]=\"media.order\"\n              class=\"altPictureCol youtube-column\">\n              <div class=\"altPicture\">\n                <img\n                  [class.highlightedPicture]=\"index === hightlightMediaIndex\"\n                  [src]=\"media.thumbnail\"\n                >\n              </div>\n            </ion-col>\n          </ng-container>\n\n          <ng-container\n            *ngFor=\"let arMedia of certificateDisplay?.arMedias; let index=index;\">\n            <ion-col\n              (click)=\"selectMedia(index)\"\n              *ngIf=\"arMedia.preview\"\n              [style.order]=\"arMedia.preview.order\"\n              class=\"altPictureCol ar-column\"\n            >\n              <div class=\"altPicture\">\n                <img\n                  *ngIf=\"arMedia.preview.mediaType=='AR' && arMedia.preview.type == 'ARPreview'\"\n                  [class.highlightedPicture]=\"index === selectedVideoIndex\"\n                  [src]=\"arMedia.preview.url\"\n                >\n              </div>\n            </ion-col>\n\n          </ng-container>\n\n        </ion-row>\n      </ion-grid>\n\n      <div class=\"divider\"></div>\n\n      <div id=\"pd-info\">\n        <div id=\"pd-info-header\">\n          <div>\n            <p data-e2e=\"product_name\">\n              {{certificateDisplay?.name}}\n            </p>\n            <p data-e2e=\"product_model\">\n              {{certificateDisplay?.model}}\n            </p>\n          </div>\n          <div *ngIf=\"displayViewCert\" class=\"clickable\">\n            <img (click)=\"clickViewCert()\" [src]=\"(certificateDisplay?.isCertificateValid?\n                        'assets/imgs/img_product_cert.svg':\n                        'assets/imgs/img_product_not_cert.svg') | imageSrc\n                        \" data-e2e='validity-picture'/>\n          </div>\n        </div>\n        <div *ngIf=\"isArray(certificateDisplay?.serialNumber)\"\n             class=\"ion-text-wrap\"\n             class=\"serialnumber-container\"\n             data-e2e=\"product-serialnumber\">\n          <div *ngFor=\"let serialnumber of certificateDisplay?.serialNumber\">\n\n            <div *ngIf=\"serialnumber.type=='serialnumber'\"><b>{{ 'CertificateInfos.serialNumber' | translate }}\n              :</b> {{ serialnumber.value }}</div>\n            <div *ngIf=\"serialnumber.type=='casenumber'\"><b>{{ 'CertificateInfos.caseNumber' | translate }}\n              : </b>{{ serialnumber.value }}</div>\n            <div *ngIf=\"serialnumber.type=='movementnumber'\"><b>{{ 'CertificateInfos.movementNumber' | translate }}\n              : </b>{{ serialnumber.value }}</div>\n            <div *ngIf=\"serialnumber.type=='millesimation'\"><b>{{ 'CertificateInfos.millesimation' | translate }}\n              : </b>{{ serialnumber.value }}</div>\n\n          </div>\n        </div>\n        <div #walletDescription (click)=\"toggleSeeMore()\" class=\"description-container\">\n          <div\n            [ngClass]=\"{'max-height-description':seeMore}\">\n            <p #description [innerHTML]=\"(certificateDisplay?.description | translate) | safeHtml\"\n               data-e2e=\"product-description\"\n               style=\"white-space: pre-line!important\"\n            >\n            </p>\n          </div>\n          <div *ngIf=\"seeMore\" class=\"seemore clickable\">\n            <ion-icon name=\"eye\"></ion-icon>\n          </div>\n        </div>\n\n\n        <div class=\"clickable\" id=\"pd-info-footer\">\n          <p (click)=\"clickHistory()\" *ngIf=\"displayHistoryBtn\" data-e2e=\"history_btn\">\n            {{'CertificateInfos.history' | translate}}\n            <ion-badge *ngIf=\"pendingEventsLength>0 && certificateDisplay?.isOwner\"\n                       color=\"primary\">{{pendingEventsLength}}</ion-badge>\n          </p>\n          <p (click)=\"clickTransparency(certificateDisplay?.transparency.url)\" *ngIf=\"certificateDisplay?.transparency\"\n             data-e2e=\"transparency_btn\">\n            {{'CertificateInfos.transparency' | translate}}\n          </p>\n\n          <p (click)=\"clickTransparencyItem()\" *ngIf=\"certificateDisplay?.transparencyItems\"\n             data-e2e=\"transparency_btn\">\n            {{'CertificateInfos.transparency' | translate}}\n          </p>\n\n          <p (click)=\"clickShareBtn()\" *ngIf=\"overlayImg\" [ngClass]=\"{'disabled': !certificateDisplay?.isOwner}\"\n             class=\"btn-with-icon\"\n             data-e2e=\"share_btn\">\n            <ion-icon name=\"share-social\"></ion-icon>\n            {{'CertificateInfos.shareBtn' | translate}}\n          </p>\n\n        </div>\n        <div id=\"labels\">\n          <div>\n            <img (click)=\"clickLabelModal(label.title)\" *ngFor=\"let label of labels\" [src]=\"label.icon\" alt=\"\">\n          </div>\n          <div *ngIf=\"certificateDisplay?.pgeneve\"><img (click)=\"clickPGeneve()\" alt=\"\"\n                                                        src=\"{{'assets/imgs/pgeneve.png' | imageSrc}}\">\n          </div>\n          <div *ngIf=\"certificateDisplay?.swissmade\"><img (click)=\"clickSwissMade()\" alt=\"\"\n                                                          src=\"{{'assets/imgs/swiss-made-logo.png' | imageSrc}}\">\n          </div>\n        </div>\n        <div #productLinks *ngIf=\"certificateDisplay?.links\" data-e2e=\"product-links\" id=\"pd-info-links\">\n\n          <p (click)=\"linkClick(link)\"\n             *ngFor=\"let link of certificateDisplay?.links\"\n             class=\"pd-info-link\"\n             data-e2e=\"product-link\">\n            <a [attr.data-e2e]=\"link.type\"\n               [ngClass]=\"{'externalLinks--isNotOwner': !certificateDisplay?.isOwner && ['proofLinkAction','arianeeAccessTokenAuthLink'].includes(link.type)}\"\n               class=\"externalLinks clickable\"\n            > {{link.title}}</a>\n            <ion-icon color=\"primary\" item-right name=\"chevron-forward-circle-outline\"></ion-icon>\n\n          </p>\n        </div>\n\n      </div>\n    </div>\n\n  </ion-content>\n\n  <ion-footer *ngIf=\"proofFooter\" class=\"footer\" data-e2e=\"proof-footer\">\n\n    <div class=\"proof\" *ngIf=\"proof\">\n      <img [src]=\"(proof.isTrue?\n                        'assets/imgs/img_product_cert.svg':\n                        'assets/imgs/img_product_not_cert.svg') | imageSrc\"/>\n      <div [attr.data-e2e]=\"'proofValid_'+proof.isTrue\">\n        <p>{{ 'CertificateInfos.' + proof.code | translate }}</p>\n        <p *ngIf=\"proof?.timestamp\">{{ 'CertificateInfos.created' | translate}}\n          : {{proof?.timestamp  | amDateFormat:'LLL'}}</p>\n      </div>\n    </div>\n\n\n  </ion-footer>\n  <ion-footer *ngIf=\"CTAButtonLabel && linkButtonLabel\" class=\"footer footer-cta\">\n    <ng-container *ngIf=\"showClaimForm === false\">\n      <button (click)=\"clickCTA($event)\"\n              class=\"button__download\"\n              data-e2e=\"CTA_Button\">\n        {{CTAButtonLabel| translate}}\n      </button>\n      <a (click)=\"showClaimForm = true\" *ngIf=\"allowClaimWithAddress === true\" class=\"link-button\">\n\n        {{linkButtonLabel | translate}}\n\n      </a>\n    </ng-container>\n    <ng-container *ngIf=\"showClaimForm === true\">\n      <div class=\"claim-container\">\n        <div class=\"claim-container__back\">\n\n          <a (click)=\"showClaimForm = false\">\n            {{\"CertificateInfos.back\" | translate}}</a>\n        </div>\n        <div class=\"claim-container__header\">\n          <div class=\"title\">\n            {{\"CertificateInfos.nonArianeeWallet\" | translate}}\n          </div>\n          <div class=\"description\">\n\n            {{\"CertificateInfos.nonArianeeWalletDescription\" | translate}}\n          </div>\n        </div>\n        <div class=\"claim-container__form\">\n          <form (ngSubmit)=\"onClaimSubmit()\" [formGroup]=\"claimForm\">\n            <span class=\"title\">\n                {{\"CertificateInfos.nftClaimInputPlaceholder\" | translate}}\n            </span>\n            <div class=\"input-container\">\n              <input class=\"input\" formControlName=\"publicKey\" id=\"publicKey\"\n                     type=\"text\">\n              <button (click)=\"pastePublicKey(); $event.preventDefault()\" class=\"paste-button\">\n                {{\"CertificateInfos.nftClaimPasteAction\" | translate}}\n              </button>\n            </div>\n\n            <small class=\"form-text text-muted\">\n              <span *ngIf=\"claimForm.get('publicKey').touched &&\n                           claimForm.get('publicKey').hasError('invalidPublicKey') &&\n                           claimForm.value.publicKey.length > 0\">\n              {{\"CertificateInfos.nftClaimInputError\" | translate}}\n              </span>\n            </small>\n\n            <button [disabled]=\"!claimForm.valid\"\n                    class=\"button__ownership\"\n                    type=\"submit\">\n              {{\"CertificateInfos.nftClaimButton\" | translate}}\n            </button>\n          </form>\n        </div>\n      </div>\n    </ng-container>\n  </ion-footer>\n  <ion-footer *ngIf=\"requestableFooter\"\n              class=\"footer\"\n              data-e2e=\"requestOwnership-footer\">\n    <div *ngIf=\"!isClaimedPendingCertificate\" class=\"proof\">\n      <span *ngIf=\"certificateDisplay?.isOwner\">{{'CertificateInfos.AlreadyOwner' | translate}}</span>\n      <span\n        *ngIf=\"!certificateDisplay?.isOwner\">{{(hostedWallet ? 'CertificateInfos.hostedWallet' : 'CertificateInfos.CannotGetOwnership') | translate:footerTranslateParam }}</span>\n    </div>\n    <div *ngIf=\"isClaimedPendingCertificate\" class=\"proof\">\n      <span>\n      {{ 'CertificateInfos.AlreadyClaimed' | translate}}\n      </span>\n    </div>\n  </ion-footer>\n  <ion-footer *ngIf=\"isRequestableButton\" class=\"footer pd-swipe-container\">\n    <div data-e2e=\"product-details-swipe-request\">\n      <app-claim-swiper (onSwipeComplete)=\"swipeComplete()\"></app-claim-swiper>\n    </div>\n  </ion-footer>\n</lib-custom-theme-wrapper>\n",
                styles: ["::-webkit-scrollbar{display:none!important;color:#fff;height:0}ion-header ion-toolbar{height:0;border:none!important}ion-content{background:#fff}.header-ios ion-toolbar:last-child{visibility:hidden;--border-width:0 0 0.55px!important}#pd-bg{position:absolute;top:0;left:0;width:100%;z-index:1;height:400px;overflow:auto;background-size:cover}#pd-bg>img{max-width:100%;width:100%;-webkit-filter:contrast(.2);filter:contrast(.2)}#pd-main{position:relative;z-index:2;margin-bottom:50px}#pd-main.isRequestable{margin-bottom:100px}#pd-navbar-padding{padding-top:20px}#pd-navbar{display:flex;width:100%;top:0;z-index:10;justify-content:flex-end;padding-top:27px;background-image:linear-gradient(to bottom,rgba(0,0,0,.6),rgba(0,0,0,0));position:-webkit-sticky;position:sticky}#pd-navbar ion-button{margin-right:10px;font-size:24px}.to-claim{height:90px}#pd-brand-image{text-align:center;margin-left:60px;margin-right:60px;padding-top:50px}#pd-product-main-img{position:relative;text-align:center;margin:16px 16px 0;overflow:hidden;align-items:center;justify-content:center;display:flex;height:0}#pd-product-main-img>*{border-radius:8px;max-height:100%;max-width:100%}#playerIframe{align-self:center;width:100%;padding-top:56.25%;position:relative}#playerIframe iframe{top:0;left:0;position:absolute;width:100%;height:100%}#pd-info-header{display:flex;align-items:center;padding:0 16px}#pd-info-header>div:first-child{flex:2}#pd-info-header>div:first-child p{font-family:var(--arianee-font-title, \"Inter-Bold\");color:#202224;font-size:1.2em;margin:4px 0}#pd-info-header>div:nth-child(2){flex:1;text-align:right}#pd-info-description{font-family:var(--arianee-font-text, \"Inter-Regular\");color:#6c6d6f;padding:0 16px}.lost{color:#ec0000;font-weight:700;margin:8px 16px;border:1px solid #ec0000;border-radius:5px;padding:7px 5px 5px;text-align:center}#pd-info-footer{display:flex;flex-wrap:wrap;padding:0 16px}#pd-info-footer>p{position:relative;margin:16px 8px 8px;color:#202224;font-family:var(--arianee-font-text, \"Inter-Regular\");padding:6px 25px;border:1px solid #202224}#pd-info-footer>p.btn-with-icon{padding:6px 24px 6px 35px}#pd-info-footer>p.btn-with-icon ion-icon{position:absolute;left:10px;margin-top:2px}#pd-info-footer ion-badge{position:absolute;top:-10px;right:-10px}#pd-info-footer .disabled{color:#ccc;border:1px solid #ccc}#pd-info-links{padding:0 16px;font-family:var(--arianee-font-title, \"Inter-Bold\");color:#202224;font-size:1.2em;margin:16px 0 8px}#pd-info-links>p:first-child{border-top:0}#pd-info-links>p{border-top:1px solid #f1f1f1;padding-top:5px;display:flex;flex-wrap:wrap;align-items:center}#pd-info-links>p>a{flex:1}.pd-info-link{margin:8px 0;font-family:var(--arianee-font-text, \"Inter-Regular\")}.externalLinks{text-decoration:none;font-size:.9em;color:rgba(var(--ion-color-primary-rgb),1)}.externalLinks.externalLinks--isNotOwner{color:rgba(var(--ion-color-primary-rgb),.4)}.pd-info-link ion-icon{font-size:24px;float:right;fill:var(--ion-color-primary)}.footer{position:absolute;bottom:0;left:0;right:0;box-shadow:0 -3px 4px #ccc;background-color:#fff}.footer.pd-swipe-container{padding:10px}.highlightedPicture{opacity:.3}.altPicture{display:inline-flex;align-items:center;justify-content:center;min-width:80px;min-height:80px;max-width:80px;max-height:80px;border-radius:8px;overflow:hidden}.altPicture img{min-width:80px;min-height:80px}.altPictureGrid{margin:8px 16px 0;padding:0;min-height:80px;max-height:80px}.altPictureGrid ion-row{min-height:80px;max-height:80px;gap:8px;overflow-x:auto;overflow-y:hidden}.altPictureGrid ion-row ion-col{text-align:center}.altPictureGrid .altPictureCol{min-width:80px;min-height:80px;max-width:80px;max-height:80px;padding:0}div.divider{border-bottom:1px solid #202224;margin:16px}.videoThumbnail{max-width:110px;height:100%;background-size:cover;background-repeat:no-repeat;background-position:center}.threeDimensionalModelPreview,.videoPreview{background-size:contain;background-repeat:no-repeat;background-position:center center}.center{text-align:center}.proof{display:flex;flex-direction:row;justify-content:center;align-items:center}.proof span{margin:15px}.proof img,.proof ion-spinner{margin-right:10px}.proof p{margin:0}.description-container,.serialnumber-container{font-family:var(--arianee-font-text, \"Inter-Regular\");color:#6c6d6f;padding:0 16px}.description-container .max-height-description{position:relative;max-height:8em;overflow:hidden}.description-container .max-height-description::after{content:\"\";display:block;position:absolute;width:100%;height:5em;bottom:0;background:linear-gradient(rgba(255,255,255,0),var(--arianee-color-primary,#fff))}.description-container .seemore{position:relative;top:-1.5em;color:#000;display:flex;opacity:.6;justify-content:center;align-items:center}.description-container .seemore ion-icon{height:30px;width:30px}.ion-notification{position:absolute;top:0;right:0;opacity:.9}#labels{padding:5px 16px;display:flex;justify-content:flex-start;flex-direction:row}#labels img{display:block;width:auto;height:54px;margin-right:10px}.popoverMore .popover-content{width:820px!important}.button_big{white-space:normal;height:4em}.button_big .button_big__content{display:flex;flex-direction:column}.button_big .button_big__content .button_big__title{font-weight:bolder}.button_big .button_big__content .button_big__subtitle{font-size:smaller;margin-top:.3em;color:#323232}.ARPrimary{position:absolute;bottom:0;right:0;display:flex;align-items:center;justify-content:center;gap:5px;border-radius:10px;padding:3px 7px;font-size:20px;color:#666;border:2px solid #666;background-color:#eceaea}.ARPrimary .label-wrapper{height:20px}b{font-family:var(--arianee-font-text, \"Inter-Bold\")}lib-model-viewer,video{position:relative;width:100%;height:100%}.flex-row{display:flex}.footer-cta{display:flex;align-items:center;justify-content:center;flex-direction:column;gap:18px;padding:16px;border-radius:20px 20px 0 0}.footer-cta::before{display:none}.footer-cta .button__download,.footer-cta .button__ownership{background:#000;border-radius:20px;width:100%;color:#fff;font-weight:700;font-size:16px;line-height:22px;height:48px}.footer-cta .link-button{font-weight:700;font-size:16px;line-height:22px;display:flex;align-items:center;text-align:center;color:#0e0f11!important}.claim-container{display:flex;align-items:center;flex-direction:column;gap:0;width:100%}.claim-container__back{font-weight:500;font-size:14px;line-height:20px;display:flex;align-items:center;text-align:center;color:#000;margin-right:auto;width:100%}.claim-container__header{display:flex;align-items:center;text-align:center;flex-direction:column;font-size:18px;line-height:22px;color:#0e0f11;gap:20px;padding-bottom:24px}.claim-container__header .title{font-weight:700}.claim-container__header .description{font-weight:500}.claim-container__back a{font-weight:500;font-size:14px;line-height:20px;color:#000!important}.claim-container__form{display:flex;align-items:center;justify-content:center;flex-direction:column;color:#fff;width:100%}.claim-container__form form{width:100%;display:flex;align-items:center;justify-content:center;flex-direction:column}.claim-container__form form small{color:#000;margin-right:auto;padding-bottom:16px;min-height:31px}.claim-container__form form .title{font-weight:700;font-size:16px;line-height:22px;color:#0e0f11;margin-right:auto}.claim-container__form form .input-container{height:44px;display:flex;justify-content:center;align-items:center;border-bottom:1px solid #7c7d80;width:100%}.claim-container__form form .input-container .input{display:flex;flex-direction:row;justify-content:center;align-items:center;padding:8px 0 12px;gap:8px;flex-grow:1;height:44px;background:0 0;color:#0e0f11;line-height:1;box-sizing:border-box;outline:0;border:none}.claim-container__form form .input-container .paste-button{display:flex;flex-direction:row;justify-content:center;align-items:center;padding:2px 8px;gap:10px;width:47px;height:20px;background:#fff;border-radius:6px}.claim-container__form form .button{display:flex;flex-direction:row;justify-content:center;align-items:center;padding:12px 24px;gap:8px;width:100%;height:48px;font-weight:700;font-size:16px;line-height:22px;border-radius:20px;margin-top:16px;transition:background-color .5s}"]
            }] }
];
/** @nocollapse */
ProductViewComponent.ctorParameters = () => [
    { type: PhotoViewer },
    { type: Renderer2 },
    { type: FormBuilder }
];
ProductViewComponent.propDecorators = {
    scrollElement: [{ type: ViewChild, args: ['scrollElement', { static: false },] }],
    mainViewParent: [{ type: ViewChild, args: ['mainViewParent', { static: true },] }],
    viewer: [{ type: ViewChild, args: ['viewer', { static: true },] }],
    productMainImg: [{ type: ViewChild, args: ['productMainImg', { static: false, read: ElementRef },] }],
    walletDescription: [{ type: ViewChild, args: ['walletDescription', { static: false },] }],
    productLinks: [{ type: ViewChild, args: ['productLinks', { static: false },] }],
    modelViewer: [{ type: ViewChild, args: ['modelViewer', { static: false },] }],
    description: [{ type: ViewChild, args: ['description', { static: true },] }],
    certificateDisplay: [{ type: Input, args: ['certificateDisplay',] }],
    certificateId: [{ type: Input, args: ['certificateId',] }],
    passphrase: [{ type: Input, args: ['passphrase',] }],
    identity: [{ type: Input, args: ['identity',] }],
    isRequestableButton: [{ type: Input, args: ['isRequestableButton',] }],
    pendingEventsLength: [{ type: Input, args: ['pendingEventsLength',] }],
    labels: [{ type: Input, args: ['labels',] }],
    method: [{ type: Input, args: ['method',] }],
    unreadNotification: [{ type: Input, args: ['unreadNotification',] }],
    displayNavBar: [{ type: Input, args: ['displayNavBar',] }],
    displayHistoryBtn: [{ type: Input, args: ['displayHistoryBtn',] }],
    proof: [{ type: Input, args: ['proof',] }],
    showProof: [{ type: Input, args: ['showProof',] }],
    actionMenuItems: [{ type: Input, args: ['actionMenuItems',] }],
    allowClaimWithAddress: [{ type: Input, args: ['allowClaimWithAddress',] }],
    events: [{ type: Input, args: ['events',] }],
    address: [{ type: Input, args: ['address',] }],
    isMissing: [{ type: Input, args: ['isMissing',] }],
    isStolen: [{ type: Input, args: ['isStolen',] }],
    isClaimedPendingCertificate: [{ type: Input, args: ['isClaimedPendingCertificate',] }],
    displayViewCert: [{ type: Input, args: ['displayViewCert',] }],
    CTAButtonLabel: [{ type: Input, args: ['CTAButtonLabel',] }],
    linkButtonLabel: [{ type: Input, args: ['linkButtonLabel',] }],
    requestableFooter: [{ type: Input, args: ['requestableFooter',] }],
    proofFooter: [{ type: Input, args: ['proofFooter',] }],
    onBrandClick: [{ type: Output, args: ['onBrandClick',] }],
    onLinkClick: [{ type: Output, args: ['onLinkClick',] }],
    onSwipeClick: [{ type: Output, args: ['onSwipeClick',] }],
    onMessageClick: [{ type: Output, args: ['onMessageClick',] }],
    onToggleLost: [{ type: Output, args: ['onToggleLost',] }],
    onShowProofModal: [{ type: Output, args: ['onShowProofModal',] }],
    onClickViewCert: [{ type: Output, args: ['onClickViewCert',] }],
    onClickHistory: [{ type: Output, args: ['onClickHistory',] }],
    onClickTransaprency: [{ type: Output, args: ['onClickTransaprency',] }],
    onClickTransparencyItems: [{ type: Output, args: ['onClickTransparencyItems',] }],
    onClickLabelModal: [{ type: Output, args: ['onClickLabelModal',] }],
    onClickPGeneve: [{ type: Output, args: ['onClickPGeneve',] }],
    onClickSwissMade: [{ type: Output, args: ['onClickSwissMade',] }],
    onClickMore: [{ type: Output, args: ['onClickMore',] }],
    onClickCtaButton: [{ type: Output, args: ['onClickCtaButton',] }],
    onClickShareBtn: [{ type: Output, args: ['onClickShareBtn',] }],
    onClickClaimBtn: [{ type: Output, args: ['onClickClaimBtn',] }]
};
if (false) {
    /** @type {?} */
    ProductViewComponent.prototype.scrollElement;
    /** @type {?} */
    ProductViewComponent.prototype.mainViewParent;
    /** @type {?} */
    ProductViewComponent.prototype.viewer;
    /** @type {?} */
    ProductViewComponent.prototype.productMainImg;
    /** @type {?} */
    ProductViewComponent.prototype.walletDescription;
    /** @type {?} */
    ProductViewComponent.prototype.productLinks;
    /** @type {?} */
    ProductViewComponent.prototype.modelViewer;
    /** @type {?} */
    ProductViewComponent.prototype.description;
    /** @type {?} */
    ProductViewComponent.prototype.certificateDisplay;
    /** @type {?} */
    ProductViewComponent.prototype.certificateId;
    /** @type {?} */
    ProductViewComponent.prototype.passphrase;
    /** @type {?} */
    ProductViewComponent.prototype.identity;
    /** @type {?} */
    ProductViewComponent.prototype.isRequestableButton;
    /** @type {?} */
    ProductViewComponent.prototype.pendingEventsLength;
    /** @type {?} */
    ProductViewComponent.prototype.labels;
    /** @type {?} */
    ProductViewComponent.prototype.method;
    /** @type {?} */
    ProductViewComponent.prototype.unreadNotification;
    /** @type {?} */
    ProductViewComponent.prototype.displayNavBar;
    /** @type {?} */
    ProductViewComponent.prototype.displayHistoryBtn;
    /** @type {?} */
    ProductViewComponent.prototype.proof;
    /** @type {?} */
    ProductViewComponent.prototype.showProof;
    /** @type {?} */
    ProductViewComponent.prototype.actionMenuItems;
    /** @type {?} */
    ProductViewComponent.prototype.allowClaimWithAddress;
    /** @type {?} */
    ProductViewComponent.prototype.events;
    /** @type {?} */
    ProductViewComponent.prototype.address;
    /** @type {?} */
    ProductViewComponent.prototype.isMissing;
    /** @type {?} */
    ProductViewComponent.prototype.isStolen;
    /** @type {?} */
    ProductViewComponent.prototype.isClaimedPendingCertificate;
    /** @type {?} */
    ProductViewComponent.prototype.displayViewCert;
    /** @type {?} */
    ProductViewComponent.prototype.CTAButtonLabel;
    /** @type {?} */
    ProductViewComponent.prototype.linkButtonLabel;
    /** @type {?} */
    ProductViewComponent.prototype.requestableFooter;
    /** @type {?} */
    ProductViewComponent.prototype.proofFooter;
    /** @type {?} */
    ProductViewComponent.prototype.onBrandClick;
    /** @type {?} */
    ProductViewComponent.prototype.onLinkClick;
    /** @type {?} */
    ProductViewComponent.prototype.onSwipeClick;
    /** @type {?} */
    ProductViewComponent.prototype.onMessageClick;
    /** @type {?} */
    ProductViewComponent.prototype.onToggleLost;
    /** @type {?} */
    ProductViewComponent.prototype.onShowProofModal;
    /** @type {?} */
    ProductViewComponent.prototype.onClickViewCert;
    /** @type {?} */
    ProductViewComponent.prototype.onClickHistory;
    /** @type {?} */
    ProductViewComponent.prototype.onClickTransaprency;
    /** @type {?} */
    ProductViewComponent.prototype.onClickTransparencyItems;
    /** @type {?} */
    ProductViewComponent.prototype.onClickLabelModal;
    /** @type {?} */
    ProductViewComponent.prototype.onClickPGeneve;
    /** @type {?} */
    ProductViewComponent.prototype.onClickSwissMade;
    /** @type {?} */
    ProductViewComponent.prototype.onClickMore;
    /** @type {?} */
    ProductViewComponent.prototype.onClickCtaButton;
    /** @type {?} */
    ProductViewComponent.prototype.onClickShareBtn;
    /** @type {?} */
    ProductViewComponent.prototype.onClickClaimBtn;
    /** @type {?} */
    ProductViewComponent.prototype.claimForm;
    /** @type {?} */
    ProductViewComponent.prototype.showClaimForm;
    /** @type {?} */
    ProductViewComponent.prototype.embedURL;
    /** @type {?} */
    ProductViewComponent.prototype.hightlightPicture;
    /** @type {?} */
    ProductViewComponent.prototype.hightlightMediaIndex;
    /** @type {?} */
    ProductViewComponent.prototype.hightlightPictureIndex;
    /** @type {?} */
    ProductViewComponent.prototype.highlightARMediaIndex;
    /** @type {?} */
    ProductViewComponent.prototype.selected3dModel;
    /** @type {?} */
    ProductViewComponent.prototype.selected3dModelIndex;
    /** @type {?} */
    ProductViewComponent.prototype.selectedVideo;
    /** @type {?} */
    ProductViewComponent.prototype.selectedVideoIndex;
    /** @type {?} */
    ProductViewComponent.prototype.hostedWallet;
    /** @type {?} */
    ProductViewComponent.prototype.footerTranslateParam;
    /** @type {?} */
    ProductViewComponent.prototype.seeMore;
    /** @type {?} */
    ProductViewComponent.prototype.overlayImg;
    /** @type {?} */
    ProductViewComponent.prototype.hideMiniPreview;
    /**
     * @type {?}
     * @private
     */
    ProductViewComponent.prototype.specialExternalContentType;
    /**
     *
     * GET responsive width
     * (not page width but parent width, PWA constraint)
     * AND Set Height to make a perfect square for viewer
     * @type {?}
     */
    ProductViewComponent.prototype.setViewerHeight;
    /**
     * @type {?}
     * @private
     */
    ProductViewComponent.prototype.photoViewer;
    /**
     * @type {?}
     * @private
     */
    ProductViewComponent.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    ProductViewComponent.prototype.formBuilder;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @ts-ignore
/** @type {?} */
const qrcode = require('qrcode');
// example <angular-qr-code link="http://arian.ee/id,passphrase" ></angular-qr-code>
class QrCodeComponent {
    /**
     * @param {?} renderer
     */
    constructor(renderer) {
        this.renderer = renderer;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        qrcode.toDataURL(this.qrcodeElement.nativeElement, this.link, { errorCorrectionLevel: 'L', margin: 0, width: 160, height: 160 });
    }
}
QrCodeComponent.decorators = [
    { type: Component, args: [{
                selector: 'angular-qr-code',
                template: "<canvas class=\"qrCode\" #qrcodeElement></canvas>\n",
                styles: [".qrCode{height:100%!important;width:100%!important}"]
            }] }
];
/** @nocollapse */
QrCodeComponent.ctorParameters = () => [
    { type: Renderer2 }
];
QrCodeComponent.propDecorators = {
    link: [{ type: Input, args: ['link',] }],
    qrcodeElement: [{ type: ViewChild, args: ['qrcodeElement', { static: true },] }]
};
if (false) {
    /** @type {?} */
    QrCodeComponent.prototype.link;
    /** @type {?} */
    QrCodeComponent.prototype.qrcodeElement;
    /**
     * @type {?}
     * @private
     */
    QrCodeComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EventsListComponent {
    /**
     * @param {?} translate
     */
    constructor(translate) {
        this.translate = translate;
        this.onClickViewMore = new EventEmitter();
        this.onClickRefuseEvent = new EventEmitter();
        this.onClickAcceptEvent = new EventEmitter();
        this.fakeEvent = [{}, {}];
        this.indexSlide = 'internalSlide';
        this.slideOpts = {
            speed: 400,
            allowTouchMove: false
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.locale = this.translate.currentLang;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    clickViewMore(index) {
        return __awaiter(this, void 0, void 0, function* () {
            this.onClickViewMore.emit(index);
            this.indexSlide = 'internalSlide event_' + index;
            this.slideTitle = this.events[index].title;
            this.slideSubTitle = this.events[index].subtitle;
            this.slideContent = (this.events[index].detail && this.events[index].detail.description) ? this.events[index].detail.description : this.events[index].description;
            this.sliders.slideNext();
        });
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.sliders.slidePrev();
    }
    /**
     * @param {?} eventId
     * @param {?} index
     * @return {?}
     */
    refuseEvent(eventId, index) {
        this.onClickRefuseEvent.emit([eventId, index]);
    }
    /**
     * @param {?} eventId
     * @param {?} index
     * @return {?}
     */
    acceptEvent(eventId, index) {
        this.onClickAcceptEvent.emit([eventId, index]);
    }
    /**
     * @param {?} transparencyItem
     * @return {?}
     */
    getCategoryImage(transparencyItem) {
        /** @type {?} */
        const medias = get(transparencyItem, 'medias');
        if (medias && medias.length > 0) {
            /** @type {?} */
            const icon = medias.find((/**
             * @param {?} media
             * @return {?}
             */
            (media) => media.type === 'icon'));
            if (icon)
                return icon.url;
        }
        switch (transparencyItem.category) {
            case 'material':
                return 'assets/imgs/Materiaux.png';
            case 'assembly':
                return 'assets/imgs/Manufacture.png';
            case 'impact':
                return 'assets/imgs/Impact.png';
            default:
                return '';
        }
    }
}
EventsListComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-events-list',
                template: "<lib-customizable-modal-wrapper>\n  <div *ngIf=\"!loader; else skeleton\" [ngClass]=\"eventType\" style=\"display: flex;\">\n    <ion-slides #sliders [options]=\"slideOpts\">\n      <ion-slide>\n        <div *ngFor=\"let event of events; let i = index;\"\n             [attr.data-e2e]=\"'event_item_'+i\"\n             [ngClass]=\"'pd-history-main-item eventMain_'+i\">\n          <div [attr.data-e2e]=\"'event_'+event.id\" [ngClass]=\"'pd-history-main-item-content event_'+i\">\n\n            <div (click)=\"clickViewMore(i)\" class=\"pd-history-main-item-info\">\n\n              <div *ngIf=\"event?.avatar!='no' && !event.category\">\n                <div>\n                  <img *ngIf=\"event?.avatar&&event.publicKey!=address\" [src]=\"event?.avatar\"/>\n                  <angular-jazzicon *ngIf=\"!event?.avatar&&event.publicKey!=address\"\n                                    seed=\"{{event.publicKey}}\"></angular-jazzicon>\n                  <ion-icon *ngIf=\"event.publicKey==address\" name=\"person-circle\" style='font-size:60px'></ion-icon>\n\n                </div>\n              </div>\n\n              <div *ngIf=\"event.category\">\n                <div>\n                  <img *ngIf=\"event.category\" src=\"{{ getCategoryImage(event) | imageSrc}}\"/>\n                </div>\n              </div>\n\n              <div>\n                <p *ngIf=\"event.title=='ownership_transfer'&&event.publicKey.toLowerCase()==address.toLowerCase()\">\n                  {{'CertificateEvents.receivedByYou' | translate}}\n                </p>\n                <p *ngIf=\"event.title=='ownership_transfer'&&event.publicKey!=address\">\n                  {{'CertificateEvents.receivedBySomeone' | translate}}\n                </p>\n                <p *ngIf=\"event.title!='ownership_transfer'\" class=\"eventTitle\" data-e2e=\"event_title\">\n                  {{event.title}}\n                </p>\n                <span *ngIf=\"event.date\" class=\"date\">\n                                {{  event.date | amLocale:locale | amDateFormat:'LLL' }}\n                            </span>\n                <span *ngIf=\"event.subtitle\" class=\"eventSubtitle\" data-e2e=\"event_subtitle\">\n                                {{ event.subtitle }}\n                            </span>\n                <span *ngIf=\"event.type\" class=\"eventType\">\n                                    {{event.type ? ('eventType.' + event.type | translate) : \"\"}} &nbsp;\n                            </span>\n              </div>\n\n              <div\n                *ngIf=\"(event.detail) && (event.detail.description || event.detail.imgurl) && (!event.viewdetail ||\u00A0eventType!='history')\">\n                <ion-icon mode=\"ios\" name=\"arrow-forward\"></ion-icon>\n              </div>\n\n              <div\n                *ngIf=\"(event.detail) && (event.detail.description || event.detail.imgurl) && event.viewdetail && eventType=='history'\">\n                <ion-icon mode=\"ios\" name=\"arrow-down\"></ion-icon>\n              </div>\n\n            </div>\n\n            <div *ngIf=\"event.viewdetail\" class=\"pd-history-main-item-detail\">\n              <div *ngIf=\"event.detail.imgurl\" class=\"eventImg\">\n                <img [src]=\"event.detail.imgurl  | imageProxy | async\"/>\n              </div>\n              <div>\n                <p *ngIf=\"event.detail && event.detail.description\" class=\"pd-history-main-detail-description\"\n                   data-e2e=\"event_description\">\n                  {{event.detail.description}}\n                </p>\n                <div *ngIf=\"event.pending\" class=\"arianeeEventsButton\">\n                  <ion-button (click)=\"refuseEvent(event.id, i)\" color=\"pink\">{{'CertificateEvents.refuse' |\n                    translate}}\n                  </ion-button>\n                  <ion-button (click)=\"acceptEvent(event.id, i)\" color=\"success\">{{'CertificateEvents.accept' |\n                    translate}}\n                  </ion-button>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"pd-history-main-item-footer\">\n            <div></div>\n\n          </div>\n        </div>\n\n        <!--div *ngIf=\"eventType=='pgeneve'\" class=\"pd-geneve\" [innerHTML]=\"('PGeneve.compliesWith'| translate) | safeHtml\"></div-->\n        <div *ngIf=\"eventType=='swissmade'\" [innerHTML]=\"('SwissMade.compliesWith' | translate) | safeHtml\"\n             class=\"pd-swissmade\"></div>\n\n\n      </ion-slide>\n\n      <ion-slide *ngIf=\"isSlide\">\n        <div [ngClass]=indexSlide>\n          <div class=\"subInternalSlide\">\n            <div class=\"slideTitle\">\n              <div>\n                <div class=\"slideTitle2\">\n                  {{slideTitle}}\n                </div>\n                <div class=\"slideSubTitle\">\n                  {{slideSubTitle}}\n                </div>\n              </div>\n\n              <div>\n                <ion-icon (click)=\"onClickClose()\" class=\"iconSize\" color=\"black\" name=\"close\"></ion-icon>\n              </div>\n            </div>\n            <div [innerHTML]=\"slideContent | safeHtml\" class=\"slideContent\">\n            </div>\n          </div>\n        </div>\n      </ion-slide>\n\n\n    </ion-slides>\n\n  </div>\n</lib-customizable-modal-wrapper>\n\n<ng-template #skeleton>\n  <div data-e2e=\"skeleton\">\n    <p>\n      <ion-skeleton-text animated></ion-skeleton-text>\n    </p>\n    <div *ngFor=\"let history of fakeEvent\" class=\"pd-history-main-item\">\n      <div class=\"pd-history-main-item-content\">\n        <div class=\"pd-history-main-item-info\">\n          <div>\n            <div>\n\n              <ion-skeleton-text animated style=\"width:100%;height:100%;\"></ion-skeleton-text>\n            </div>\n          </div>\n          <div>\n            <p>\n              <ion-skeleton-text animated></ion-skeleton-text>\n            </p>\n\n            <p>\n              <ion-skeleton-text animated></ion-skeleton-text>\n            </p>\n          </div>\n          <div>\n            <div>\n              <ion-icon mode=\"ios\" name=\"arrow-forward\"></ion-icon>\n            </div>\n            <p>\n              <ion-skeleton-text animated></ion-skeleton-text>\n            </p>\n          </div>\n        </div>\n      </div>\n      <div class=\"pd-history-main-item-footer\">\n        <div></div>\n      </div>\n\n    </div>\n  </div>\n</ng-template>\n",
                styles: [".slide-zoom,.swiper-slide{text-align:left}.pd-history-main-item-info{display:flex;align-items:center}.pd-history-main-item-info>div:first-child{flex:1;display:flex;align-items:center;max-width:60px}.pd-history-main-item-info>div:first-child>div{width:60px;height:60px;border-radius:120px;overflow:hidden}.pd-history-main-item-info>div:first-child>div img{width:100%;height:100%}.pd-history-main-item-info>div:nth-child(2){display:flex;flex-direction:column;padding:0 12px;width:100%}.pd-history-main-item-info>div:nth-child(2) p{margin:4px 0}.pd-history-main-item-info>div:nth-child(2)>p:first-child{font-family:Inter-Bold;color:#1c1c1c}.pd-history-main-item-info>div:nth-child(2)>p:nth-child(2){font-family:Inter-Regular;color:#8a8a8a}.pd-history-main-item-info>div:nth-child(3){flex:1}.pd-history-main-item-info>div:nth-child(3)>div{text-align:right}.pd-history-main-item-info>div:nth-child(3)>p{margin:4px 0;font-family:Inter-Bold}ion-slides{width:100%;overflow:hidden!important}ion-slides ion-slide{padding:10px}.pd-history-main-item-content{background-color:#fff;box-shadow:0 0 12px #969696;padding:8px;border-radius:8px;cursor:pointer}.pd-history-main-item-footer{position:relative;height:48px}.pd-history-main-item-footer>div{position:absolute;height:48px;width:2px;background-color:var(--modal-border-color,#979797);left:50%;transform:translate(-50%,0)}.pd-history-main-item-footer>p{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);margin:0;background-color:#fff;font-family:Inter-Regular;font-size:.9em;color:#959595}.pd-history-main-item-detail{display:flex;margin-top:3vh}.pd-history-main-item-detail>div{flex:2}.pd-history-main-item-detail>div:first-child img{border-radius:8px}.pd-history-main-item-detail>div:nth-child(2){padding:0 8px}.pd-history-main-item-detail>div:nth-child(2)>div{display:flex;text-align:center}.pd-history-main-item-detail .eventImg{flex-grow:1}.pd-history-main-detail-description{font-family:Inter-Regular;color:#8a8a8a;margin:0}ion-datetime{padding:0}.date,.subtitle{color:#999;font-family:Inter-Regular;font-size:.9em}.arianeeEventsButton{display:flex;justify-content:flex-end}.pgeneve .event_0{background-image:url(/assets/imgs/Origin.jpg);background-size:100%;background-position-y:50%}.pgeneve .event_1{background-image:url(/assets/imgs/High_Watchmaking.jpg);background-size:100%;background-position-y:50%}.pgeneve .event_2{background-image:url(/assets/imgs/Reliability.jpg);background-size:100%;background-position-y:50%}.pgeneve .eventTitle{font-size:1.7em;display:block;width:100%;text-align:center;margin:0;padding-top:22px;color:#bea182;font-family:PreloCondensed-Medium;text-transform:uppercase}.pgeneve .slideTitle2{font-size:1.3em;display:block;width:100%;margin:0;padding-top:5px;color:#bea182;font-family:PreloCondensed-Medium;text-transform:uppercase}.pgeneve .slideSubTitle{font-family:PreloCondensed-Medium;display:block;width:100%;color:#666;padding-bottom:5px;text-transform:uppercase;font-size:1em}.pgeneve .eventSubtitle,.pgeneve .eventType{display:none!important}.pgeneve .pd-history-main-item-content{padding:0}.pgeneve .pd-history-main-item-detail{display:none}.pgeneve .pd-history-main-item-footer,.pgeneve .pd-history-main-item-footer>div{height:30px}.pgeneve .eventMain_2 .pd-history-main-item-footer{visibility:hidden;height:10px}.pgeneve .pd-history-main-item-info{border-radius:8px;background-color:#fffD;display:block;align-items:center}.pgeneve .pd-history-main-item-info>div:first-child{flex:0;display:block;align-items:center;width:100%;max-width:100%;height:65px}.pgeneve .pd-history-main-item-info>div:first-child>div{width:100%;height:60px;border-radius:120px;overflow:hidden}.pgeneve .pd-history-main-item-info>div:first-child>div img{width:100%;height:100%}.pgeneve .pd-history-main-item-info>div:nth-child(2){flex-direction:column;padding:0 12px;width:100%;right:0;text-align:right;position:relative;top:-30px;display:block}.pgeneve .pd-history-main-item-info>div:nth-child(2) p{margin:4px 0}.pgeneve .pd-history-main-item-info>div:nth-child(2)>p:first-child{font-family:Inter-Bold;color:#1c1c1c}.pgeneve .pd-history-main-item-info>div:nth-child(2)>p:nth-child(2){font-family:Inter-Regular;color:#8a8a8a}.pgeneve .pd-history-main-item-info>div:nth-child(3){flex:1}.pgeneve .pd-history-main-item-info>div:nth-child(3)>div{text-align:right}.pgeneve .pd-history-main-item-info>div:nth-child(3)>p{margin:4px 0;font-family:Inter-Bold}.pgeneve .swiper-zoom-container{display:initial}.pgeneve .swiper-container{overflow:initial}.pgeneve .slideTitle{text-align:left;font-size:1.3em!important;padding-bottom:10px;display:flex;align-items:center}.pgeneve .slideTitle>div:first-child{flex:3}.pgeneve .slideTitle>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.pgeneve .slideTitle>div:nth-child(2){text-align:right}.pgeneve .slideTitle>div:nth-child(2) ion-icon{font-size:1em}.pgeneve .slideContent{font-size:.9em;text-align:justify;font-family:PreloCondensed-Light}.pgeneve .swiper-slide{font-size:initial}.pgeneve .slide-zoom,.pgeneve .swiper-slide{text-align:initial}.pgeneve .swiper-wrapper{width:90%!important;margin:auto!important}.pgeneve .internalSlide{width:90%;margin-left:5%;margin-right:5%;background-size:cover;background-position-y:50%;border-radius:15px}.pgeneve .internalSlide .event_0{background-image:url(/assets/imgs/Origin.jpg)}.pgeneve .internalSlide .event_1{background-image:url(/assets/imgs/High_Watchmaking.jpg)}.pgeneve .internalSlide .event_2{background-image:url(/assets/imgs/Reliability.jpg)}.pgeneve .subInternalSlide{border-radius:15px;background-color:#fffD;padding-left:5%;padding-right:5%}.pgeneve .pd-geneve{color:#666;font-size:.9em;font-family:PreloCondensed-Light}.pgeneve ion-slide{height:355px;overflow-y:auto}:host ::ng-deep table.pgeneve-table td{vertical-align:top}:host ::ng-deep table.pgeneve-table span.title{font-weight:700;margin-bottom:5px}:host ::ng-deep table.pgeneve-table p{margin:0 0 3px}:host ::ng-deep table.pgeneve-table ul{padding:0;margin:0;list-style:none}:host ::ng-deep table.pgeneve-table ul li{padding-left:10px}:host ::ng-deep table.pgeneve-table ul li:before{content:\"-\";margin-right:5px;margin-left:-10px}:host ::ng-deep table.pgeneve-table span.img{border-radius:10px;margin-right:10px;display:block;height:80px;width:80px;background-size:cover}:host ::ng-deep table.pgeneve-table.origin:first-child span.img{background-image:url(/assets/imgs/pgeneve/origin1.jpg)}:host ::ng-deep table.pgeneve-table.origin:nth-child(2) span.img{background-image:url(/assets/imgs/pgeneve/origin2.jpg)}:host ::ng-deep table.pgeneve-table.origin:nth-child(3) span.img{background-image:url(/assets/imgs/pgeneve/origin3.jpg)}:host ::ng-deep table.pgeneve-table.origin:nth-child(4) span.img{background-image:url(/assets/imgs/pgeneve/origin4.jpg)}:host ::ng-deep table.pgeneve-table.watchmaking:first-child span.img{background-image:url(/assets/imgs/pgeneve/watchmaking1.jpg)}:host ::ng-deep table.pgeneve-table.reliability:first-child span.img{background-image:url(/assets/imgs/pgeneve/reliability1.jpg)}:host ::ng-deep table.pgeneve-table.reliability:nth-child(2) span.img{background-image:url(/assets/imgs/pgeneve/reliability2.jpg)}:host ::ng-deep table.pgeneve-table.reliability:nth-child(3) span.img{background-image:url(/assets/imgs/pgeneve/reliability3.jpg)}:host ::ng-deep table.pgeneve-table.reliability:nth-child(4) span.img{background-image:url(/assets/imgs/pgeneve/reliability4.jpg)}.swissmade .event_0{background-image:url(/assets/imgs/swissmade1.png);background-size:100%;background-position-y:50%}.swissmade .event_1{background-image:url(/assets/imgs/swissmade2.png);background-size:100%;background-position-y:50%}.swissmade .event_2{background-image:url(/assets/imgs/swissmade3.png);background-size:100%;background-position-y:50%}.swissmade .eventTitle{font-size:1.5em;display:block;width:100%;text-align:center;margin:0;padding-top:5px;color:#bea182;font-family:PreloCondensed-Medium;text-transform:uppercase}.swissmade .eventSubtitle{font-family:PreloCondensed-Medium;display:block;width:100%;text-align:center;color:#666;padding-bottom:5px;text-transform:uppercase;font-size:.9em}.swissmade .slideTitle2{font-size:1.3em;display:block;width:100%;margin:0;padding-top:5px;color:#bea182;font-family:PreloCondensed-Medium;text-transform:uppercase}.swissmade .slideSubTitle{font-family:PreloCondensed-Medium;display:block;width:100%;color:#666;padding-bottom:5px;text-transform:uppercase;font-size:1em}.swissmade .eventType{display:none!important}.swissmade .pd-history-main-item-content{padding:0}.swissmade .pd-history-main-item-detail{display:none}.swissmade .pd-history-main-item-footer,.swissmade .pd-history-main-item-footer>div{height:30px}.swissmade .eventMain_2 .pd-history-main-item-footer{visibility:hidden;height:10px}.swissmade .pd-history-main-item-info{height:70px;border-radius:8px;background-color:#fffD;display:block;align-items:center}.swissmade .pd-history-main-item-info>div:first-child{flex:0;display:block;align-items:center;width:100%;max-width:100%}.swissmade .pd-history-main-item-info>div:first-child>div{width:100%;height:60px;border-radius:120px;overflow:hidden}.swissmade .pd-history-main-item-info>div:first-child>div img{width:100%;height:100%}.swissmade .pd-history-main-item-info>div:nth-child(2){flex-direction:column;padding:0 12px;width:100%;right:0;text-align:right;position:relative;top:-37px;display:block}.swissmade .pd-history-main-item-info>div:nth-child(2) p{margin:4px 0}.swissmade .pd-history-main-item-info>div:nth-child(2)>p:first-child{font-family:Inter-Bold;color:#1c1c1c}.swissmade .pd-history-main-item-info>div:nth-child(2)>p:nth-child(2){font-family:Inter-Regular;color:#8a8a8a}.swissmade .pd-history-main-item-info>div:nth-child(3){flex:1}.swissmade .pd-history-main-item-info>div:nth-child(3)>div{text-align:right}.swissmade .pd-history-main-item-info>div:nth-child(3)>p{margin:4px 0;font-family:Inter-Bold}.swissmade .swiper-zoom-container{display:initial}.swissmade .swiper-container{overflow:initial}.swissmade .slideTitle{text-align:left;font-size:1.3em!important;padding-bottom:10px;display:flex;align-items:center}.swissmade .slideTitle>div:first-child{flex:3}.swissmade .slideTitle>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.swissmade .slideTitle>div:nth-child(2){text-align:right}.swissmade .slideTitle>div:nth-child(2) ion-icon{font-size:1em}.swissmade .slideContent{font-size:.9em;text-align:justify;font-family:PreloCondensed-Light}.swissmade .slideContent .table{width:100%}.swissmade .slideContent .td{width:33%;font-weight:700;text-align:center}.swissmade .swiper-slide{font-size:initial}.swissmade .slide-zoom,.swissmade .swiper-slide{text-align:initial}.swissmade .swiper-wrapper{width:90%!important;margin:auto!important}.swissmade .internalSlide{width:90%;margin-left:5%;margin-right:5%;background-size:cover;background-position-y:50%;border-radius:15px}.swissmade .internalSlide .event_0{background-image:url(/assets/imgs/Origin.jpg)}.swissmade .internalSlide .event_1{background-image:url(/assets/imgs/High_Watchmaking.jpg)}.swissmade .internalSlide .event_2{background-image:url(/assets/imgs/Reliability.jpg)}.swissmade .subInternalSlide{border-radius:15px;background-color:#fffD;padding-left:5%;padding-right:5%}.swissmade .pd-swissmade{color:#666;font-size:.9em;font-family:PreloCondensed-Light}:host ::ng-deep table{margin-top:10px;padding-bottom:10px;display:block}:host ::ng-deep .table td{width:33%;background-size:60%;background-position:top;background-repeat:no-repeat;vertical-align:bottom;padding-left:5px;padding-right:5px;height:104px;text-align:center;font-weight:700}:host ::ng-deep .seal{background-image:url(/assets/imgs/PGE-Seal.png)}:host ::ng-deep .guarantee{background-image:url(/assets/imgs/CANTON-DE-GENEVE.png)}:host ::ng-deep .swissflag{background-image:url(/assets/imgs/SwissFlag.png);background-position-y:20px!important}:host ::ng-deep .table2 td{width:25%;background-size:60%;background-position:top;background-repeat:no-repeat;vertical-align:bottom;padding-left:5px;padding-right:5px;height:80px;text-align:center;font-weight:700;font-size:.6em}:host ::ng-deep .baseplates{background-image:url(/assets/imgs/Baselplates.png);background-position-y:16px!important}:host ::ng-deep .adjustementsystem{background-image:url(/assets/imgs/Adjustment.png);background-position-y:16px!important}:host ::ng-deep .wheeltrain{background-image:url(/assets/imgs/Wheel.png);background-position-y:8px!important}:host ::ng-deep .shapedparts{background-image:url(/assets/imgs/Parts.png);background-position-y:4px!important}:host ::ng-deep .table3 td{background-size:60%;background-position:top;background-repeat:no-repeat;vertical-align:bottom;padding-left:5px;padding-right:5px;height:80px;text-align:center;font-weight:700;font-size:.8em}:host ::ng-deep .localization{width:27%;color:#bea182}:host ::ng-deep .technical{width:46%;color:#7f7f7f}:host ::ng-deep .big{font-size:3.5em}.transparency .eventTitle{display:block;width:100%;text-align:left;margin:0 0 5px;padding-top:5px}.transparency .eventSubtitle{display:block;width:100%;text-align:left;color:#666;padding-bottom:5px}.transparency .eventType{display:none!important}.transparency .pd-history-main-item-detail{display:none}.transparency .pd-history-main-item-footer,.transparency .pd-history-main-item-footer>div{height:30px}.transparency .pd-history-main-item:last-child>.pd-history-main-item-footer{visibility:hidden}.transparency .pd-history-main-item-info{align-items:center}.transparency .pd-history-main-item-info>div:first-child{flex:1;display:block;align-items:center;width:60px;max-width:60px}.transparency .pd-history-main-item-info>div:first-child>div{width:60px;height:60px;border-radius:120px;overflow:hidden}.transparency .pd-history-main-item-info>div:first-child>div img{width:100%;height:100%}.transparency .pd-history-main-item-info>div:nth-child(2){display:flex;flex-direction:column;padding:0 12px;width:100%;position:relative;right:0;text-align:right}.transparency .pd-history-main-item-info>div:nth-child(2) p{margin:4px 0}.transparency .pd-history-main-item-info>div:nth-child(2)>p:first-child{font-family:Inter-Bold;color:#1c1c1c}.transparency .pd-history-main-item-info>div:nth-child(2)>p:nth-child(2){font-family:Inter-Regular;color:#8a8a8a}.transparency .pd-history-main-item-info>div:nth-child(3){flex:1}.transparency .pd-history-main-item-info>div:nth-child(3)>div{text-align:right}.transparency .pd-history-main-item-info>div:nth-child(3)>p{margin:4px 0;font-family:Inter-Bold}.transparency .swiper-zoom-container{display:initial}.transparency .swiper-container{overflow:initial;padding-top:10px}.transparency .slideTitle{text-align:left;font-size:1.3em!important;padding-bottom:10px;display:flex;align-items:center}.transparency .slideTitle>div:first-child{flex:3}.transparency .slideTitle>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.transparency .slideTitle>div:nth-child(2){flex:1;text-align:right}.transparency .slideTitle>div:nth-child(2) ion-icon{font-size:1em}.transparency .slideContent{font-size:.9em;font-style:italic;text-align:justify}.transparency .swiper-slide{font-size:initial}.transparency .slide-zoom,.transparency .swiper-slide{text-align:initial}.transparency .swiper-wrapper{width:90%!important;margin:auto!important}.transparency .internalSlide{width:80%;margin:auto}.history .eventTitle{display:block;width:100%;text-align:left;margin:0 0 5px;padding-top:5px}.history .eventSubtitle{width:100%;text-align:left;color:#666;padding-bottom:5px;display:none}.history .pd-history-main-item-footer,.history .pd-history-main-item-footer>div{height:30px}.history .pd-history-main-item-info{align-items:center}.history .pd-history-main-item-info>div:first-child{flex:1;display:block;align-items:center;width:60px;max-width:60px}.history .pd-history-main-item-info>div:first-child>div{width:60px;height:60px;border-radius:120px;overflow:hidden}.history .pd-history-main-item-info>div:first-child>div img{width:100%;height:100%}.history .pd-history-main-item-info>div:nth-child(2){display:flex;flex-direction:column;padding:0 12px;width:100%;position:relative;right:0}.history .pd-history-main-item-info>div:nth-child(2) p{margin:4px 0}.history .pd-history-main-item-info>div:nth-child(2)>p:first-child{font-family:Inter-Bold;color:#1c1c1c}.history .pd-history-main-item-info>div:nth-child(2)>p:nth-child(2){font-family:Inter-Regular;color:#8a8a8a}.history .pd-history-main-item-info>div:nth-child(3){flex:1}.history .pd-history-main-item-info>div:nth-child(3)>div{text-align:right}.history .pd-history-main-item-info>div:nth-child(3)>p{margin:4px 0;font-family:Inter-Bold}.history .swiper-zoom-container{display:initial}.history .swiper-container{overflow:initial;padding-top:10px}.history .slideTitle{text-align:left;font-size:1.3em!important;padding-bottom:10px;display:flex;align-items:center}.history .slideTitle>div:first-child{flex:3}.history .slideTitle>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.history .slideTitle>div:nth-child(2){flex:1;text-align:right}.history .slideTitle>div:nth-child(2) ion-icon{font-size:1em}.history .slideContent{font-size:.9em;font-style:italic;text-align:justify}.history .swiper-slide{font-size:initial}.history .slide-zoom,.history .swiper-slide{text-align:initial}.history .swiper-wrapper{width:90%!important;margin:auto!important}.history .internalSlide{width:80%;margin:auto}.transparencyItems .eventTitle{display:block;width:100%;text-align:left;margin:0 0 5px;padding-top:5px}.transparencyItems .eventSubtitle{display:block;width:100%;text-align:left;color:#666;padding-bottom:5px}.transparencyItems .eventType{display:none!important}.transparencyItems .pd-history-main-item-detail{display:none}.transparencyItems .pd-history-main-item-footer,.transparencyItems .pd-history-main-item-footer>div{height:30px}.transparencyItems .pd-history-main-item:last-child>.pd-history-main-item-footer{visibility:hidden}.transparencyItems .pd-history-main-item-info{align-items:center}.transparencyItems .pd-history-main-item-info>div:first-child{flex:1;display:block;align-items:center;width:60px;max-width:60px}.transparencyItems .pd-history-main-item-info>div:first-child>div{width:60px;height:60px;border-radius:120px;overflow:hidden}.transparencyItems .pd-history-main-item-info>div:first-child>div img{width:100%;height:100%}.transparencyItems .pd-history-main-item-info>div:nth-child(2){display:flex;flex-direction:column;padding:0 12px;width:100%;position:relative;right:0;text-align:right}.transparencyItems .pd-history-main-item-info>div:nth-child(2) p{margin:4px 0}.transparencyItems .pd-history-main-item-info>div:nth-child(2)>p:first-child{font-family:Inter-Bold;color:#1c1c1c}.transparencyItems .pd-history-main-item-info>div:nth-child(2)>p:nth-child(2){font-family:Inter-Regular;color:#8a8a8a}.transparencyItems .pd-history-main-item-info>div:nth-child(3){flex:1}.transparencyItems .pd-history-main-item-info>div:nth-child(3)>div{text-align:right}.transparencyItems .pd-history-main-item-info>div:nth-child(3)>p{margin:4px 0;font-family:Inter-Bold}.transparencyItems .swiper-zoom-container{display:initial}.transparencyItems .swiper-container{overflow:initial;padding-top:10px}.transparencyItems .slideTitle{text-align:left;font-size:1.3em!important;padding-bottom:10px;display:flex;align-items:center}.transparencyItems .slideTitle>div:first-child{flex:3}.transparencyItems .slideTitle>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.transparencyItems .slideTitle>div:nth-child(2){flex:1;text-align:right}.transparencyItems .slideTitle>div:nth-child(2) ion-icon{font-size:1em}.transparencyItems .slideContent{font-size:.9em;font-style:italic;text-align:justify}.transparencyItems .swiper-slide{font-size:initial}.transparencyItems .slide-zoom,.transparencyItems .swiper-slide{text-align:initial}.transparencyItems .swiper-wrapper{width:90%!important;margin:auto!important}.transparencyItems .internalSlide{width:80%;margin:auto}"]
            }] }
];
/** @nocollapse */
EventsListComponent.ctorParameters = () => [
    { type: TranslateService }
];
EventsListComponent.propDecorators = {
    events: [{ type: Input, args: ['events',] }],
    loader: [{ type: Input, args: ['loader',] }],
    address: [{ type: Input, args: ['address',] }],
    eventType: [{ type: Input, args: ['eventType',] }],
    isSlide: [{ type: Input, args: ['isSlide',] }],
    onClickViewMore: [{ type: Output }],
    onClickRefuseEvent: [{ type: Output }],
    onClickAcceptEvent: [{ type: Output }],
    sliders: [{ type: ViewChild, args: ['sliders', { static: false },] }]
};
if (false) {
    /** @type {?} */
    EventsListComponent.prototype.events;
    /** @type {?} */
    EventsListComponent.prototype.loader;
    /** @type {?} */
    EventsListComponent.prototype.address;
    /** @type {?} */
    EventsListComponent.prototype.eventType;
    /** @type {?} */
    EventsListComponent.prototype.isSlide;
    /** @type {?} */
    EventsListComponent.prototype.onClickViewMore;
    /** @type {?} */
    EventsListComponent.prototype.onClickRefuseEvent;
    /** @type {?} */
    EventsListComponent.prototype.onClickAcceptEvent;
    /** @type {?} */
    EventsListComponent.prototype.sliders;
    /** @type {?} */
    EventsListComponent.prototype.fakeEvent;
    /** @type {?} */
    EventsListComponent.prototype.locale;
    /** @type {?} */
    EventsListComponent.prototype.isOwner;
    /** @type {?} */
    EventsListComponent.prototype.slideTitle;
    /** @type {?} */
    EventsListComponent.prototype.slideContent;
    /** @type {?} */
    EventsListComponent.prototype.slideSubTitle;
    /** @type {?} */
    EventsListComponent.prototype.indexSlide;
    /** @type {?} */
    EventsListComponent.prototype.slideOpts;
    /** @type {?} */
    EventsListComponent.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductInfoTransparencyComponent {
    /**
     * @param {?} modalCtrl
     * @param {?} translate
     * @param {?} httpClient
     * @param {?} displayMapperService
     */
    constructor(modalCtrl, translate, httpClient, displayMapperService) {
        this.modalCtrl = modalCtrl;
        this.translate = translate;
        this.httpClient = httpClient;
        this.displayMapperService = displayMapperService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const urlHttps = this.jsonUrl.replace('http://', 'https://');
            /** @type {?} */
            const certificateDisplay = this.displayMapperService.certificateDisplayMapper(this.certificate);
            this.brandLogoHeader = certificateDisplay.brandLogoHeader;
            /** @type {?} */
            const events = yield this.httpClient.get(urlHttps).toPromise();
            this.events = events.map((/**
             * @param {?} event
             * @return {?}
             */
            event => {
                event.date = null;
                return event;
            }));
            this.logScreen('product-info-transparency', {});
        });
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
    /**
     * @param {?} index
     * @return {?}
     */
    clickViewMore(index) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.events[index].detail.htmlPage) {
                this.onClickViewMore({
                    labelOverride: {
                        description: this.events[index].detail.htmlPage
                    },
                    labelTitle: this.events[index].title
                });
            }
        });
    }
}
ProductInfoTransparencyComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-info-transparency',
                template: "<div class=\"inner-content\" data-e2e=\"product_history\">\n  <div class=\"pd-history-header\">\n    <div>\n      <p>\n        {{'CertificateTransparency.transparency' | translate}}\n      </p>\n    </div>\n    <div>\n      <ion-icon name=\"close\" (click)=\"onClickClose()\"></ion-icon>\n    </div>\n  </div>\n\n  <div class=\"pd-history-main\">\n    <div>\n      <app-events-list [events]=\"events\" [eventType]=\"'transparency'\" (onClickViewMore)=\"clickViewMore($event)\" [loader]=\"false\"></app-events-list>\n    </div>\n\n    <div class=\"pd-history-brand\">\n      <img src=\"{{brandLogoHeader}}\" />\n    </div>\n  </div>\n</div>\n\n\n",
                styles: [".inner-content{padding:0!important;background-color:#fefefe}.pd-history-header{display:flex;margin-top:16px;padding:0 16px;align-items:center}.pd-history-header>div:first-child{flex:3}.pd-history-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}.pd-history-header>div:nth-child(2){flex:1;text-align:right}.pd-history-header>div:nth-child(2) ion-icon{font-size:2em}.pd-history-main{padding:8px;margin-top:20px;border-top:1px solid #eee;overflow:auto}.pd-history-main>p{text-align:center}.pd-history-brand{text-align:center;margin:3vh 0}.pd-history-brand>img{width:50%}.pd-history-main-item-footer{text-align:center}.ownerSince{color:#999;text-align:center;font-weight:700;margin-bottom:30px}.date{color:#999;font-family:Inter-Regular;font-size:.9em}"]
            }] }
];
/** @nocollapse */
ProductInfoTransparencyComponent.ctorParameters = () => [
    { type: ModalController },
    { type: TranslateService },
    { type: HttpClient },
    { type: DisplayMapperService }
];
ProductInfoTransparencyComponent.propDecorators = {
    jsonUrl: [{ type: Input, args: ['jsonUrl',] }],
    logScreen: [{ type: Input }],
    onClickViewMore: [{ type: Input }],
    certificate: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductInfoTransparencyComponent.prototype.jsonUrl;
    /** @type {?} */
    ProductInfoTransparencyComponent.prototype.logScreen;
    /** @type {?} */
    ProductInfoTransparencyComponent.prototype.onClickViewMore;
    /** @type {?} */
    ProductInfoTransparencyComponent.prototype.certificate;
    /** @type {?} */
    ProductInfoTransparencyComponent.prototype.events;
    /** @type {?} */
    ProductInfoTransparencyComponent.prototype.brandLogoHeader;
    /**
     * @type {?}
     * @private
     */
    ProductInfoTransparencyComponent.prototype.modalCtrl;
    /** @type {?} */
    ProductInfoTransparencyComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    ProductInfoTransparencyComponent.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    ProductInfoTransparencyComponent.prototype.displayMapperService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LabelModalComponent {
    /**
     * @param {?} modalCtrl
     */
    constructor(modalCtrl) {
        this.modalCtrl = modalCtrl;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.label = this.labelOverride || this.label;
        });
    }
    /**
     * @return {?}
     */
    onClickClose() {
        this.modalCtrl.dismiss();
    }
}
LabelModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-label-modal',
                template: "<div id=\"labelModal\" class=\"inner-content\">\n\n    <div class=\"pd-cert-main\">\n        <ion-icon class=\"closeModal\" name=\"close\" (click)=\"onClickClose()\"></ion-icon>\n\n        <div *ngIf=\"label\">\n            <img *ngIf=\"label.icon\" [src]=\"label.icon\" alt=\"\">\n\n            <div [innerHTML]=\"(label.description | translate) | safeHtml\"></div>\n        </div>\n\n    </div>\n\n</div>\n\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["#labelModal .inner-content{padding:0!important}#labelModal .pd-label-header{display:flex;margin-top:16px;padding:0 16px;align-items:center}#labelModal .pd-label-header>div:first-child{flex:3}#labelModal .pd-label-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.4em;margin:0}#labelModal .pd-label-header>div:nth-child(2){flex:1;text-align:right}#labelModal .pd-label-header>div:nth-child(2) ion-icon{font-size:2em}#labelModal .pd-cert-header{display:flex;margin:16px 0;align-items:center;padding:0 16px}#labelModal .pd-cert-header>div:first-child{flex:3}#labelModal .pd-cert-header>div:first-child>p{color:#202224;font-family:Inter-Bold;font-size:1.2em;margin:0}#labelModal .pd-cert-header>div:nth-child(2){flex:1;text-align:right}#labelModal .pd-cert-header>div:nth-child(2) ion-icon{font-size:1.6em}#labelModal .pd-cert-main{padding:8px;display:flex;background-size:cover;background-repeat:no-repeat;background-position:top center;font-family:Inter-Bold;height:70vh;overflow:auto;width:100%}#labelModal .pd-cert-main img{display:block;margin:0 auto}#labelModal .center{text-align:center}#labelModal .closeModal{font-size:2em;position:absolute;top:5px;right:5px}"]
            }] }
];
/** @nocollapse */
LabelModalComponent.ctorParameters = () => [
    { type: ModalController }
];
LabelModalComponent.propDecorators = {
    labelTitle: [{ type: Input }],
    labelOverride: [{ type: Input }],
    labelName: [{ type: Input }],
    label: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    LabelModalComponent.prototype.labelTitle;
    /** @type {?} */
    LabelModalComponent.prototype.labelOverride;
    /** @type {?} */
    LabelModalComponent.prototype.labelName;
    /** @type {?} */
    LabelModalComponent.prototype.label;
    /**
     * @type {?}
     * @private
     */
    LabelModalComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BackUpWarnModalComponent {
    /**
     * @param {?} modalCtrl
     */
    constructor(modalCtrl) {
        this.modalCtrl = modalCtrl;
        this.onClickBackup = (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            yield this.onClickClose();
            yield this.navigateToBackup();
        }));
        this.onClickClose = (/**
         * @return {?}
         */
        () => {
            return this.modalCtrl.dismiss();
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.logScreen('BackUpWarnModal');
    }
}
BackUpWarnModalComponent.decorators = [
    { type: Component, args: [{
                template: "<lib-custom-theme-wrapper>\n  <div class=\"congrat_container\" data-e2e=\"backup_warn_modal\">\n    <div class=\"mdl-header congrat_txt\" ion-padding-top>\n      {{'BackupWarnModal.title' | translate}}\n    </div>\n\n    <div class=\"icon\">\n      <img src=\"{{'assets/icon/ic_upload.svg' | imageSrc}}\">\n    </div>\n\n    <div class=\"congrat_description\">\n      <div class=\"mdl-text\">\n        {{'BackupWarnModal.backupKO' | translate}}\n      </div>\n      <div class=\"mdl-text\">\n        {{'BackupWarnModal.shouldBackup' | translate}}\n      </div>\n    </div>\n\n    <ion-button color=\"primary\" expand=\"full\" (click)=\"onClickBackup()\" data-e2e=\"backup_now\">\n      {{'BackupWarnModal.backupCurrentWallet' | translate}}\n    </ion-button>\n    <ion-button fill=\"clear\" color=\"primary\" expand=\"full\" (click)=\"onClickClose()\" data-e2e=\"backup_later\">\n      {{'BackupWarnModal.later' | translate}}\n    </ion-button>\n  </div>\n</lib-custom-theme-wrapper>\n",
                styles: [".congrat_container{display:flex;flex-direction:column;align-items:center;padding-top:15px;padding-bottom:20px}.congrat_container .congrat_img{height:auto;width:100%}.congrat_container .congrat_description{margin-top:20px;margin-bottom:30px}.congrat_container .congrat_description>div{padding-top:12px}.congrat_container .icon{padding-top:20px}.congrat_container .mdl-text{font-family:var(--arainee-font-text)}.congrat_container .congrat_txt,.congrat_container ion-button{font-family:var(--arainee-font-title)}"]
            }] }
];
/** @nocollapse */
BackUpWarnModalComponent.ctorParameters = () => [
    { type: ModalController }
];
BackUpWarnModalComponent.propDecorators = {
    navigateToBackup: [{ type: Input }],
    logScreen: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    BackUpWarnModalComponent.prototype.navigateToBackup;
    /** @type {?} */
    BackUpWarnModalComponent.prototype.logScreen;
    /** @type {?} */
    BackUpWarnModalComponent.prototype.onClickBackup;
    /** @type {?} */
    BackUpWarnModalComponent.prototype.onClickClose;
    /**
     * @type {?}
     * @private
     */
    BackUpWarnModalComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} http
 * @return {?}
 */
function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
/** @type {?} */
const components$1 = [
    ProductInfoComponent,
    ProdPopoverComponent,
    ProductInfoResellComponent,
    ProductInfoCertComponent,
    ProductInfoHistoryComponent,
    ProductCertVerifiedComponent,
    ProdPopoverComponent,
    ProductInfoPGeneveComponent,
    ProductInfoSwissMadeComponent,
    BackUpWarnModalComponent,
    CongratOnClaimModalComponent,
    ClaimSwiperComponent,
    ProductInfoYoutubeComponent,
    ProductViewComponent,
    QrCodeComponent,
    DeclareLostComponent,
    EventsListComponent,
    ProductInfoTransparencyComponent,
    ProductInfoTransparencyItemsComponent,
    TransferCertComponent,
    LabelModalComponent,
    TransparencyItemModalComponent,
    ModelViewerComponent
];
class ProductViewModule {
}
ProductViewModule.decorators = [
    { type: NgModule, args: [{
                providers: [PhotoViewer],
                declarations: components$1,
                imports: [
                    CommonModule,
                    IonicModule,
                    TranslateModule,
                    MomentModule,
                    FormsModule,
                    PipeModule,
                    CommonComponentsModule,
                    DirectivesModule,
                    ReactiveFormsModule
                ],
                exports: components$1,
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                entryComponents: components$1
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BackCertComponent, BackConfirmComponent, BackUpWarnModalComponent, BackupItemComponent, BackupPopoverComponent, BrandListItemComponent, CertificateCardComponent, CertificateCardModalComponent, CheckIconComponent, ClaimSwiperComponent, CommonComponentsModule, CongratOnClaimModalComponent, CustomizableButtonComponent, DeclareLostComponent, DisplayMapperService, Events, EventsListComponent, ImageProxyPipe, ImageRatioFullWidthDirective, ImageSourcePipe, JazziconComponent, LabelModalComponent, LoaderComponent, LoaderService, PipeModule, ProdPopoverComponent, ProductCertVerifiedComponent, ProductInfoCertComponent, ProductInfoComponent, ProductInfoHistoryComponent, ProductInfoPGeneveComponent, ProductInfoResellComponent, ProductInfoSwissMadeComponent, ProductInfoTransparencyComponent, ProductInfoTransparencyItemsComponent, ProductInfoYoutubeComponent, ProductViewComponent, ProductViewModule, QrCodeComponent, SafeHtmlPipe, SafePipe, StyleService, TitleIconComponent, ToasterService, TransferCertComponent, TranslationService, TransparencyItemModalComponent, UnavailableActionModalComponent, WalletActionButtonsComponent, backupTypeEnum, brandCompanyName, brandDescription, brandDisplayMapper, brandExternalContent, brandIdentity, brandImageLogo, brandName, brandSocialmedia, certificateDisplayMapper, mapperChecker, mockFactoryV2, mockIdentity, CommonService as ɵa, WebWalletService as ɵb, CustomizableModalWrapperComponent as ɵc, LoadingSpinnerComponent as ɵd, IconComponent as ɵe, ImageSourceService as ɵf, CustomThemeWrapperComponent as ɵg, RequestOwnershipFailModalComponent as ɵh, RequestOwnershipSuccessModalComponent as ɵi, InterceptorAbstractService as ɵj, DirectivesModule as ɵk, ModelViewerComponent as ɵl };
//# sourceMappingURL=arianeeprivate-wallet-shared-components.js.map
